var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoriArchStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "801px",
    height: "1057px",
    viewBox: "0 0 801 1057",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dori_arch_stack_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.22070601,2.18381522 C4.07238145,1.43340063 3.4114647,0.870045906 2.6174921,0.870045906 C1.98711275,0.870045906 1.43962065,1.22676473 1.16696523,1.74879227 C0.510410959,1.81839594 0,2.37305021 0,3.04516067 C0,3.76512366 0.586754478,4.35022953 1.30874605,4.35022953 L4.14436249,4.35022953 C4.74638567,4.35022953 5.23498419,3.86300382 5.23498419,3.26267215 C5.23498419,2.68844185 4.78782929,2.22296729 4.22070601,2.18381522 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.872497366,1.74009181 L6.10748156,1.74009181 L6.10748156,1.16006121 L0.872497366,1.16006121 C0.552581665,1.16006121 0.290832455,1.42107498 0.290832455,1.74009181 L0.290832455,5.22027543 C0.290832455,5.53929227 0.552581665,5.80030604 0.872497366,5.80030604 L2.03582719,5.80030604 L2.03582719,5.22027543 L0.872497366,5.22027543 L0.872497366,1.74009181 Z M3.78082192,3.48018362 L2.6174921,3.48018362 L2.6174921,3.99641086 C2.4400843,4.15591928 2.32665964,4.38213121 2.32665964,4.64024483 C2.32665964,4.89835845 2.4400843,5.12457038 2.6174921,5.2840788 L2.6174921,5.80030604 L3.78082192,5.80030604 L3.78082192,5.2840788 C3.95822972,5.12457038 4.07165437,4.8954583 4.07165437,4.64024483 C4.07165437,4.38503136 3.95822972,4.15591928 3.78082192,3.99641086 L3.78082192,3.48018362 Z M3.19915701,5.07526778 C2.95776607,5.07526778 2.76290832,4.88095753 2.76290832,4.64024483 C2.76290832,4.39953213 2.95776607,4.20522188 3.19915701,4.20522188 C3.44054795,4.20522188 3.63540569,4.39953213 3.63540569,4.64024483 C3.63540569,4.88095753 3.44054795,5.07526778 3.19915701,5.07526778 Z M6.39831401,2.32012242 L4.65331928,2.32012242 C4.50790306,2.32012242 4.36248683,2.46513007 4.36248683,2.61013772 L4.36248683,5.51029074 C4.36248683,5.65529839 4.50790306,5.80030604 4.65331928,5.80030604 L6.39831401,5.80030604 C6.54373024,5.80030604 6.68914647,5.65529839 6.68914647,5.51029074 L6.68914647,2.61013772 C6.68914647,2.46513007 6.54373024,2.32012242 6.39831401,2.32012242 Z M6.10748156,5.22027543 L4.94415174,5.22027543 L4.94415174,2.90015302 L6.10748156,2.90015302 L6.10748156,5.22027543 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18071654,0.725038255 L2.18124341,3.9877104 L6.18018967,3.9877104 L4.18071654,0.725038255 Z M4.18071654,2.1171117 L4.88234984,3.26267215 L3.47544784,3.26267215 L4.18071654,2.1171117 Z M6.18018967,4.71274866 C5.27497366,4.71274866 4.54425711,5.4414121 4.54425711,6.34408473 C4.54425711,7.24675736 5.27497366,7.9754208 6.18018967,7.9754208 C7.08540569,7.9754208 7.81612223,7.24675736 7.81612223,6.34408473 C7.81612223,5.4414121 7.08540569,4.71274866 6.18018967,4.71274866 Z M6.18018967,7.25038255 C5.67850369,7.25038255 5.27133825,6.84436113 5.27133825,6.34408473 C5.27133825,5.84380833 5.67850369,5.43778691 6.18018967,5.43778691 C6.68187566,5.43778691 7.0890411,5.84380833 7.0890411,6.34408473 C7.0890411,6.84436113 6.68187566,7.25038255 6.18018967,7.25038255 Z M0.908851423,7.79416124 L3.81717597,7.79416124 L3.81717597,4.89400822 L0.908851423,4.89400822 L0.908851423,7.79416124 Z M1.63593256,5.61904647 L3.09009484,5.61904647 L3.09009484,7.06912298 L1.63593256,7.06912298 L1.63593256,5.61904647 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36248683,2.2439934 L6.18018967,3.87532947 L6.18018967,6.70660386 L5.45310854,6.70660386 L5.45310854,4.53148909 L3.27186512,4.53148909 L3.27186512,6.70660386 L2.54478398,6.70660386 L2.54478398,3.87532947 L4.36248683,2.2439934 L4.36248683,2.2439934 Z M4.36248683,1.26881695 L0.727081138,4.53148909 L1.81770285,4.53148909 L1.81770285,7.43164211 L3.99894626,7.43164211 L3.99894626,5.25652735 L4.7260274,5.25652735 L4.7260274,7.43164211 L6.90727081,7.43164211 L6.90727081,4.53148909 L7.99789252,4.53148909 L4.36248683,1.26881695 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98103267,0.495442807 C1.60975764,0.495442807 0.496838778,1.6052347 0.496838778,2.97265684 C0.496838778,4.34007899 1.60975764,5.44987088 2.98103267,5.44987088 C4.35230769,5.44987088 5.46522655,4.34007899 5.46522655,2.97265684 C5.46522655,1.6052347 4.35230769,0.495442807 2.98103267,0.495442807 Z M1.75632508,4.52834726 C1.86314542,4.305398 2.51400421,4.08740316 2.98103267,4.08740316 C3.44806112,4.08740316 4.10140411,4.305398 4.20574025,4.52834726 C3.86788988,4.79588638 3.44309273,4.95442807 2.98103267,4.95442807 C2.5189726,4.95442807 2.09417545,4.79588638 1.75632508,4.52834726 Z M4.56097998,4.16915122 C4.20574025,3.73811598 3.34372497,3.59196035 2.98103267,3.59196035 C2.61834036,3.59196035 1.75632508,3.73811598 1.40108535,4.16915122 C1.14769758,3.83720454 0.993677555,3.4235098 0.993677555,2.97265684 C0.993677555,1.88020545 1.88550316,0.990885615 2.98103267,0.990885615 C4.07656217,0.990885615 4.96838778,1.88020545 4.96838778,2.97265684 C4.96838778,3.4235098 4.81436776,3.83720454 4.56097998,4.16915122 L4.56097998,4.16915122 Z M2.98103267,1.48632842 C2.49909905,1.48632842 2.11156481,1.87277381 2.11156481,2.35335334 C2.11156481,2.83393286 2.49909905,3.22037825 2.98103267,3.22037825 C3.46296628,3.22037825 3.85050053,2.83393286 3.85050053,2.35335334 C3.85050053,1.87277381 3.46296628,1.48632842 2.98103267,1.48632842 Z M2.98103267,2.72493544 C2.77484457,2.72493544 2.60840358,2.5589621 2.60840358,2.35335334 C2.60840358,2.14774457 2.77484457,1.98177123 2.98103267,1.98177123 C3.18722076,1.98177123 3.35366175,2.14774457 3.35366175,2.35335334 C3.35366175,2.5589621 3.18722076,2.72493544 2.98103267,2.72493544 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.9752854%",
    cy: "49.9992083%",
    fx: "49.9752854%",
    fy: "49.9992083%",
    r: "50.5420579%",
    gradientTransform: "translate(0.499753,0.499992),scale(1.000000,0.895566),translate(-0.499753,-0.499992)",
    id: "radialGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB1414",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1108",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "57.542089%",
    cy: "49.9992083%",
    fx: "57.542089%",
    fy: "49.9992083%",
    r: "42.9752543%",
    gradientTransform: "translate(0.575421,0.499992),scale(1.000000,0.897946),translate(-0.575421,-0.499992)",
    id: "radialGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1108",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-0.00543129941%",
    cy: "95.334231%",
    fx: "-0.00543129941%",
    fy: "95.334231%",
    r: "50.0002959%",
    gradientTransform: "translate(-0.000054,0.953342),scale(1.000000,0.897946),translate(0.000054,-0.953342)",
    id: "radialGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    stopOpacity: 0.34513,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6",
    stopOpacity: 0.08407,
    offset: "66.861%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949",
    stopOpacity: 0.04425,
    offset: "76.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    stopOpacity: 0.0885,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5398773,0.40960452 C1.37153374,0.40960452 0.423312883,1.32711864 0.423312883,2.45762712 C0.423312883,3.58813559 1.37153374,4.50564972 2.5398773,4.50564972 C3.70822086,4.50564972 4.65644172,3.58813559 4.65644172,2.45762712 C4.65644172,1.32711864 3.70822086,0.40960452 2.5398773,0.40960452 Z M2.11656442,3.48163842 L1.05828221,2.45762712 L1.35671779,2.16885593 L2.11656442,2.90204802 L3.72303681,1.34759887 L4.02147239,1.63841808 L2.11656442,3.48163842 Z",
    id: "path-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08806748,1.63841808 L2.5398773,2.16885593 L1.99168712,1.63841808 L1.69325153,1.92718927 L2.24144172,2.45762712 L1.69325153,2.98806497 L1.99168712,3.27683616 L2.5398773,2.74639831 L3.08806748,3.27683616 L3.38650307,2.98806497 L2.83831288,2.45762712 L3.38650307,1.92718927 L3.08806748,1.63841808 Z M2.5398773,0.40960452 C1.36941718,0.40960452 0.423312883,1.32507062 0.423312883,2.45762712 C0.423312883,3.59018362 1.36941718,4.50564972 2.5398773,4.50564972 C3.71033742,4.50564972 4.65644172,3.59018362 4.65644172,2.45762712 C4.65644172,1.32507062 3.71033742,0.40960452 2.5398773,0.40960452 Z M2.5398773,4.0960452 C1.60647239,4.0960452 0.846625767,3.36080508 0.846625767,2.45762712 C0.846625767,1.55444915 1.60647239,0.81920904 2.5398773,0.81920904 C3.47328221,0.81920904 4.23312883,1.55444915 4.23312883,2.45762712 C4.23312883,3.36080508 3.47328221,4.0960452 2.5398773,4.0960452 Z",
    id: "path-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6837423,2.39618644 L4.12730061,2.39618644 C3.21929448,2.39618644 2.47638037,3.11504237 2.47638037,3.99364407 L2.47638037,15.1758475 C2.47638037,16.0544492 3.21929448,16.7733051 4.12730061,16.7733051 L15.6837423,16.7733051 C16.5917485,16.7733051 17.3346626,16.0544492 17.3346626,15.1758475 L17.3346626,3.99364407 C17.3346626,3.11504237 16.5917485,2.39618644 15.6837423,2.39618644 Z M15.6837423,15.1758475 L4.12730061,15.1758475 L4.12730061,11.5176695 L4.94450613,12.308411 L8.24634663,9.11349576 L11.5481871,12.308411 L14.8500276,9.12148305 L15.6837423,9.92819915 L15.6837423,15.1758475 Z M15.6837423,7.65980932 L14.8500276,6.85309322 L11.5481871,10.0559958 L8.24634663,6.86108051 L4.94450613,10.0559958 L4.12730061,9.25726695 L4.12730061,3.99364407 L15.6837423,3.99364407 L15.6837423,7.65980932 Z",
    id: "path-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08806748,1.63841808 L2.5398773,2.16885593 L1.99168712,1.63841808 L1.69325153,1.92718927 L2.24144172,2.45762712 L1.69325153,2.98806497 L1.99168712,3.27683616 L2.5398773,2.74639831 L3.08806748,3.27683616 L3.38650307,2.98806497 L2.83831288,2.45762712 L3.38650307,1.92718927 L3.08806748,1.63841808 Z M2.5398773,0.40960452 C1.36941718,0.40960452 0.423312883,1.32507062 0.423312883,2.45762712 C0.423312883,3.59018362 1.36941718,4.50564972 2.5398773,4.50564972 C3.71033742,4.50564972 4.65644172,3.59018362 4.65644172,2.45762712 C4.65644172,1.32507062 3.71033742,0.40960452 2.5398773,0.40960452 Z M2.5398773,4.0960452 C1.60647239,4.0960452 0.846625767,3.36080508 0.846625767,2.45762712 C0.846625767,1.55444915 1.60647239,0.81920904 2.5398773,0.81920904 C3.47328221,0.81920904 4.23312883,1.55444915 4.23312883,2.45762712 C4.23312883,3.36080508 3.47328221,4.0960452 2.5398773,4.0960452 Z",
    id: "path-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08806748,1.63841808 L2.5398773,2.16885593 L1.99168712,1.63841808 L1.69325153,1.92718927 L2.24144172,2.45762712 L1.69325153,2.98806497 L1.99168712,3.27683616 L2.5398773,2.74639831 L3.08806748,3.27683616 L3.38650307,2.98806497 L2.83831288,2.45762712 L3.38650307,1.92718927 L3.08806748,1.63841808 Z M2.5398773,0.40960452 C1.36941718,0.40960452 0.423312883,1.32507062 0.423312883,2.45762712 C0.423312883,3.59018362 1.36941718,4.50564972 2.5398773,4.50564972 C3.71033742,4.50564972 4.65644172,3.59018362 4.65644172,2.45762712 C4.65644172,1.32507062 3.71033742,0.40960452 2.5398773,0.40960452 Z M2.5398773,4.0960452 C1.60647239,4.0960452 0.846625767,3.36080508 0.846625767,2.45762712 C0.846625767,1.55444915 1.60647239,0.81920904 2.5398773,0.81920904 C3.47328221,0.81920904 4.23312883,1.55444915 4.23312883,2.45762712 C4.23312883,3.36080508 3.47328221,4.0960452 2.5398773,4.0960452 Z",
    id: "path-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08806748,1.63841808 L2.5398773,2.16885593 L1.99168712,1.63841808 L1.69325153,1.92718927 L2.24144172,2.45762712 L1.69325153,2.98806497 L1.99168712,3.27683616 L2.5398773,2.74639831 L3.08806748,3.27683616 L3.38650307,2.98806497 L2.83831288,2.45762712 L3.38650307,1.92718927 L3.08806748,1.63841808 Z M2.5398773,0.40960452 C1.36941718,0.40960452 0.423312883,1.32507062 0.423312883,2.45762712 C0.423312883,3.59018362 1.36941718,4.50564972 2.5398773,4.50564972 C3.71033742,4.50564972 4.65644172,3.59018362 4.65644172,2.45762712 C4.65644172,1.32507062 3.71033742,0.40960452 2.5398773,0.40960452 Z M2.5398773,4.0960452 C1.60647239,4.0960452 0.846625767,3.36080508 0.846625767,2.45762712 C0.846625767,1.55444915 1.60647239,0.81920904 2.5398773,0.81920904 C3.47328221,0.81920904 4.23312883,1.55444915 4.23312883,2.45762712 C4.23312883,3.36080508 3.47328221,4.0960452 2.5398773,4.0960452 Z",
    id: "path-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632216,2.39618644 L4.11374105,2.39618644 C3.20871802,2.39618644 2.46824463,3.11504237 2.46824463,3.99364407 L2.46824463,15.1758475 C2.46824463,16.0544492 3.20871802,16.7733051 4.11374105,16.7733051 L15.632216,16.7733051 C16.537239,16.7733051 17.2777124,16.0544492 17.2777124,15.1758475 L17.2777124,3.99364407 C17.2777124,3.11504237 16.537239,2.39618644 15.632216,2.39618644 Z M15.632216,15.1758475 L4.11374105,15.1758475 L4.11374105,11.5176695 L4.92826178,12.308411 L8.21925462,9.11349576 L11.5102475,12.308411 L14.8012403,9.12148305 L15.632216,9.92819915 L15.632216,15.1758475 Z M15.632216,7.65980932 L14.8012403,6.85309322 L11.5102475,10.0559958 L8.21925462,6.86108051 L4.92826178,10.0559958 L4.11374105,9.25726695 L4.11374105,3.99364407 L15.632216,3.99364407 L15.632216,7.65980932 Z",
    id: "path-58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08806748,1.63841808 L2.5398773,2.16885593 L1.99168712,1.63841808 L1.69325153,1.92718927 L2.24144172,2.45762712 L1.69325153,2.98806497 L1.99168712,3.27683616 L2.5398773,2.74639831 L3.08806748,3.27683616 L3.38650307,2.98806497 L2.83831288,2.45762712 L3.38650307,1.92718927 L3.08806748,1.63841808 Z M2.5398773,0.40960452 C1.36941718,0.40960452 0.423312883,1.32507062 0.423312883,2.45762712 C0.423312883,3.59018362 1.36941718,4.50564972 2.5398773,4.50564972 C3.71033742,4.50564972 4.65644172,3.59018362 4.65644172,2.45762712 C4.65644172,1.32507062 3.71033742,0.40960452 2.5398773,0.40960452 Z M2.5398773,4.0960452 C1.60647239,4.0960452 0.846625767,3.36080508 0.846625767,2.45762712 C0.846625767,1.55444915 1.60647239,0.81920904 2.5398773,0.81920904 C3.47328221,0.81920904 4.23312883,1.55444915 4.23312883,2.45762712 C4.23312883,3.36080508 3.47328221,4.0960452 2.5398773,4.0960452 Z",
    id: "path-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22070601,2.20565338 C4.07238145,1.44773464 3.4114647,0.878746365 2.6174921,0.878746365 C1.98711275,0.878746365 1.43962065,1.23903237 1.16696523,1.76628019 C0.510410959,1.8365799 0,2.39678071 0,3.07561228 C0,3.80277489 0.586754478,4.39373182 1.30874605,4.39373182 L4.14436249,4.39373182 C4.74638567,4.39373182 5.23498419,3.90163386 5.23498419,3.29529887 C5.23498419,2.71532627 4.78782929,2.24519696 4.22070601,2.20565338 Z",
    id: "path-62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.872497366,1.75749273 L6.10748156,1.75749273 L6.10748156,1.17166182 L0.872497366,1.17166182 C0.552581665,1.17166182 0.290832455,1.43528573 0.290832455,1.75749273 L0.290832455,5.27247819 C0.290832455,5.59468519 0.552581665,5.8583091 0.872497366,5.8583091 L2.03582719,5.8583091 L2.03582719,5.27247819 L0.872497366,5.27247819 L0.872497366,1.75749273 Z M3.78082192,3.51498546 L2.6174921,3.51498546 L2.6174921,4.03637497 C2.4400843,4.19747847 2.32665964,4.42595252 2.32665964,4.68664728 C2.32665964,4.94734203 2.4400843,5.17581609 2.6174921,5.33691959 L2.6174921,5.8583091 L3.78082192,5.8583091 L3.78082192,5.33691959 C3.95822972,5.17581609 4.07165437,4.94441288 4.07165437,4.68664728 C4.07165437,4.42888168 3.95822972,4.19747847 3.78082192,4.03637497 L3.78082192,3.51498546 Z M3.19915701,5.12602046 C2.95776607,5.12602046 2.76290832,4.92976711 2.76290832,4.68664728 C2.76290832,4.44352745 2.95776607,4.2472741 3.19915701,4.2472741 C3.44054795,4.2472741 3.63540569,4.44352745 3.63540569,4.68664728 C3.63540569,4.92976711 3.44054795,5.12602046 3.19915701,5.12602046 Z M6.39831401,2.34332364 L4.65331928,2.34332364 C4.50790306,2.34332364 4.36248683,2.48978137 4.36248683,2.63623909 L4.36248683,5.56539364 C4.36248683,5.71185137 4.50790306,5.8583091 4.65331928,5.8583091 L6.39831401,5.8583091 C6.54373024,5.8583091 6.68914647,5.71185137 6.68914647,5.56539364 L6.68914647,2.63623909 C6.68914647,2.48978137 6.54373024,2.34332364 6.39831401,2.34332364 Z M6.10748156,5.27247819 L4.94415174,5.27247819 L4.94415174,2.92915455 L6.10748156,2.92915455 L6.10748156,5.27247819 Z",
    id: "path-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18071654,0.732288637 L2.18124341,4.02758751 L6.18018967,4.02758751 L4.18071654,0.732288637 Z M4.18071654,2.13828282 L4.88234984,3.29529887 L3.47544784,3.29529887 L4.18071654,2.13828282 Z M6.18018967,4.75987614 C5.27497366,4.75987614 4.54425711,5.49582622 4.54425711,6.40752558 C4.54425711,7.31922493 5.27497366,8.05517501 6.18018967,8.05517501 C7.08540569,8.05517501 7.81612223,7.31922493 7.81612223,6.40752558 C7.81612223,5.49582622 7.08540569,4.75987614 6.18018967,4.75987614 Z M6.18018967,7.32288637 C5.67850369,7.32288637 5.27133825,6.91280474 5.27133825,6.40752558 C5.27133825,5.90224642 5.67850369,5.49216478 6.18018967,5.49216478 C6.68187566,5.49216478 7.0890411,5.90224642 7.0890411,6.40752558 C7.0890411,6.91280474 6.68187566,7.32288637 6.18018967,7.32288637 Z M0.908851423,7.87210285 L3.81717597,7.87210285 L3.81717597,4.9429483 L0.908851423,4.9429483 L0.908851423,7.87210285 Z M1.63593256,5.67523694 L3.09009484,5.67523694 L3.09009484,7.13981421 L1.63593256,7.13981421 L1.63593256,5.67523694 Z",
    id: "path-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36248683,2.26643333 L6.18018967,3.91408277 L6.18018967,6.7736699 L5.45310854,6.7736699 L5.45310854,4.57680398 L3.27186512,4.57680398 L3.27186512,6.7736699 L2.54478398,6.7736699 L2.54478398,3.91408277 L4.36248683,2.26643333 L4.36248683,2.26643333 Z M4.36248683,1.28150512 L0.727081138,4.57680398 L1.81770285,4.57680398 L1.81770285,7.50595853 L3.99894626,7.50595853 L3.99894626,5.30909262 L4.7260274,5.30909262 L4.7260274,7.50595853 L6.90727081,7.50595853 L6.90727081,4.57680398 L7.99789252,4.57680398 L4.36248683,1.28150512 Z",
    id: "path-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98103267,0.500397236 C1.60975764,0.500397236 0.496838778,1.62128704 0.496838778,3.00238341 C0.496838778,4.38347978 1.60975764,5.50436959 2.98103267,5.50436959 C4.35230769,5.50436959 5.46522655,4.38347978 5.46522655,3.00238341 C5.46522655,1.62128704 4.35230769,0.500397236 2.98103267,0.500397236 Z M1.75632508,4.57363073 C1.86314542,4.34845198 2.51400421,4.12827719 2.98103267,4.12827719 C3.44806112,4.12827719 4.10140411,4.34845198 4.20574025,4.57363073 C3.86788988,4.84384524 3.44309273,5.00397236 2.98103267,5.00397236 C2.5189726,5.00397236 2.09417545,4.84384524 1.75632508,4.57363073 Z M4.56097998,4.21084274 C4.20574025,3.77549714 3.34372497,3.62787996 2.98103267,3.62787996 C2.61834036,3.62787996 1.75632508,3.77549714 1.40108535,4.21084274 C1.14769758,3.87557659 0.993677555,3.4577449 0.993677555,3.00238341 C0.993677555,1.89900751 1.88550316,1.00079447 2.98103267,1.00079447 C4.07656217,1.00079447 4.96838778,1.89900751 4.96838778,3.00238341 C4.96838778,3.4577449 4.81436776,3.87557659 4.56097998,4.21084274 L4.56097998,4.21084274 Z M2.98103267,1.50119171 C2.49909905,1.50119171 2.11156481,1.89150155 2.11156481,2.37688687 C2.11156481,2.86227219 2.49909905,3.25258203 2.98103267,3.25258203 C3.46296628,3.25258203 3.85050053,2.86227219 3.85050053,2.37688687 C3.85050053,1.89150155 3.46296628,1.50119171 2.98103267,1.50119171 Z M2.98103267,2.7521848 C2.77484457,2.7521848 2.60840358,2.58455172 2.60840358,2.37688687 C2.60840358,2.16922202 2.77484457,2.00158894 2.98103267,2.00158894 C3.18722076,2.00158894 3.35366175,2.16922202 3.35366175,2.37688687 C3.35366175,2.58455172 3.18722076,2.7521848 2.98103267,2.7521848 Z",
    id: "path-70"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.9752854%",
    cy: "49.9992083%",
    fx: "49.9752854%",
    fy: "49.9992083%",
    r: "50.5420579%",
    gradientTransform: "translate(0.499753,0.499992),scale(1.000000,0.886699),translate(-0.499753,-0.499992)",
    id: "radialGradient-72"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB1414",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1108",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "57.542089%",
    cy: "49.9992083%",
    fx: "57.542089%",
    fy: "49.9992083%",
    r: "42.9752543%",
    gradientTransform: "translate(0.575421,0.499992),scale(1.000000,0.889056),translate(-0.575421,-0.499992)",
    id: "radialGradient-73"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1108",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-0.00543129941%",
    cy: "95.334231%",
    fx: "-0.00543129941%",
    fy: "95.334231%",
    r: "50.0002959%",
    gradientTransform: "translate(-0.000054,0.953342),scale(1.000000,0.889056),translate(0.000054,-0.953342)",
    id: "radialGradient-74"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    stopOpacity: 0.34513,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6",
    stopOpacity: 0.08407,
    offset: "66.861%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949",
    stopOpacity: 0.04425,
    offset: "76.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e5668",
    stopOpacity: 0.0885,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8792688,13.7707983 C19.920189,13.4313025 19.9508792,13.0918067 19.9508792,12.7310924 C19.9508792,12.3703782 19.920189,12.0308824 19.8792688,11.6913866 L22.0378117,9.94086134 C22.2321829,9.78172269 22.2833332,9.49527311 22.1605724,9.26186975 L20.1145602,5.59107143 C20.0224896,5.42132353 19.8485786,5.32584034 19.6644375,5.32584034 C19.6030571,5.32584034 19.5416767,5.33644958 19.4905264,5.35766807 L16.9432412,6.41859244 C16.411278,5.99422269 15.8383945,5.64411765 15.2143608,5.37888655 L14.8256185,2.56743697 C14.7949283,2.31281513 14.580097,2.12184874 14.3243454,2.12184874 L10.2323209,2.12184874 C9.97656938,2.12184874 9.76173809,2.31281513 9.7310479,2.56743697 L9.34230557,5.37888655 C8.71827183,5.64411765 8.14538839,6.00483193 7.6134252,6.41859244 L5.06613993,5.35766807 C5.00475956,5.33644958 4.94337919,5.32584034 4.88199882,5.32584034 C4.70808778,5.32584034 4.53417674,5.42132353 4.44210619,5.59107143 L2.39609392,9.26186975 C2.26310312,9.49527311 2.32448349,9.78172269 2.51885465,9.94086134 L4.6773976,11.6913866 C4.63647735,12.0308824 4.60578717,12.3809874 4.60578717,12.7310924 C4.60578717,13.0811975 4.63647735,13.4313025 4.6773976,13.7707983 L2.51885465,15.5213235 C2.32448349,15.6804622 2.27333318,15.9669118 2.39609392,16.2003151 L4.44210619,19.8711134 C4.53417674,20.0408613 4.70808778,20.1363445 4.89222888,20.1363445 C4.95360925,20.1363445 5.01498962,20.1257353 5.06613993,20.1045168 L7.6134252,19.0435924 C8.14538839,19.4679622 8.71827183,19.8180672 9.34230557,20.0832983 L9.7310479,22.8947479 C9.76173809,23.1493697 9.97656938,23.3403361 10.2323209,23.3403361 L14.3243454,23.3403361 C14.580097,23.3403361 14.7949283,23.1493697 14.8256185,22.8947479 L15.2143608,20.0832983 C15.8383945,19.8180672 16.411278,19.4573529 16.9432412,19.0435924 L19.4905264,20.1045168 C19.5519068,20.1257353 19.6132872,20.1363445 19.6746675,20.1363445 C19.8485786,20.1363445 20.0224896,20.0408613 20.1145602,19.8711134 L22.1605724,16.2003151 C22.2833332,15.9669118 22.2321829,15.6804622 22.0378117,15.5213235 L19.8792688,13.7707983 Z M17.8537166,11.9566176 C17.8946369,12.2855042 17.9048669,12.5082983 17.9048669,12.7310924 C17.9048669,12.9538866 17.8844068,13.1872899 17.8537166,13.5055672 L17.7104958,14.7044118 L18.6209712,15.4470588 L19.7258178,16.3382353 L19.0097135,17.6219538 L17.7104958,17.0808824 L16.6465694,16.6352941 L15.7258639,17.3567227 C15.2859712,17.6962185 14.8665387,17.9508403 14.4471062,18.1311975 L13.3627197,18.587395 L13.1990387,19.7862395 L12.9944375,21.2184874 L11.5622289,21.2184874 L11.3678577,19.7862395 L11.2041767,18.587395 L10.1197902,18.1311975 C9.6798976,17.9402311 9.27069514,17.6962185 8.86149269,17.3779412 L7.93055711,16.6352941 L6.8461706,17.0914916 L5.54695281,17.632563 L4.83084852,16.3488445 L5.93569514,15.4576681 L6.8461706,14.715021 L6.70294974,13.5161765 C6.67225956,13.1872899 6.65179944,12.9432773 6.65179944,12.7310924 C6.65179944,12.5189076 6.67225956,12.274895 6.70294974,11.9566176 L6.8461706,10.7577731 L5.93569514,10.0151261 L4.83084852,9.12394958 L5.54695281,7.84023109 L6.8461706,8.38130252 L7.91009698,8.82689076 L8.8308025,8.10546218 C9.27069514,7.76596639 9.69012766,7.51134454 10.1095602,7.33098739 L11.1939467,6.87478992 L11.3576277,5.67594538 L11.5622289,4.24369748 L12.9842074,4.24369748 L13.1785786,5.67594538 L13.3422596,6.87478992 L14.4266461,7.33098739 C14.8665387,7.52195378 15.2757412,7.76596639 15.6849436,8.0842437 L16.6158792,8.82689076 L17.7002657,8.37069328 L18.9994835,7.82962185 L19.7155878,9.11334034 L18.6209712,10.0151261 L17.7104958,10.7577731 L17.8537166,11.9566176 Z M12.2783332,8.48739496 C10.0174896,8.48739496 8.18630864,10.3864496 8.18630864,12.7310924 C8.18630864,15.0757353 10.0174896,16.9747899 12.2783332,16.9747899 C14.5391767,16.9747899 16.3703577,15.0757353 16.3703577,12.7310924 C16.3703577,10.3864496 14.5391767,8.48739496 12.2783332,8.48739496 Z M12.2783332,14.8529412 C11.1530264,14.8529412 10.2323209,13.8981092 10.2323209,12.7310924 C10.2323209,11.5640756 11.1530264,10.6092437 12.2783332,10.6092437 C13.4036399,10.6092437 14.3243454,11.5640756 14.3243454,12.7310924 C14.3243454,13.8981092 13.4036399,14.8529412 12.2783332,14.8529412 Z",
    id: "path-75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3716791,2.44118697 L4.0451787,2.44118697 C3.15523939,2.44118697 2.42710722,3.17354307 2.42710722,4.06864496 L2.42710722,15.4608508 C2.42710722,16.3559527 3.15523939,17.0883088 4.0451787,17.0883088 L15.3716791,17.0883088 C16.2616184,17.0883088 16.9897505,16.3559527 16.9897505,15.4608508 L16.9897505,4.06864496 C16.9897505,3.17354307 16.2616184,2.44118697 15.3716791,2.44118697 Z M15.3716791,15.4608508 L4.0451787,15.4608508 L4.0451787,11.7339721 L4.84612408,12.5395638 L8.08226704,9.28464779 L11.31841,12.5395638 L14.554553,9.29278508 L15.3716791,10.1146514 L15.3716791,15.4608508 Z M15.3716791,7.80366103 L14.554553,6.98179475 L11.31841,10.244848 L8.08226704,6.98993204 L4.84612408,10.244848 L4.0451787,9.43111901 L4.0451787,4.06864496 L15.3716791,4.06864496 L15.3716791,7.80366103 Z",
    id: "path-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3716791,2.44118697 L4.0451787,2.44118697 C3.15523939,2.44118697 2.42710722,3.17354307 2.42710722,4.06864496 L2.42710722,15.4608508 C2.42710722,16.3559527 3.15523939,17.0883088 4.0451787,17.0883088 L15.3716791,17.0883088 C16.2616184,17.0883088 16.9897505,16.3559527 16.9897505,15.4608508 L16.9897505,4.06864496 C16.9897505,3.17354307 16.2616184,2.44118697 15.3716791,2.44118697 Z M15.3716791,15.4608508 L4.0451787,15.4608508 L4.0451787,11.7339721 L4.84612408,12.5395638 L8.08226704,9.28464779 L11.31841,12.5395638 L14.554553,9.29278508 L15.3716791,10.1146514 L15.3716791,15.4608508 Z M15.3716791,7.80366103 L14.554553,6.98179475 L11.31841,10.244848 L8.08226704,6.98993204 L4.84612408,10.244848 L4.0451787,9.43111901 L4.0451787,4.06864496 L15.3716791,4.06864496 L15.3716791,7.80366103 Z",
    id: "path-79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3716791,2.44118697 L4.0451787,2.44118697 C3.15523939,2.44118697 2.42710722,3.17354307 2.42710722,4.06864496 L2.42710722,15.4608508 C2.42710722,16.3559527 3.15523939,17.0883088 4.0451787,17.0883088 L15.3716791,17.0883088 C16.2616184,17.0883088 16.9897505,16.3559527 16.9897505,15.4608508 L16.9897505,4.06864496 C16.9897505,3.17354307 16.2616184,2.44118697 15.3716791,2.44118697 Z M15.3716791,15.4608508 L4.0451787,15.4608508 L4.0451787,11.7339721 L4.84612408,12.5395638 L8.08226704,9.28464779 L11.31841,12.5395638 L14.554553,9.29278508 L15.3716791,10.1146514 L15.3716791,15.4608508 Z M15.3716791,7.80366103 L14.554553,6.98179475 L11.31841,10.244848 L8.08226704,6.98993204 L4.84612408,10.244848 L4.0451787,9.43111901 L4.0451787,4.06864496 L15.3716791,4.06864496 L15.3716791,7.80366103 Z",
    id: "path-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22070601,2.18381522 C4.07238145,1.43340063 3.4114647,0.870045906 2.6174921,0.870045906 C1.98711275,0.870045906 1.43962065,1.22676473 1.16696523,1.74879227 C0.510410959,1.81839594 0,2.37305021 0,3.04516067 C0,3.76512366 0.586754478,4.35022953 1.30874605,4.35022953 L4.14436249,4.35022953 C4.74638567,4.35022953 5.23498419,3.86300382 5.23498419,3.26267215 C5.23498419,2.68844185 4.78782929,2.22296729 4.22070601,2.18381522 Z",
    id: "path-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.872497366,1.74009181 L6.10748156,1.74009181 L6.10748156,1.16006121 L0.872497366,1.16006121 C0.552581665,1.16006121 0.290832455,1.42107498 0.290832455,1.74009181 L0.290832455,5.22027543 C0.290832455,5.53929227 0.552581665,5.80030604 0.872497366,5.80030604 L2.03582719,5.80030604 L2.03582719,5.22027543 L0.872497366,5.22027543 L0.872497366,1.74009181 Z M3.78082192,3.48018362 L2.6174921,3.48018362 L2.6174921,3.99641086 C2.4400843,4.15591928 2.32665964,4.38213121 2.32665964,4.64024483 C2.32665964,4.89835845 2.4400843,5.12457038 2.6174921,5.2840788 L2.6174921,5.80030604 L3.78082192,5.80030604 L3.78082192,5.2840788 C3.95822972,5.12457038 4.07165437,4.8954583 4.07165437,4.64024483 C4.07165437,4.38503136 3.95822972,4.15591928 3.78082192,3.99641086 L3.78082192,3.48018362 Z M3.19915701,5.07526778 C2.95776607,5.07526778 2.76290832,4.88095753 2.76290832,4.64024483 C2.76290832,4.39953213 2.95776607,4.20522188 3.19915701,4.20522188 C3.44054795,4.20522188 3.63540569,4.39953213 3.63540569,4.64024483 C3.63540569,4.88095753 3.44054795,5.07526778 3.19915701,5.07526778 Z M6.39831401,2.32012242 L4.65331928,2.32012242 C4.50790306,2.32012242 4.36248683,2.46513007 4.36248683,2.61013772 L4.36248683,5.51029074 C4.36248683,5.65529839 4.50790306,5.80030604 4.65331928,5.80030604 L6.39831401,5.80030604 C6.54373024,5.80030604 6.68914647,5.65529839 6.68914647,5.51029074 L6.68914647,2.61013772 C6.68914647,2.46513007 6.54373024,2.32012242 6.39831401,2.32012242 Z M6.10748156,5.22027543 L4.94415174,5.22027543 L4.94415174,2.90015302 L6.10748156,2.90015302 L6.10748156,5.22027543 Z",
    id: "path-85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18071654,0.725038255 L2.18124341,3.9877104 L6.18018967,3.9877104 L4.18071654,0.725038255 Z M4.18071654,2.1171117 L4.88234984,3.26267215 L3.47544784,3.26267215 L4.18071654,2.1171117 Z M6.18018967,4.71274866 C5.27497366,4.71274866 4.54425711,5.4414121 4.54425711,6.34408473 C4.54425711,7.24675736 5.27497366,7.9754208 6.18018967,7.9754208 C7.08540569,7.9754208 7.81612223,7.24675736 7.81612223,6.34408473 C7.81612223,5.4414121 7.08540569,4.71274866 6.18018967,4.71274866 Z M6.18018967,7.25038255 C5.67850369,7.25038255 5.27133825,6.84436113 5.27133825,6.34408473 C5.27133825,5.84380833 5.67850369,5.43778691 6.18018967,5.43778691 C6.68187566,5.43778691 7.0890411,5.84380833 7.0890411,6.34408473 C7.0890411,6.84436113 6.68187566,7.25038255 6.18018967,7.25038255 Z M0.908851423,7.79416124 L3.81717597,7.79416124 L3.81717597,4.89400822 L0.908851423,4.89400822 L0.908851423,7.79416124 Z M1.63593256,5.61904647 L3.09009484,5.61904647 L3.09009484,7.06912298 L1.63593256,7.06912298 L1.63593256,5.61904647 Z",
    id: "path-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36248683,2.2439934 L6.18018967,3.87532947 L6.18018967,6.70660386 L5.45310854,6.70660386 L5.45310854,4.53148909 L3.27186512,4.53148909 L3.27186512,6.70660386 L2.54478398,6.70660386 L2.54478398,3.87532947 L4.36248683,2.2439934 L4.36248683,2.2439934 Z M4.36248683,1.26881695 L0.727081138,4.53148909 L1.81770285,4.53148909 L1.81770285,7.43164211 L3.99894626,7.43164211 L3.99894626,5.25652735 L4.7260274,5.25652735 L4.7260274,7.43164211 L6.90727081,7.43164211 L6.90727081,4.53148909 L7.99789252,4.53148909 L4.36248683,1.26881695 Z",
    id: "path-89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98103267,0.495442807 C1.60975764,0.495442807 0.496838778,1.6052347 0.496838778,2.97265684 C0.496838778,4.34007899 1.60975764,5.44987088 2.98103267,5.44987088 C4.35230769,5.44987088 5.46522655,4.34007899 5.46522655,2.97265684 C5.46522655,1.6052347 4.35230769,0.495442807 2.98103267,0.495442807 Z M1.75632508,4.52834726 C1.86314542,4.305398 2.51400421,4.08740316 2.98103267,4.08740316 C3.44806112,4.08740316 4.10140411,4.305398 4.20574025,4.52834726 C3.86788988,4.79588638 3.44309273,4.95442807 2.98103267,4.95442807 C2.5189726,4.95442807 2.09417545,4.79588638 1.75632508,4.52834726 Z M4.56097998,4.16915122 C4.20574025,3.73811598 3.34372497,3.59196035 2.98103267,3.59196035 C2.61834036,3.59196035 1.75632508,3.73811598 1.40108535,4.16915122 C1.14769758,3.83720454 0.993677555,3.4235098 0.993677555,2.97265684 C0.993677555,1.88020545 1.88550316,0.990885615 2.98103267,0.990885615 C4.07656217,0.990885615 4.96838778,1.88020545 4.96838778,2.97265684 C4.96838778,3.4235098 4.81436776,3.83720454 4.56097998,4.16915122 L4.56097998,4.16915122 Z M2.98103267,1.48632842 C2.49909905,1.48632842 2.11156481,1.87277381 2.11156481,2.35335334 C2.11156481,2.83393286 2.49909905,3.22037825 2.98103267,3.22037825 C3.46296628,3.22037825 3.85050053,2.83393286 3.85050053,2.35335334 C3.85050053,1.87277381 3.46296628,1.48632842 2.98103267,1.48632842 Z M2.98103267,2.72493544 C2.77484457,2.72493544 2.60840358,2.5589621 2.60840358,2.35335334 C2.60840358,2.14774457 2.77484457,1.98177123 2.98103267,1.98177123 C3.18722076,1.98177123 3.35366175,2.14774457 3.35366175,2.35335334 C3.35366175,2.5589621 3.18722076,2.72493544 2.98103267,2.72493544 Z",
    id: "path-91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22070601,2.18381522 C4.07238145,1.43340063 3.4114647,0.870045906 2.6174921,0.870045906 C1.98711275,0.870045906 1.43962065,1.22676473 1.16696523,1.74879227 C0.510410959,1.81839594 0,2.37305021 0,3.04516067 C0,3.76512366 0.586754478,4.35022953 1.30874605,4.35022953 L4.14436249,4.35022953 C4.74638567,4.35022953 5.23498419,3.86300382 5.23498419,3.26267215 C5.23498419,2.68844185 4.78782929,2.22296729 4.22070601,2.18381522 Z",
    id: "path-93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.872497366,1.74009181 L6.10748156,1.74009181 L6.10748156,1.16006121 L0.872497366,1.16006121 C0.552581665,1.16006121 0.290832455,1.42107498 0.290832455,1.74009181 L0.290832455,5.22027543 C0.290832455,5.53929227 0.552581665,5.80030604 0.872497366,5.80030604 L2.03582719,5.80030604 L2.03582719,5.22027543 L0.872497366,5.22027543 L0.872497366,1.74009181 Z M3.78082192,3.48018362 L2.6174921,3.48018362 L2.6174921,3.99641086 C2.4400843,4.15591928 2.32665964,4.38213121 2.32665964,4.64024483 C2.32665964,4.89835845 2.4400843,5.12457038 2.6174921,5.2840788 L2.6174921,5.80030604 L3.78082192,5.80030604 L3.78082192,5.2840788 C3.95822972,5.12457038 4.07165437,4.8954583 4.07165437,4.64024483 C4.07165437,4.38503136 3.95822972,4.15591928 3.78082192,3.99641086 L3.78082192,3.48018362 Z M3.19915701,5.07526778 C2.95776607,5.07526778 2.76290832,4.88095753 2.76290832,4.64024483 C2.76290832,4.39953213 2.95776607,4.20522188 3.19915701,4.20522188 C3.44054795,4.20522188 3.63540569,4.39953213 3.63540569,4.64024483 C3.63540569,4.88095753 3.44054795,5.07526778 3.19915701,5.07526778 Z M6.39831401,2.32012242 L4.65331928,2.32012242 C4.50790306,2.32012242 4.36248683,2.46513007 4.36248683,2.61013772 L4.36248683,5.51029074 C4.36248683,5.65529839 4.50790306,5.80030604 4.65331928,5.80030604 L6.39831401,5.80030604 C6.54373024,5.80030604 6.68914647,5.65529839 6.68914647,5.51029074 L6.68914647,2.61013772 C6.68914647,2.46513007 6.54373024,2.32012242 6.39831401,2.32012242 Z M6.10748156,5.22027543 L4.94415174,5.22027543 L4.94415174,2.90015302 L6.10748156,2.90015302 L6.10748156,5.22027543 Z",
    id: "path-95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18071654,0.725038255 L2.18124341,3.9877104 L6.18018967,3.9877104 L4.18071654,0.725038255 Z M4.18071654,2.1171117 L4.88234984,3.26267215 L3.47544784,3.26267215 L4.18071654,2.1171117 Z M6.18018967,4.71274866 C5.27497366,4.71274866 4.54425711,5.4414121 4.54425711,6.34408473 C4.54425711,7.24675736 5.27497366,7.9754208 6.18018967,7.9754208 C7.08540569,7.9754208 7.81612223,7.24675736 7.81612223,6.34408473 C7.81612223,5.4414121 7.08540569,4.71274866 6.18018967,4.71274866 Z M6.18018967,7.25038255 C5.67850369,7.25038255 5.27133825,6.84436113 5.27133825,6.34408473 C5.27133825,5.84380833 5.67850369,5.43778691 6.18018967,5.43778691 C6.68187566,5.43778691 7.0890411,5.84380833 7.0890411,6.34408473 C7.0890411,6.84436113 6.68187566,7.25038255 6.18018967,7.25038255 Z M0.908851423,7.79416124 L3.81717597,7.79416124 L3.81717597,4.89400822 L0.908851423,4.89400822 L0.908851423,7.79416124 Z M1.63593256,5.61904647 L3.09009484,5.61904647 L3.09009484,7.06912298 L1.63593256,7.06912298 L1.63593256,5.61904647 Z",
    id: "path-97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36248683,2.2439934 L6.18018967,3.87532947 L6.18018967,6.70660386 L5.45310854,6.70660386 L5.45310854,4.53148909 L3.27186512,4.53148909 L3.27186512,6.70660386 L2.54478398,6.70660386 L2.54478398,3.87532947 L4.36248683,2.2439934 L4.36248683,2.2439934 Z M4.36248683,1.26881695 L0.727081138,4.53148909 L1.81770285,4.53148909 L1.81770285,7.43164211 L3.99894626,7.43164211 L3.99894626,5.25652735 L4.7260274,5.25652735 L4.7260274,7.43164211 L6.90727081,7.43164211 L6.90727081,4.53148909 L7.99789252,4.53148909 L4.36248683,1.26881695 Z",
    id: "path-99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98103267,0.495442807 C1.60975764,0.495442807 0.496838778,1.6052347 0.496838778,2.97265684 C0.496838778,4.34007899 1.60975764,5.44987088 2.98103267,5.44987088 C4.35230769,5.44987088 5.46522655,4.34007899 5.46522655,2.97265684 C5.46522655,1.6052347 4.35230769,0.495442807 2.98103267,0.495442807 Z M1.75632508,4.52834726 C1.86314542,4.305398 2.51400421,4.08740316 2.98103267,4.08740316 C3.44806112,4.08740316 4.10140411,4.305398 4.20574025,4.52834726 C3.86788988,4.79588638 3.44309273,4.95442807 2.98103267,4.95442807 C2.5189726,4.95442807 2.09417545,4.79588638 1.75632508,4.52834726 Z M4.56097998,4.16915122 C4.20574025,3.73811598 3.34372497,3.59196035 2.98103267,3.59196035 C2.61834036,3.59196035 1.75632508,3.73811598 1.40108535,4.16915122 C1.14769758,3.83720454 0.993677555,3.4235098 0.993677555,2.97265684 C0.993677555,1.88020545 1.88550316,0.990885615 2.98103267,0.990885615 C4.07656217,0.990885615 4.96838778,1.88020545 4.96838778,2.97265684 C4.96838778,3.4235098 4.81436776,3.83720454 4.56097998,4.16915122 L4.56097998,4.16915122 Z M2.98103267,1.48632842 C2.49909905,1.48632842 2.11156481,1.87277381 2.11156481,2.35335334 C2.11156481,2.83393286 2.49909905,3.22037825 2.98103267,3.22037825 C3.46296628,3.22037825 3.85050053,2.83393286 3.85050053,2.35335334 C3.85050053,1.87277381 3.46296628,1.48632842 2.98103267,1.48632842 Z M2.98103267,2.72493544 C2.77484457,2.72493544 2.60840358,2.5589621 2.60840358,2.35335334 C2.60840358,2.14774457 2.77484457,1.98177123 2.98103267,1.98177123 C3.18722076,1.98177123 3.35366175,2.14774457 3.35366175,2.35335334 C3.35366175,2.5589621 3.18722076,2.72493544 2.98103267,2.72493544 Z",
    id: "path-101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76899766,1.08202179 L1.78131517,1.08202179 C1.38942583,1.08202179 1.0687891,1.40662833 1.0687891,1.80336965 L1.0687891,6.85280468 C1.0687891,7.249546 1.38942583,7.57415254 1.78131517,7.57415254 L6.76899766,7.57415254 C7.160887,7.57415254 7.48152373,7.249546 7.48152373,6.85280468 L7.48152373,1.80336965 C7.48152373,1.40662833 7.160887,1.08202179 6.76899766,1.08202179 Z M6.76899766,6.85280468 L1.78131517,6.85280468 L1.78131517,5.20091808 L2.13401558,5.55798527 L3.55906772,4.11528955 L4.98411985,5.55798527 L6.40917199,4.11889629 L6.76899766,4.48317696 L6.76899766,6.85280468 Z M6.76899766,3.45886299 L6.40917199,3.09458232 L4.98411985,4.54088479 L3.55906772,3.09818906 L2.13401558,4.54088479 L1.78131517,4.18021086 L1.78131517,1.80336965 L6.76899766,1.80336965 L6.76899766,3.45886299 Z",
    id: "path-103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76899766,1.08202179 L1.78131517,1.08202179 C1.38942583,1.08202179 1.0687891,1.40662833 1.0687891,1.80336965 L1.0687891,6.85280468 C1.0687891,7.249546 1.38942583,7.57415254 1.78131517,7.57415254 L6.76899766,7.57415254 C7.160887,7.57415254 7.48152373,7.249546 7.48152373,6.85280468 L7.48152373,1.80336965 C7.48152373,1.40662833 7.160887,1.08202179 6.76899766,1.08202179 Z M6.76899766,6.85280468 L1.78131517,6.85280468 L1.78131517,5.20091808 L2.13401558,5.55798527 L3.55906772,4.11528955 L4.98411985,5.55798527 L6.40917199,4.11889629 L6.76899766,4.48317696 L6.76899766,6.85280468 Z M6.76899766,3.45886299 L6.40917199,3.09458232 L4.98411985,4.54088479 L3.55906772,3.09818906 L2.13401558,4.54088479 L1.78131517,4.18021086 L1.78131517,1.80336965 L6.76899766,1.80336965 L6.76899766,3.45886299 Z",
    id: "path-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76899766,1.08202179 L1.78131517,1.08202179 C1.38942583,1.08202179 1.0687891,1.40662833 1.0687891,1.80336965 L1.0687891,6.85280468 C1.0687891,7.249546 1.38942583,7.57415254 1.78131517,7.57415254 L6.76899766,7.57415254 C7.160887,7.57415254 7.48152373,7.249546 7.48152373,6.85280468 L7.48152373,1.80336965 C7.48152373,1.40662833 7.160887,1.08202179 6.76899766,1.08202179 Z M6.76899766,6.85280468 L1.78131517,6.85280468 L1.78131517,5.20091808 L2.13401558,5.55798527 L3.55906772,4.11528955 L4.98411985,5.55798527 L6.40917199,4.11889629 L6.76899766,4.48317696 L6.76899766,6.85280468 Z M6.76899766,3.45886299 L6.40917199,3.09458232 L4.98411985,4.54088479 L3.55906772,3.09818906 L2.13401558,4.54088479 L1.78131517,4.18021086 L1.78131517,1.80336965 L6.76899766,1.80336965 L6.76899766,3.45886299 Z",
    id: "path-107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76899766,1.08202179 L1.78131517,1.08202179 C1.38942583,1.08202179 1.0687891,1.40662833 1.0687891,1.80336965 L1.0687891,6.85280468 C1.0687891,7.249546 1.38942583,7.57415254 1.78131517,7.57415254 L6.76899766,7.57415254 C7.160887,7.57415254 7.48152373,7.249546 7.48152373,6.85280468 L7.48152373,1.80336965 C7.48152373,1.40662833 7.160887,1.08202179 6.76899766,1.08202179 Z M6.76899766,6.85280468 L1.78131517,6.85280468 L1.78131517,5.20091808 L2.13401558,5.55798527 L3.55906772,4.11528955 L4.98411985,5.55798527 L6.40917199,4.11889629 L6.76899766,4.48317696 L6.76899766,6.85280468 Z M6.76899766,3.45886299 L6.40917199,3.09458232 L4.98411985,4.54088479 L3.55906772,3.09818906 L2.13401558,4.54088479 L1.78131517,4.18021086 L1.78131517,1.80336965 L6.76899766,1.80336965 L6.76899766,3.45886299 Z",
    id: "path-109"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-2.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-7143.000000, -6172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_arch_stack_white",
    transform: "translate(7144.000000, 6172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(80.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#EDAF4B",
    x: 160,
    y: 125,
    width: 80,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#EDAF4B",
    x: 400,
    y: 125,
    width: 80,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 47.000000)",
    stroke: "#2e5668",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 80,
    cy: 80,
    r: 80
  })), /*#__PURE__*/React.createElement("text", {
    id: "Analytics",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.252,
    y: 27
  }, "Analytics")), /*#__PURE__*/React.createElement("text", {
    id: "Predictions",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 238.39,
    y: 27
  }, "Predictions")), /*#__PURE__*/React.createElement("text", {
    id: "Automation",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 474.064,
    y: 27
  }, "Automation")), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(240.000000, 47.000000)",
    stroke: "#2e5668",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 80,
    cy: 80,
    r: 80
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.761508,112.31616 L307.718508,112.31616 C307.995848,112.31616 308.257568,112.20286 308.448978,111.99973 C308.636478,111.80051 308.734138,111.52707 308.718508,111.25364 C308.624758,109.76924 308.288818,107.51534 308.234128,107.15594 C307.765378,103.92154 303.077928,102.53094 303.128628,102.43324 C303.905968,100.99574 304.405928,99.32774 304.429428,97.16374 C304.441148,96.17936 304.624738,93.18324 302.765328,91.23014 C301.687228,90.09734 300.152028,89.51924 298.202828,89.51924 C296.378628,89.51924 294.917628,90.07002 293.851228,91.15204 C291.941028,93.09734 292.007428,96.14424 292.011428,97.14814 C292.027058,99.42154 292.366898,100.86694 293.265328,102.50754 C293.308298,102.58566 288.437228,104.26144 288.198928,107.11694 L287.761428,111.23804 C287.741898,111.51538 287.835648,111.78882 288.023148,111.99585 C288.218458,112.19897 288.484088,112.31616 288.761428,112.31616 L288.761508,112.31616 Z M295.281008,92.55414 C295.964598,91.85883 296.921608,91.52294 298.202908,91.52294 C299.581808,91.52294 300.628708,91.89013 301.316208,92.61274 C302.585708,93.94474 302.421708,97.26894 302.421708,97.26894 C302.417798,97.3041 302.245928,100.89394 300.566208,102.58924 C299.921678,103.23768 299.148208,103.55408 298.199008,103.55408 C297.195108,103.55408 296.390408,103.22596 295.738108,102.55018 C294.101408,100.85878 294.011508,97.32748 294.011508,97.29238 C294.019318,97.29238 293.956818,93.90178 295.281008,92.55408 L295.281008,92.55414 Z M290.003708,108.27714 C290.187298,106.07404 293.839608,104.57404 294.800608,104.39044 C295.742018,105.15606 296.894408,105.55064 298.206808,105.55064 C299.492008,105.55064 300.620908,105.15611 301.562308,104.38654 C302.445118,104.5506 306.320108,105.96464 306.480308,108.29274 C306.507648,108.68336 306.609218,109.67944 306.656088,110.31224 L289.844088,110.31615 L290.003708,108.27714 Z M362.280708,131.71114 L321.444708,131.71114 C320.339208,131.71114 319.444708,132.60567 319.444708,133.71114 L319.444708,146.82414 C319.370488,146.72258 311.046308,141.63664 311.046308,141.63664 C310.737718,141.44914 310.350998,141.44523 310.034608,141.62101 C309.722108,141.79679 309.526798,142.13273 309.526798,142.4921 L309.526798,145.414 L300.436998,145.414 L300.436998,129.945 L317.483998,129.945 C318.589498,129.945 319.483998,129.05047 319.483998,127.945 L319.483998,84 C319.483998,82.8945 318.589468,82 317.483998,82 L279,82 C277.8945,82 277,82.89453 277,84 L277,127.945 C277,129.0505 277.89453,129.945 279,129.945 L296.437998,129.945 L296.437998,147.414 C296.437998,148.5195 297.332528,149.414 298.437998,149.414 L309.527998,149.414 L309.527998,152.3359 C309.527998,152.69528 309.723308,153.03121 310.035808,153.20699 C310.188148,153.29293 310.356118,153.3359 310.527998,153.3359 C310.707688,153.3359 310.887378,153.28903 311.047528,153.19137 C311.047528,153.19137 319.371728,148.10937 319.445928,148.00387 L319.445928,161.11687 C319.445928,162.22237 320.340458,163.11687 321.445928,163.11687 L334.238928,163.11687 L334.238928,165.31217 L332.770128,168.269174 C332.461538,168.890264 332.496688,169.624674 332.859978,170.210574 C333.223258,170.800414 333.867778,171.155884 334.559178,171.155884 L349.168178,171.155884 C349.859588,171.155884 350.504078,170.796504 350.867378,170.206664 C351.230658,169.616824 351.265818,168.882464 350.957218,168.261364 L349.488418,165.32386 L349.488418,163.11296 L362.281418,163.11296 C363.386918,163.11296 364.281418,162.21843 364.281418,161.11296 L364.281418,133.71096 C364.281418,132.60546 363.382978,131.71096 362.281418,131.71096 L362.280708,131.71114 Z M280.999708,125.94554 L280.999708,86.00054 L315.479708,86.00054 L315.479708,125.94554 L280.999708,125.94554 Z M311.522708,150.55854 L311.522708,144.26554 L316.714108,147.41004 L311.522708,150.55854 Z M337.784708,167.15654 C337.784708,167.15654 338.233928,166.08624 338.233928,165.77764 L338.233928,163.11354 L345.487828,163.11354 L345.487828,165.79714 C345.487828,166.10573 345.929238,167.15654 345.929238,167.15654 L337.784708,167.15654 Z M360.280708,159.11744 L323.444708,159.11744 L323.444708,135.71144 L360.280708,135.71144 L360.280708,159.11744 Z M327.944708,156.00808 C329.034508,156.00808 329.921308,155.12132 329.921308,154.03144 C329.921308,153.41816 329.640058,152.86734 329.198648,152.50414 L332.475948,147.05104 C333.093138,147.25026 333.835348,147.10182 334.327548,146.70338 L338.522848,149.72288 C338.448638,149.93382 338.405658,150.15647 338.405658,150.39085 C338.405658,151.48065 339.292378,152.36745 340.382258,152.36745 C341.472058,152.36745 342.358858,151.48073 342.358858,150.39085 C342.358858,149.84397 342.132298,149.34395 341.772918,148.98855 L345.999518,142.51195 C346.765138,142.79711 347.726118,142.52367 348.226118,141.89867 L354.015218,143.98067 C354.007408,144.04317 354.007408,144.10567 354.007408,144.17208 C354.007408,145.26188 354.894128,146.14868 355.984008,146.14868 C357.073888,146.14868 357.960608,145.26196 357.960608,144.17208 C357.960608,143.0822 357.073888,142.19548 355.984008,142.19548 C355.312128,142.19548 354.718408,142.53142 354.362908,143.04314 L348.636308,140.98454 C348.655838,140.87907 348.663658,140.7697 348.663658,140.66032 C348.663658,139.57052 347.776938,138.68372 346.687058,138.68372 C345.597178,138.68372 344.710458,139.57044 344.710458,140.66032 C344.710458,141.1447 344.886238,141.59391 345.179208,141.93762 L340.905808,148.48842 C340.284718,148.31654 339.562008,148.48842 339.089408,148.90248 L334.917508,145.90248 C335.007348,145.67592 335.058128,145.42982 335.058128,145.17592 C335.058128,144.08612 334.171408,143.19932 333.081528,143.19932 C331.991648,143.19932 331.104928,144.08604 331.104928,145.17592 C331.104928,145.69545 331.304148,146.16811 331.632268,146.51972 L328.284568,152.09002 C328.175188,152.07049 328.061908,152.06268 327.944728,152.06268 C326.854928,152.06268 325.968128,152.9494 325.968128,154.03928 C325.968128,155.12128 326.854848,156.00808 327.944728,156.00808 L327.944708,156.00808 Z M355.987708,143.19204 C356.526768,143.19204 356.964268,143.62954 356.964268,144.1686 C356.964268,144.70766 356.526768,145.14516 355.987708,145.14516 C355.448648,145.14516 355.011148,144.70766 355.011148,144.1686 C355.007248,143.62954 355.448648,143.19204 355.987708,143.19204 Z M346.690808,139.68034 C347.229868,139.68034 347.667368,140.11784 347.667368,140.6569 C347.667368,141.19596 347.229868,141.63346 346.690808,141.63346 C346.151748,141.63346 345.714248,141.19596 345.714248,140.6569 C345.710348,140.11784 346.151748,139.68034 346.690808,139.68034 Z M340.382208,149.41474 C340.921268,149.41474 341.358768,149.85224 341.358768,150.3913 C341.358768,150.93036 340.921268,151.36786 340.382208,151.36786 C339.843148,151.36786 339.405648,150.93036 339.405648,150.3913 C339.405648,149.85224 339.847058,149.41474 340.382208,149.41474 Z M333.077508,144.19204 C333.616568,144.19204 334.054068,144.62954 334.054068,145.1686 C334.054068,145.70766 333.616568,146.14516 333.077508,146.14516 C332.538448,146.14516 332.100948,145.70766 332.100948,145.1686 C332.100948,144.62954 332.542358,144.19204 333.077508,144.19204 Z M327.944708,153.05534 C328.483768,153.05534 328.921268,153.49284 328.921268,154.0319 C328.921268,154.57096 328.483768,155.00846 327.944708,155.00846 C327.405648,155.00846 326.968148,154.57096 326.968148,154.0319 C326.968148,153.49284 327.405648,153.05534 327.944708,153.05534 Z M313.132708,119.13334 C313.132708,119.41068 312.910048,119.63334 312.632708,119.63334 L284.241708,119.63334 C283.964368,119.63334 283.741708,119.41068 283.741708,119.13334 C283.741708,118.856 283.964368,118.63334 284.241708,118.63334 L312.632708,118.63334 C312.910048,118.63334 313.132708,118.856 313.132708,119.13334 Z M313.132708,122.60604 C313.132708,122.88338 312.910048,123.10604 312.632708,123.10604 L284.241708,123.10604 C283.964368,123.10604 283.741708,122.88338 283.741708,122.60604 C283.741708,122.3287 283.964368,122.10604 284.241708,122.10604 L312.632708,122.10604 C312.910048,122.10604 313.132708,122.3287 313.132708,122.60604 Z M313.132708,115.85994 C313.132708,116.13728 312.910048,116.35994 312.632708,116.35994 L284.241708,116.35994 C283.964368,116.35994 283.741708,116.13728 283.741708,115.85994 C283.741708,115.5826 283.964368,115.35994 284.241708,115.35994 L312.632708,115.35994 C312.910048,115.35994 313.132708,115.5826 313.132708,115.85994 Z",
    id: "Fill-1",
    fill: "#2e5668"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(39.000000, 83.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,39 C34.1515933,39 29,44.1511521 29,50.5 C29,56.8488479 34.1511517,62 40.5,62 C46.8488466,62 52,56.8488479 52,50.5 C52.0034518,44.1515937 46.8488466,39 40.5,39 Z M40.4999991,57.4 C36.6357521,57.4 33.599558,54.3638057 33.599558,50.4995584 C33.599558,46.6353111 36.6357521,43.5991167 40.4999991,43.5991167 C44.3642462,43.5991167 47.4004402,46.6353111 47.4004402,50.4995584 C47.4004402,54.3638057 44.4574297,57.4 40.4999991,57.4 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5,44 C59.2514628,44 55,48.2510285 55,53.5 C55,58.7489715 59.2510285,63 64.5,63 C69.7489715,63 74,58.6573414 74,53.5 C74,48.3426586 69.6573414,44 64.5,44 Z M64.5,58.4732127 C61.6942083,58.4732127 59.522879,56.3018833 59.522879,53.4960916 C59.522879,50.6902999 61.6942083,48.5189706 64.5,48.5189706 C67.3057917,48.5189706 69.477121,50.6902999 69.477121,53.4960916 C69.477121,56.3018833 67.2141616,58.4732127 64.5,58.4732127 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8185295,70.4974858 L19.4537439,71.592197 C19.1810078,72.320863 19.0889583,73.3266573 19.0889583,74.6026526 L19.0923708,78.0714831 C19.0923708,81.3556166 21.727656,84 25.0004892,84 L55.9117439,84 C59.1845771,84 61.8198623,81.3556157 61.8198623,78.0714831 L61.8198623,74.6060681 C61.8198623,73.511357 61.6391758,72.4166458 61.4550767,71.5956125 L61.3630272,71.0482569 L60.9982416,70.0459393 C59.361825,66.0331661 55.1787078,63.4776724 49.5433255,63.0227104 C48.9058038,62.9303431 48.2717207,63.1150778 47.8148332,63.6624334 C45.8136048,65.5781779 43.1783195,66.5804954 40.4509586,66.5804954 C37.7235976,66.5804954 35.0883123,65.5781779 33.1791596,63.6624334 C32.725737,63.2963882 32.0882153,63.0227104 31.3620827,63.0227104 C25.7267003,63.4776987 21.6352225,65.9407725 19.9988059,70.0459393 L19.8185295,70.4974858 Z M67.8200826,75.7897574 C66.5484779,75.7897574 65.5461182,76.7920723 65.5461182,78.0715707 C65.5461182,79.347566 66.5449868,80.3533867 67.8200826,80.3533867 L75.0918816,80.3533867 C78.3647147,80.3533867 81,77.7090024 81,74.4248715 C81,69.1325999 76.7282982,64.845711 71.4538002,64.845711 L70.5435162,64.845711 C69.9059945,64.845711 69.2719114,65.1193888 68.9070996,65.5743771 C67.6354949,66.942766 66.087663,67.5825152 64.1785103,67.5825152 C62.9069055,67.5825152 61.9045458,68.5848327 61.9045458,69.8643311 L61.9045458,70.5929972 L62.3579685,71.2327201 C62.7227541,71.7800757 63.4489129,72.1461471 64.1750454,72.1461471 C66.9944821,72.1461471 69.2649556,71.3251137 71.3582597,69.5017628 L71.4503092,69.4093955 L71.6309958,69.4093955 C74.3583567,69.5017628 76.4481698,71.6912114 76.4481698,74.4279893 C76.4481698,75.2490226 75.9026976,75.7963782 75.0844893,75.7963782 L67.8200826,75.7897574 Z M9.54619716,64.8426459 C4.36421393,64.8426459 0,69.1290969 0,74.4218064 C0,77.7059372 2.63528527,80.3503206 5.90811843,80.3503206 L13.1799147,80.3503206 C14.4515195,80.3503206 15.4538792,79.348003 15.4538792,78.0685046 C15.4538792,76.7925093 14.4550105,75.7866922 13.1799147,75.7866922 L5.90811843,75.7866922 C5.08991014,75.7866922 4.54443795,75.2393366 4.54443795,74.4183033 C4.54443795,71.6815254 6.6342484,69.4921031 9.36160937,69.3997095 L9.54229595,69.3997095 L9.63434547,69.4920768 C11.6355739,71.2265372 13.998123,72.1364611 16.8175597,72.1364611 C17.5437185,72.1364611 18.2733159,71.7704159 18.6346367,71.2230341 L19.0880594,70.5833112 L19.0914718,69.8614849 C19.0914718,68.5854896 18.0926031,67.579669 16.8175073,67.579669 C14.9083547,67.579669 13.4525985,66.939946 12.088918,65.4826403 C11.6354953,65.027652 11.0900493,64.8429173 10.4525014,64.8429173 L9.54619716,64.8426459 Z M56.0003548,79.4399588 L25.0891088,79.4399588 C24.2709005,79.4399588 23.7254283,78.8926032 23.7254283,78.0715698 L23.7254283,74.6061557 C23.7254283,70.8670603 26.0879775,68.4928507 30.6359064,67.764211 L30.816593,67.764211 L30.9972796,67.8565783 C33.8167163,70.0460006 37.1781341,71.2331054 40.5434706,71.2331054 C43.9083795,71.2331054 47.2697974,70.0460006 50.0896704,67.8565783 L50.270357,67.764211 L50.4510436,67.764211 C54.9954815,68.492877 57.3615217,70.8670603 57.3615217,74.6061557 L57.3649342,78.0715698 C57.3649342,78.8002359 56.7308249,79.4399588 56.0012537,79.4399588 L56.0003548,79.4399588 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,44 C12.2514628,44 8,48.2510285 8,53.5 C8,58.7489715 12.2510285,63 17.5,63 C22.7489715,63 27,58.6573414 27,53.5 C27,48.3426586 22.7489715,44 17.5,44 Z M17.5,58.4732127 C14.6942083,58.4732127 12.522879,56.3018833 12.522879,53.4960916 C12.522879,50.6902999 14.6942083,48.5189706 17.5,48.5189706 C20.3057917,48.5189706 22.477121,50.6902999 22.477121,53.4960916 C22.477121,56.3018833 20.3057917,58.4732127 17.5,58.4732127 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2598017,0.000434137694 C38.9961168,0.000434137694 38,0.994175319 38,2.26272566 L38,33.7377085 C38,35.0027857 38.9926475,36 40.2598017,36 L79.7401983,36 C81.0038832,36 82,35.0062588 82,33.7377085 C82,32.3810282 81.1868877,31.475417 79.9232028,31.475417 L77.3923636,31.475417 L77.3923636,22.8842661 C77.3923636,21.6191889 76.3997161,20.6219746 75.1325619,20.6219746 L73.3268022,20.6219746 C72.0631172,20.6219746 71.0670005,21.6157158 71.0670005,22.8842661 L71.0670005,31.475417 L65.4667166,31.475417 L65.4667166,25.8689628 C65.4667166,24.6038855 64.4740691,23.6066712 63.2069149,23.6066712 L61.4011551,23.6066712 C60.1374702,23.6066712 59.1413534,24.6004124 59.1413534,25.8689628 L59.1413534,31.475417 L53.5410696,31.475417 L53.5410696,28.3109873 C53.5410696,27.0459101 52.5484221,26.0486958 51.2812679,26.0486958 L49.4755081,26.0486958 C48.2118231,26.0486958 47.2157064,27.042437 47.2157064,28.3109873 L47.2157064,31.475417 L42.5165678,31.475417 L42.5165678,2.26229152 C42.608044,0.993828009 41.6153358,0 40.2601486,0 L40.2598017,0.000434137694 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4075972,15.3321216 C48.3206584,15.3321216 48.3206584,15.3321216 48.4075972,15.3321216 C47.0700432,15.3321216 46,16.3181657 46,17.5768903 C46,18.9230624 46.9797316,19.9091065 48.2303981,20 L48.3206841,20 C49.5679264,20 59.2881991,19.7307656 66.5114188,10.4859023 L67.4911504,15.601356 C67.7586612,16.6782936 68.6515053,17.4859968 69.7215485,17.4859968 C69.8987733,17.4859968 69.9890593,17.4859968 70.1662841,17.3951291 C71.4135265,17.1258947 72.2160589,15.9580636 71.9485481,14.7027851 L69.8987733,3.84553071 C69.6312625,2.59025222 68.4709076,1.782549 67.2236653,2.0517834 L56.5232331,4.20565865 C55.2759907,4.47489306 54.4734583,5.64272422 54.7409691,6.89800271 C55.0084799,8.15328121 56.1688347,8.96098442 57.4160771,8.69175002 L62.7662932,7.61481239 C56.8810555,15.0624822 49.1228141,15.3317166 48.4080253,15.3317166 L48.4075972,15.3321216 Z",
    id: "Fill-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy",
    transform: "translate(481.000000, 47.000000)",
    stroke: "#2e5668",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 80,
    cy: 80,
    r: 80
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(515.000000, 85.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2416,21.4109714 L46.0909091,21.4109714 C49.3054545,21.3995003 52.1799505,19.4189855 53.3043491,16.4406964 L57.5272727,19.5757839 C57.7938624,19.774591 58.1184128,19.8816485 58.4545455,19.8816485 C58.6940934,19.8816485 58.929774,19.8281198 59.1461376,19.721072 C59.6715921,19.4610822 60,18.9334683 60,18.3523647 L60,7.64661472 C59.9961327,3.42568339 56.5381818,0.00381719007 52.2727273,0 L39.9090909,0 C36.1884276,0.0076441678 33.0008844,2.63806984 32.3247418,6.25872356 C28.6658967,6.92779868 26.0077149,10.081982 26,13.7639065 L26,24.4696565 C26,25.0507992 26.3322752,25.5784034 26.8538624,25.8383638 C27.3793169,26.0983438 28.0052631,26.0409979 28.4727075,25.6930757 L34.2416,21.4109714 Z M39.9095855,3.05909612 L52.2732218,3.05909612 C54.8347695,3.05909612 56.9095855,5.11225499 56.9095855,7.64706495 L56.9095855,15.2936797 L53.2004945,12.5408984 C52.9339049,12.3420913 52.6093545,12.2350338 52.2732218,12.2350338 L39.9095855,12.2350338 C37.3480378,12.2350338 35.2732218,10.1818749 35.2732218,7.64706495 C35.2732218,5.11225499 37.3480378,3.05909612 39.9095855,3.05909612 Z M29.0909091,13.7648461 C29.0986339,11.7423226 30.4431942,9.96449083 32.4059462,9.39093355 C33.2211747,12.8433373 36.3274938,15.2864368 39.9090909,15.2940712 L50.4409309,15.2940712 C49.7879727,17.1216243 48.0493091,18.3450827 46.0905135,18.3527171 L33.7268771,18.3527171 C33.3907444,18.3527171 33.066194,18.4597746 32.7996044,18.6585817 L29.0905135,21.411363 L29.0909091,13.7648461 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "46.5 9 48 9 48 6 45 6 45 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "51 9 54 9 54 6 51 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "38 9 41 9 41 6 38 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3538672,35.3040601 C80.0233971,33.3714141 76.9584036,32.5975194 74.0011126,33.2002892 C69.2517657,34.2579983 65.9021579,38.5627001 66.0021815,43.4777373 C66.0060209,46.0364476 66.5944076,48.5602162 67.7211887,50.8466597 C68.3711055,52.1726536 68.7980171,53.5997894 68.9748304,55.0658488 C68.9748304,55.0852908 68.9825192,55.1047327 68.9863685,55.128067 C69.0478988,55.6335872 69.0786639,56.1468524 69.0786639,56.6602271 L69.0786639,59.4445156 C69.0786639,59.8567086 69.2401783,60.253352 69.5286025,60.5450308 C69.8170268,60.8367096 70.2092845,61 70.6169494,61 L81.3852336,61 C81.792869,61 82.1851267,60.8366798 82.4735805,60.5450308 C82.7620342,60.2533818 82.9235191,59.8567384 82.9235191,59.4445156 L82.9235191,56.6602271 C82.9235191,56.146932 82.9542842,55.6336768 83.0158145,55.128067 C83.0158145,55.1086251 83.0235033,55.0891831 83.0273428,55.0658488 C83.2080842,53.5997894 83.631107,52.1727531 84.2809845,50.8466597 C85.4077262,48.5601166 85.9961522,46.0364476 86,43.4777373 L86,43.112203 C86.0038411,40.090689 84.6655239,37.2247702 82.3543496,35.3037714 L82.3538672,35.3040601 Z M74.5895386,36.2528824 C76.631555,35.8251299 78.750558,36.3501021 80.3695416,37.6800182 C81.9846858,39.0098945 82.9230958,41.0047587 82.9230958,43.1124121 L82.9230958,43.4779464 C82.9192465,45.5544409 82.442392,47.599876 81.5309372,49.4547743 C81.1848321,50.1702834 80.8925585,50.9090869 80.6541264,51.6674519 L78.3082983,51.6674519 L78.3082983,47.0010883 C78.3082983,46.3322378 77.8852754,45.7373126 77.2546052,45.5233816 L73.8704421,44.3801598 L73.8704421,44.3840522 C73.7589197,44.3451583 73.6897007,44.2285067 73.7050783,44.1079627 C73.7243053,43.9874187 73.8242895,43.8940915 73.9435105,43.8901991 L79.846574,43.8901991 L79.846574,40.77929 L73.9435105,40.77929 C72.3130083,40.77929 70.9208497,41.9769651 70.6593708,43.6062851 C70.3978722,45.2317226 71.3438923,46.8144536 72.8936569,47.3354936 L75.231806,48.1209956 L75.231806,51.6674519 L71.3477219,51.6674519 C71.1131391,50.9091467 70.8208656,50.1703132 70.4747604,49.4547544 C69.5594957,47.5998561 69.0826018,45.554421 69.0787624,43.4779265 C68.9787782,40.0520441 71.286172,37.0266476 74.5896075,36.2528525 L74.5895386,36.2528824 Z M79.8464854,57.8888819 L72.1552054,57.8888819 L72.1552054,56.6600479 C72.1552054,56.0300913 72.1167416,55.4001546 72.0436831,54.7779728 L79.9580471,54.7779728 C79.8849787,55.4001546 79.8465247,56.0301012 79.8465247,56.6600479 L79.8464854,57.8888819 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "75 30 78 30 78 27 75 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "63 34 65 32 67 34 65 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "60 47 63 47 63 44 60 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "89 47 92 47 92 44 89 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    points: "86 34 88 32 90 34 88 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,32.9161789 L14.7953819,34 C16.37565,29.5719695 18.8282048,25.534939 22,22.1520854 L19.8605983,20 C16.4017938,23.6887373 13.725681,28.0896177 12,32.9160798 L12,32.9161789 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8141435,56 L11,56.9238224 C13.193663,64.1103446 17.4517497,70.4188754 23.1978363,75 L25,72.5595584 L25,72.5557054 C19.7337151,68.3600693 15.8301617,62.582472 13.8137653,56 L13.8141435,56 Z",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,70.7446861 L69.9160052,73 L69.9196791,73 C72.6981732,70.5734797 75.0876594,67.7264222 77,64.5556254 L74.5041474,63 C72.7460006,65.9066034 70.5511124,68.5191928 68.0001034,70.7446861 L68,70.7446861 Z",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6727147,25 L75,23.2095074 L75,23.2058274 C72.1367983,19.4631483 68.5504898,16.3308215 64.4536371,14 L63,16.5551037 L63,16.5587837 C66.7551743,18.6947819 70.0441585,21.5661206 72.6724328,25 L72.6727147,25 Z",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,51.4545032 L21,37.5455265 C21,37.1359723 20.842474,36.7418681 20.5612236,36.4520566 C20.2799732,36.162245 19.8974718,36 19.4999465,36 L1.5,36 C0.671249359,36 0,36.6916111 0,37.5454968 L0,51.4544735 C0,51.8640277 0.157497168,52.2581319 0.438747597,52.5479434 C0.719998025,52.837755 1.10249938,53 1.50002469,53 L19.4999753,53 C19.8974718,53 20.2799732,52.8377253 20.5612524,52.5479434 C20.8425316,52.2581615 21,51.8640574 21,51.4544735 L21,51.4545032 Z M3.00002057,39.0905287 L17.9999794,39.0905287 L17.9999794,41.0687646 L10.5,43.6420539 L3.00002057,41.0687646 L3.00002057,39.0905287 Z M3.00002057,49.9095009 L3.00002057,44.3264246 L10.0274893,46.7373997 C10.3349861,46.8455894 10.6687387,46.8455894 10.9762355,46.7373997 L17.9999602,44.3264246 L17.9999602,49.9095009 L3.00002057,49.9095009 Z",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5018895,51.000888 C39.5007476,50.9970302 33.8696201,53.9068732 30.4003641,58.8055002 C26.9315028,63.7040286 26.0565911,69.978344 28.0530908,75.6397515 C30.0495904,81.3014549 34.6670754,85.6414407 40.4411765,87.2792825 L40.4565888,87.2869912 C40.5683628,87.3178241 40.6839948,87.3409482 40.7957688,87.3717811 C41.316098,87.5066761 41.8441432,87.6223018 42.3837724,87.7186484 C42.6805536,87.7726054 42.9773348,87.8188527 43.2779741,87.8535434 C43.4861097,87.8805224 43.6903873,87.9036475 43.8946649,87.919064 C44.4304163,87.9691671 44.9739232,88 45.4980611,88 C46.0222089,88 46.5695245,87.9691671 47.1053153,87.919064 C47.313451,87.9036475 47.5177286,87.8805224 47.7220062,87.8535434 C48.0303516,87.8150028 48.3232847,87.7687535 48.6239141,87.7148004 C49.1558075,87.6223018 49.6799848,87.5066761 50.1965152,87.3717811 C50.3121472,87.3409482 50.4277792,87.3178241 50.5434013,87.2869912 L50.5588235,87.2792825 C56.3287804,85.6412434 60.9498176,81.3015536 62.9469092,75.6397515 C64.9434089,69.981896 64.0684972,63.7071859 60.5996359,58.8084602 C57.1307745,53.9099318 51.5033966,51 45.5020573,51 L45.5018895,51.000888 Z M42.4184353,78.7504669 L48.5853438,78.7504669 L48.5853438,84.5971676 C46.550264,85.0211219 44.4535151,85.0211219 42.4184353,84.5971676 L42.4184353,78.7504669 Z M44.7310753,68.7300323 C44.7310753,68.4178458 44.9199406,68.1365021 45.2051576,68.0170186 C45.4942327,67.8975449 45.8257065,67.9630586 46.0453965,68.1866043 C46.2689444,68.4062922 46.3344715,68.7377381 46.2149914,69.0267974 C46.0955112,69.3119989 45.8141423,69.5008539 45.5019389,69.5008539 C45.0779615,69.5008539 44.7310753,69.1539867 44.7310753,68.7300323 Z M49.2560074,75.6673777 L47.0436167,75.6673777 L47.0436167,72.2565228 C48.7163782,71.5280976 49.6491108,69.7243799 49.2752482,67.9360737 C48.9013756,66.1516154 47.3287745,64.8720268 45.5018895,64.8720268 C43.6750046,64.8720268 42.1023936,66.1516154 41.7285309,67.9360737 C41.3546584,69.7243799 42.2874107,71.5280779 43.9601624,72.2565228 L43.9601624,75.6673777 L41.7516198,75.6673777 L38.1478759,69.6549196 L45.5018895,61.0756871 L52.8597514,69.6549196 L49.2560074,75.6673777 Z M51.668798,83.622257 L51.668798,77.6368332 L56.0742401,70.2947632 C56.417278,69.7243503 56.3517509,69.0036308 55.9200673,68.4987612 L46.6697047,57.7067649 C46.3690654,57.3791669 45.945088,57.1941697 45.4979921,57.1941697 C45.0547443,57.1941697 44.6307669,57.3791669 44.3301276,57.7067649 L35.0797649,68.4987612 C34.6442233,69.0036506 34.5825542,69.7243799 34.9255922,70.2947632 L39.3349811,77.6368332 L39.3349811,83.622257 C34.9718687,81.7183152 31.7342911,77.9065837 30.5625785,73.2930004 C29.3870177,68.6834623 30.4084058,63.784934 33.329991,60.031415 C36.2515269,56.2736533 40.7418256,54.0767746 45.5019882,54.0767746 C50.2621508,54.0767746 54.7523509,56.2736533 57.6739854,60.031415 C60.5955213,63.7853287 61.6169587,68.683857 60.4413979,73.2930004 C59.2696853,77.9063864 56.0320091,81.7181179 51.6689953,83.622257 L51.668798,83.622257 Z",
    id: "Fill-16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(177.000000, 536.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#EDAF4B",
    x: 183,
    y: 125,
    width: 80,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(23.000000, 47.000000)",
    stroke: "#2e5668",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 80,
    cy: 80,
    r: 80
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(58.000000, 83.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5641026,20.8717949 C66.5641026,14.3416263 61.2481173,9.02564103 54.7179487,9.02564103 C48.1877801,9.02564103 42.8717949,14.3416263 42.8717949,20.8717949 C42.8717949,27.4019635 48.1877801,32.7179487 54.7179487,32.7179487 C61.2481173,32.7179487 66.5641026,27.4019635 66.5641026,20.8717949 Z M45.8333333,20.8717949 C45.8333333,15.970425 49.8165789,11.9871795 54.7179487,11.9871795 C59.6193186,11.9871795 63.6025641,15.970425 63.6025641,20.8717949 C63.6025641,25.7731647 59.6193186,29.7564103 54.7179487,29.7564103 C49.8165789,29.7564103 45.8333333,25.7731647 45.8333333,20.8717949 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1831953,40.6153846 L58.1831953,38.6426383 C58.1831953,37.9681354 58.643741,37.3878788 59.3000946,37.2320086 C61.1857616,36.7859637 62.9699599,36.0316504 64.6054362,34.9908759 C65.1784053,34.6246135 65.9290794,34.7080166 66.4113578,35.1903229 L68.336944,37.1122884 L72.0866474,33.362585 L70.1574407,31.4369989 C69.6751344,30.9583224 69.5953519,30.2040556 69.9579937,29.6310772 C70.9951477,27.9992215 71.7530537,26.2150232 72.2063676,24.3220223 C72.3623027,23.6692799 72.9461521,23.2087435 73.6169972,23.2087435 L75.5897436,23.2087435 L75.5897436,17.4065483 L73.6206178,17.4065483 C72.9497355,17.4065483 72.3658583,16.9460026 72.2099881,16.2932695 C71.7566928,14.4002685 71.0023889,12.6161632 69.9616143,10.987928 C69.5953519,10.4149589 69.678755,9.66428478 70.1574407,9.18200632 L72.0866474,7.25279964 L68.336944,3.50309621 L66.4077373,5.42868232 C65.925431,5.91098863 65.1784146,5.99440099 64.6054362,5.6281293 C62.9663393,4.58735474 61.1821411,3.83306937 59.2963812,3.38699661 C58.6436389,3.23106145 58.1831024,2.64721208 58.1831024,1.97274635 L58.1831024,0 L52.3809073,0 L52.3809073,1.97274635 C52.3809073,2.64724922 51.9203615,3.22750587 51.2640079,3.38337604 C49.3783409,3.82942095 47.5941427,4.58373417 45.9586664,5.62450873 C45.3856973,5.99077113 44.6350232,5.90736806 44.1527447,5.42506175 L42.2271586,3.50309621 L38.4774552,7.25279964 L40.4066619,9.17838575 C40.8889682,9.65706221 40.9687507,10.411329 40.6061088,10.9843074 C39.5689549,12.6161632 38.8110489,14.4003614 38.357735,16.2933624 C38.19817,16.9461047 37.6143299,17.4066412 36.9434848,17.4066412 L34.974359,17.4066412 L34.974359,23.2088363 L36.9434848,23.2088363 C37.6143671,23.2088363 38.1982443,23.6693821 38.3541144,24.3221151 C38.8074098,26.2151161 39.5617137,27.9992215 40.6024883,29.6274567 C40.9687507,30.2004258 40.8853476,30.9510998 40.4066619,31.4333783 L38.4774552,33.362585 L42.2271586,37.1122884 L44.1563653,35.1867023 C44.6350417,34.7080258 45.385688,34.6209836 45.9586664,34.9872553 C47.5977633,36.0280299 49.3819615,36.7823152 51.2677213,37.228388 C51.9204636,37.3806933 52.3846207,37.9681725 52.3846207,38.6390177 L52.3809908,40.6153846 L58.1831953,40.6153846 Z M40.7766098,20.3077016 C40.7766098,12.3079134 47.2823095,5.80221372 55.2820977,5.80221372 C63.2818859,5.80221372 69.7875856,12.3079134 69.7875856,20.3077016 C69.7875856,28.3074898 63.2818859,34.8131895 55.2820977,34.8131895 C47.2823095,34.8131895 40.7766098,28.3074898 40.7766098,20.3077016 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,60.9230769 L73.3333333,60.9230769 L73.3333333,55.2820513 L66.6086315,55.2820513 L64.1042688,57.6900923 C63.8292676,57.9545165 63.4552653,58.1025912 63.0665728,58.1025912 L44.0003755,58.1025912 L44,60.9230769 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9230769,20.3076923 C60.9230769,23.4243364 58.3986954,25.9487179 55.2820513,25.9487179 C52.1654072,25.9487179 49.6410256,23.4243364 49.6410256,20.3076923 C49.6410256,17.1910482 52.1654072,14.6666667 55.2820513,14.6666667 C58.3986954,14.6666667 60.9230769,17.1910482 60.9230769,20.3076923",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5897436,62.6153846 C31.5897436,66.3760684 25.9487179,66.3760684 25.9487179,62.6153846 C25.9487179,58.8547009 31.5897436,58.8547009 31.5897436,62.6153846",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1282051,38.5415685 C89.1282051,35.3313097 86.5967766,32.7179487 83.487175,32.7179487 C80.3775734,32.7179487 77.8461538,35.3313097 77.8461538,38.5415685 C77.8461538,41.7518273 80.3775734,44.3651883 83.487175,44.3651883 C83.8115382,44.3651883 84.1288434,44.3215065 84.4391086,44.2669136 C84.7423157,45.7337203 84.8974393,47.2296918 84.8974393,48.7329311 C84.8974393,54.1270939 82.8948317,59.2629675 79.2564182,63.5174711 L79.2564182,67.6923077 C84.7035687,62.5420847 87.7179498,55.8410085 87.7179498,48.7324652 C87.7179498,46.8070367 87.481731,44.8925101 87.0410273,43.0253178 C88.3031719,41.9552626 89.1282051,40.3537206 89.1282051,38.5411306 L89.1282051,38.5415685 Z M83.487175,41.4533784 C81.932329,41.4533784 80.6666644,40.1467445 80.6666644,38.5415685 C80.6666644,36.9363925 81.932329,35.6297586 83.487175,35.6297586 C85.0420209,35.6297586 86.3076855,36.9363925 86.3076855,38.5415685 C86.3076855,40.1467445 85.0420209,41.4533784 83.487175,41.4533784 Z",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0541546,86.5348802 L38.0541546,63.0679163 C38.0541546,62.2575738 38.7091205,61.6012309 39.5177629,61.6012309 L40.9813712,61.6012309 L40.9813712,57.2011744 C40.9813712,56.3908319 41.6363371,55.734489 42.4449796,55.734489 L51.3034397,55.734489 L54.1538462,49.5450293 L54.1538462,44.0010051 L51.2266295,44.0010051 C50.4179871,44.0010051 49.7630212,43.3446622 49.7630212,42.5343197 L49.7630212,40.1949446 C48.332385,39.7696105 46.9601995,39.1866159 45.6539584,38.4568871 L43.4805117,40.6349033 C42.9096998,41.2069153 41.9839312,41.2069153 41.4095411,40.6349033 L35.5551078,34.7681614 C34.9842958,34.1961587 34.9842958,33.2684344 35.5551078,32.6928366 L37.7285544,30.5148204 C37.4760832,30.0638135 37.2675155,29.5944741 37.0516321,29.1287675 C30.3190338,33.8514478 26.3450444,40.9429776 26.3450444,48.40078 C26.3450444,51.4771117 27.0292825,54.4618284 28.3063264,57.2999234 C28.6210046,57.2449169 28.9429984,57.200921 29.2722611,57.200921 C32.4995057,57.200921 35.1266944,59.8336332 35.1266944,63.0676629 C35.1266944,66.3016927 32.4995057,68.9344048 29.2722611,68.9344048 C26.0450164,68.9344048 23.4178278,66.3016927 23.4178278,63.0676629 C23.4178278,61.2270078 24.2850146,59.6026243 25.6132871,58.5283066 C24.1569851,55.3015985 23.4178278,51.9062099 23.4178278,48.400902 C23.4178278,39.7950956 28.0537896,31.6623833 35.8657581,26.4001505 L33.6629924,26.4001505 C32.85435,26.4001505 32.1993841,25.7438076 32.1993841,24.933465 L32.1993841,16.1333521 C32.1993841,15.3230096 32.85435,14.6666667 33.6629924,14.6666667 L29.2721674,14.6666667 C18.7632255,14.6666667 10.2457276,23.2028231 10.2457276,33.7331085 L0,55.73386 L10.2457276,55.73386 L10.2457276,74.8003019 L26.3458875,74.8003019 L26.3458875,88 L39.517894,88 C38.7092516,88 38.0542857,87.3436571 38.0542857,86.5333145 L38.0541546,86.5348802 Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6153846,84.6153846 L75.5897436,84.6153846 L75.5897436,64.3076923 L40.6153846,64.3076923 L40.6153846,84.6153846 Z M55.1880342,78.8131868 L69.7606838,78.8131868 L69.7606838,75.9120879 L72.6752137,75.9120879 L72.6752137,80.2637363 C72.6752137,81.0651637 72.0230864,81.7142857 71.2179487,81.7142857 L55.1875679,81.7142857 L55.1880342,78.8131868 Z",
    id: "Fill-8"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Data-Manager",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.81,
    y: 27
  }, "Data Manager"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(263.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#2e5668",
    strokeWidth: 4,
    cx: 80,
    cy: 127,
    r: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(35.000000, 83.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0.672554348 77.741413 19.0149457 88.2234802 19.0149457 70.3438043 0.672554348 59.8617391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "38.8633696 57.2282609 20.5434783 46.7618478 2.22358989 57.2282609 20.5434783 67.6946739"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "40.413913 59.8607609 22.0715217 70.3428261 22.0715217 88.222502 40.413913 77.7404348"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "87.776413 57.2282609 69.4565217 46.7618478 51.1366304 57.2282609 69.4565217 67.6946739"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "89.3269565 59.8607609 70.9845652 70.3428261 70.9845652 88.222502 89.3269565 77.7404348"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "49.586087 77.741413 67.9284783 88.2234802 67.9284783 70.3438043 49.586087 59.8617391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1295652,35.8288043 C25.1295652,37.8655435 22.0725,37.8655435 22.0725,35.8288043 C22.0725,33.7920652 25.1295652,33.7920652 25.1295652,35.8288043",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1295652,14.4293478 C25.1295652,16.466087 22.0725,16.466087 22.0725,14.4293478 C22.0725,12.3926087 25.1295652,12.3926087 25.1295652,14.4293478",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0270652,23.1955435 C42.8295424,22.5076989 43.8613043,22.0721087 45.0000978,22.0721087 C46.1388913,22.0721087 47.170663,22.507738 47.9731304,23.1955435 L61.8937826,15.2395435 C61.8479217,14.9796978 61.8135359,14.7083772 61.8135359,14.4294261 C61.8135359,14.150475 61.8479217,13.8791543 61.8975978,13.6154837 L47.9769554,5.6594837 C47.1706533,6.35114348 46.1389011,6.7867337 45.0001076,6.7867337 C43.8613141,6.7867337 42.8295424,6.35110435 42.027075,5.66329891 L28.1064228,13.6192989 C28.1522739,13.8791446 28.1866696,14.1504652 28.1866696,14.4294163 C28.1866696,14.7083674 28.1522739,14.979688 28.1025978,15.2433587 L42.0270652,23.1955435 Z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8705228,31.526413 L64.8705228,18.7327174 C64.3354435,18.5416533 63.8462935,18.2550522 63.4259348,17.8882043 L49.5052826,25.8442043 C49.5511337,26.107875 49.5855293,26.3791957 49.5855293,26.6581467 C49.5855293,28.6491033 48.301562,30.3304402 46.5284641,30.9609293 L46.5284641,42.2265815 C47.5029,42.5743239 48.3244533,43.2277337 48.8670946,44.0875272 L61.8975293,36.6435489 C61.8478533,36.3798783 61.8134576,36.1085576 61.8134576,35.8296065 C61.8134576,33.83865 63.097425,32.157313 64.8705228,31.5268239 L64.8705228,31.526413 Z",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1329348,44.0863043 C41.6755663,43.2265011 42.4971196,42.5730326 43.4715652,42.2253587 L43.4715652,30.9597065 C41.6984674,30.325363 40.4145,28.6439674 40.4145,26.6569239 C40.4145,26.377963 40.4488957,26.1066522 40.4985717,25.8429815 L26.5779196,17.8869815 C26.1537554,18.2538293 25.6684402,18.5366054 25.1334196,18.7314946 L25.1334196,31.5251902 C26.9065174,32.1595337 28.1904848,33.8409293 28.1904848,35.8279728 C28.1904848,36.1069337 28.1560891,36.3782446 28.106413,36.6419152 L41.1329348,44.0863043 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9284783,14.4293478 C67.9284783,16.466087 64.871413,16.466087 64.871413,14.4293478 C64.871413,12.3926087 67.9284783,12.3926087 67.9284783,14.4293478",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5280435,2.20108696 C46.5280435,4.23782609 43.4709783,4.23782609 43.4709783,2.20108696 C43.4709783,0.164347826 46.5280435,0.164347826 46.5280435,2.20108696",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9284783,35.8288043 C67.9284783,37.8655435 64.871413,37.8655435 64.871413,35.8288043 C64.871413,33.7920652 67.9284783,33.7920652 67.9284783,35.8288043",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5280435,46.5280435 C46.5280435,48.5647826 43.4709783,48.5647826 43.4709783,46.5280435 C43.4709783,44.4913043 46.5280435,44.4913043 46.5280435,46.5280435",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5280435,26.6576087 C46.5280435,28.6943478 43.4709783,28.6943478 43.4709783,26.6576087 C43.4709783,24.6208696 46.5280435,24.6208696 46.5280435,26.6576087",
    id: "Fill-16"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ML-Models",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.898,
    y: 27
  }, "ML Models"))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#2e5668",
    x: 0,
    y: 773,
    width: 800,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(63.000000, 857.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#EDAF4B",
    x: 177,
    y: 68,
    width: 80,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#EDAF4B",
    x: 417,
    y: 68,
    width: 80,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(17.000000, 0.000000)",
    stroke: "#2e5668",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 80,
    cy: 80,
    r: 80
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.936903,96.62372 L108.811903,96.62372 C108.811903,97.487 109.511123,98.18622 110.374403,98.18622 C111.237683,98.18622 111.936903,97.487 111.936903,96.62372 L113.499403,96.62372 C114.362683,96.62372 115.061938,95.9245 115.061938,95.06122 L115.061938,80.99922 C115.061938,80.13594 114.362683,79.43672 113.499403,79.43672 L107.249403,79.43672 L107.249403,76.96012 L114.604903,69.60462 C115.214283,68.99524 115.214283,68.00692 114.604903,67.39372 C113.995523,66.78434 113.007203,66.78434 112.394003,67.39372 L104.581503,75.20622 C104.288533,75.49919 104.124473,75.89763 104.124473,76.31172 L104.124473,79.43672 L91.624473,79.43672 L91.624473,76.31172 C91.624473,75.89766 91.460413,75.49922 91.167443,75.20622 L83.354943,67.39372 C82.745563,66.78434 81.757243,66.78434 81.144043,67.39372 C80.534663,68.0031 80.534663,68.99142 81.144043,69.60462 L88.499543,76.96012 L88.499543,79.43672 L82.249543,79.43672 C81.386263,79.43672 80.687008,80.13594 80.687008,80.99922 L80.687008,95.06122 C80.687008,95.9245 81.386263,96.62372 82.249543,96.62372 L83.812043,96.62372 C83.812043,97.487 84.511263,98.18622 85.374543,98.18622 C86.237823,98.18622 86.937043,97.487 86.937043,96.62372 L86.936903,96.62372 Z M83.811903,82.56172 L111.936903,82.56172 L111.936903,93.49972 L83.811903,93.49972 L83.811903,82.56172 Z M104.424903,64.99572 C102.655403,63.22622 100.299903,62.24962 97.796003,62.24962 C95.292103,62.24962 92.936603,63.22618 91.167103,64.99572 C90.557723,65.6051 89.569403,65.6051 88.956203,64.99572 C88.346823,64.38634 88.346823,63.39802 88.956203,62.78482 C91.319503,60.42542 94.456203,59.12462 97.796003,59.12462 C101.135803,59.12462 104.272603,60.42542 106.635803,62.78482 C107.245183,63.3942 107.245183,64.38252 106.635803,64.99572 C106.331113,65.30041 105.932683,65.452755 105.530303,65.452755 C105.127923,65.452755 104.729523,65.30041 104.424803,64.99572 L104.424903,64.99572 Z M100.006903,69.41372 C99.413153,68.82388 98.631903,68.49966 97.796003,68.49966 C96.960103,68.49966 96.174903,68.82388 95.585103,69.41372 C94.975723,70.0231 93.983503,70.0231 93.374203,69.41372 C92.764823,68.80435 92.764823,67.81602 93.374203,67.20282 C94.557803,66.02312 96.128103,65.37472 97.796103,65.37472 C99.464103,65.37472 101.034403,66.02316 102.214103,67.20672 C102.823483,67.8161 102.823483,68.80442 102.214103,69.41762 C101.909413,69.72231 101.510983,69.87465 101.108603,69.87465 C100.710163,69.87074 100.311723,69.7184 100.007003,69.41371 L100.006903,69.41372 Z M97.796003,71.62462 C98.659283,71.62462 99.358503,72.32384 99.358503,73.18712 C99.358503,74.0504 98.659283,74.74962 97.796003,74.74962 C96.932723,74.74962 96.233503,74.0504 96.233503,73.18712 C96.233503,72.32384 96.932723,71.62462 97.796003,71.62462 Z M86.937003,88.81262 L86.937003,87.25012 C86.937003,86.38684 87.636223,85.68762 88.499503,85.68762 C89.362783,85.68762 90.062003,86.38684 90.062003,87.25012 L90.062003,88.81262 C90.062003,89.6759 89.362783,90.37512 88.499503,90.37512 C87.636223,90.37512 86.937003,89.6759 86.937003,88.81262 Z M105.687003,88.81262 L105.687003,87.25012 C105.687003,86.38684 106.386223,85.68762 107.249503,85.68762 C108.112783,85.68762 108.812003,86.38684 108.812003,87.25012 L108.812003,88.81262 C108.812003,89.6759 108.112783,90.37512 107.249503,90.37512 C106.386223,90.37512 105.687003,89.6759 105.687003,88.81262 Z M94.914003,88.547 C94.527283,87.77356 94.839783,86.8361 95.613223,86.4493 C96.386663,86.06258 97.324123,86.37508 97.710923,87.14852 C97.726553,87.17977 97.761703,87.25008 97.874983,87.25008 C97.988263,87.25008 98.023423,87.17977 98.039043,87.14852 C98.425763,86.37508 99.363243,86.06262 100.136743,86.4493 C100.910183,86.83602 101.222643,87.7735 100.835963,88.547 C100.269553,89.6759 99.136763,90.3751 97.875063,90.3751 C96.613363,90.3751 95.480563,89.67588 94.914163,88.547 L94.914003,88.547 Z M80.687003,52.875 L82.249503,52.875 L82.249503,54.4375 C82.249503,55.30078 82.948723,56 83.812003,56 C84.675283,56 85.374503,55.30078 85.374503,54.4375 L85.374503,52.875 L110.374503,52.875 L110.374503,54.4375 C110.374503,55.30078 111.073723,56 111.937003,56 C112.800283,56 113.499503,55.30078 113.499503,54.4375 L113.499503,52.875 L115.062003,52.875 C115.925283,52.875 116.624503,52.17578 116.624503,51.3125 L116.624503,32.5625 C116.624503,31.69922 115.925283,31 115.062003,31 L80.687003,31 C79.823723,31 79.124503,31.69922 79.124503,32.5625 L79.124503,51.3125 C79.124503,52.17578 79.823723,52.875 80.687003,52.875 Z M82.249503,34.125 L113.499503,34.125 L113.499503,49.75 L82.249503,49.75 L82.249503,34.125 Z M143.187503,112.25 L141.625003,112.25 L141.625003,102.875 C141.625003,102.01172 140.925783,101.3125 140.062503,101.3125 L115.062503,101.3125 C114.199223,101.3125 113.500003,102.01172 113.500003,102.875 L113.500003,109.125 L108.812503,109.125 C107.949223,109.125 107.250003,109.82422 107.250003,110.6875 L107.250003,123.187499 C107.250003,124.050779 107.949223,124.749999 108.812503,124.749999 L118.187503,124.749999 C119.050783,124.749999 119.750003,124.050779 119.750003,123.187499 L119.750003,118.499999 L126.000003,118.499999 L126.000003,121.624999 L122.875003,121.624999 C122.011723,121.624999 121.312503,122.324219 121.312503,123.187499 C121.312503,124.050779 122.011723,124.749999 122.875003,124.749999 L132.250003,124.749999 C133.113283,124.749999 133.812503,124.050779 133.812503,123.187499 C133.812503,122.324219 133.113283,121.624999 132.250003,121.624999 L129.125003,121.624999 L129.125003,118.499999 L135.375003,118.499999 L135.375003,123.187499 C135.375003,124.050779 136.074223,124.749999 136.937503,124.749999 L143.187503,124.749999 C144.050783,124.749999 144.750003,124.050779 144.750003,123.187499 L144.750003,113.8125 C144.750003,112.94922 144.050783,112.25 143.187503,112.25 Z M116.625503,121.624999 L110.375503,121.624999 L110.375503,112.25 L116.625503,112.25 L116.625503,121.624999 Z M119.750503,115.375 L119.750503,110.6875 C119.750503,109.82422 119.051283,109.125 118.188003,109.125 L116.625503,109.125 L116.625503,104.4375 L138.500503,104.4375 L138.500503,112.25 L136.938003,112.25 C136.074723,112.25 135.375503,112.94922 135.375503,113.8125 L135.375503,115.375 L119.750503,115.375 Z M141.625503,121.624999 L138.500503,121.624999 L138.500503,115.375 L141.625503,115.375 L141.625503,121.624999 Z M74.437503,106 L69.750003,106 L69.750003,101.3125 C69.750003,100.44922 69.050783,99.75 68.187503,99.75 L58.812503,99.75 C57.949223,99.75 57.25,100.44922 57.25,101.3125 L57.25,106 L52.5625,106 C51.69922,106 51,106.69922 51,107.5625 L51,116.9375 C51,117.80078 51.69922,118.499999 52.5625,118.499999 C52.5625,119.363279 53.26172,120.062499 54.125,120.062499 C54.98828,120.062499 55.6875,119.363279 55.6875,118.499999 L57.25,118.499999 L57.25,123.187499 C57.25,124.050779 57.949223,124.75 58.812503,124.75 L68.187503,124.75 C69.050783,124.75 69.750003,124.050779 69.750003,123.187499 L69.750003,118.499999 L71.312503,118.499999 C71.312503,119.363279 72.011723,120.062499 72.875003,120.062499 C73.738283,120.062499 74.437503,119.363279 74.437503,118.499999 C75.300783,118.499999 76,117.80078 76,116.9375 L76,107.5625 C76,106.69922 75.300783,106 74.437503,106 Z M60.375503,102.875 L66.625503,102.875 L66.625503,106 L60.375503,106 L60.375503,102.875 Z M66.625503,121.624999 L60.375503,121.624999 L60.375503,115.375 L66.625503,115.375 L66.625503,121.624999 Z M69.750503,115.375 L69.750503,113.8125 C69.750503,112.94922 69.051283,112.25 68.188003,112.25 L58.813003,112.25 C57.949723,112.25 57.250499,112.94922 57.250499,113.8125 L57.250499,115.375 L54.125499,115.375 L54.125499,109.125 L72.875503,109.125 L72.875503,115.375 L69.750503,115.375 Z M63.500499,57.563 C56.606,57.563 51.000499,63.1724 51.000499,70.063 L51.000499,76.313 C51.000499,79.7583 53.805199,82.563 57.250499,82.563 C59.504403,82.563 61.559103,81.3442 62.660703,79.438 L64.336503,79.438 C65.442003,81.3442 67.496703,82.563 69.750603,82.563 C73.195903,82.563 76.000603,79.7583 76.000603,76.313 L76.000603,70.063 C76.000603,63.1724 70.395103,57.563 63.500603,57.563 L63.500499,57.563 Z M72.586403,70.747 C72.555153,70.73137 72.527803,70.71575 72.496553,70.70012 C72.387173,70.64544 72.281713,70.59856 72.168433,70.55168 C72.152813,70.54387 72.133283,70.53996 72.117653,70.53215 C72.023903,70.49309 71.926243,70.45793 71.828593,70.42277 C71.793443,70.41105 71.758283,70.39934 71.723123,70.38762 C71.637183,70.36027 71.551243,70.33293 71.465313,70.30949 C71.430163,70.30168 71.398913,70.28996 71.363753,70.28215 C71.246563,70.2509 71.125473,70.21965 71.004373,70.19621 C70.992653,70.1923 70.980933,70.1923 70.973123,70.1884 C70.863743,70.16496 70.750463,70.14934 70.637183,70.13371 C70.598123,70.1298 70.562963,70.12199 70.523903,70.11809 C70.434063,70.10637 70.340313,70.09855 70.250463,70.09074 C70.211403,70.08684 70.176243,70.08293 70.137183,70.08293 C70.004373,70.0673 69.879373,70.0634 69.750463,70.0634 L57.250465,70.0634 C57.121555,70.0634 56.996555,70.0673 56.867655,70.07512 C56.828592,70.07902 56.793436,70.07902 56.754375,70.08293 C56.660625,70.09074 56.570785,70.09855 56.480935,70.11027 C56.441872,70.11418 56.406716,70.11809 56.367655,70.1259 C56.254375,70.14152 56.144995,70.16105 56.031715,70.18059 C56.019996,70.18449 56.008277,70.18449 56.000465,70.1884 C55.879375,70.21184 55.758275,70.24309 55.641085,70.27434 C55.605929,70.28215 55.574679,70.29387 55.539525,70.30168 C55.453588,70.32512 55.367655,70.35246 55.281715,70.3798 C55.246559,70.39152 55.211403,70.40324 55.176245,70.41496 C55.078589,70.45012 54.980935,70.48527 54.887185,70.52434 C54.87156,70.53215 54.852028,70.53606 54.836404,70.54387 C54.727024,70.59075 54.617654,70.64153 54.508274,70.69231 C54.477024,70.70794 54.449681,70.72356 54.418431,70.73919 C54.340306,70.77825 54.262181,70.82122 54.184051,70.86419 C54.164519,70.8759 54.148895,70.88372 54.129363,70.89544 L54.125457,70.06341 C54.125457,68.53221 55.234857,67.25481 56.691857,66.98921 C58.582453,68.62981 60.973053,69.52831 63.500453,69.52831 C66.027853,69.52831 68.418453,68.63378 70.309053,66.98921 C71.766053,67.25483 72.875453,68.53221 72.875453,70.06341 L72.875453,70.90325 C72.855923,70.89153 72.840303,70.88371 72.820773,70.872 C72.742643,70.82903 72.664523,70.78606 72.586403,70.747 Z M63.500503,60.688 C66.293503,60.688 68.805203,61.9185 70.523903,63.8638 C70.269993,63.83255 70.012183,63.81302 69.750463,63.81302 C69.336403,63.81302 68.937963,63.97708 68.644963,64.27005 C67.269963,65.64505 65.445763,66.40285 63.500463,66.40285 C61.555163,66.40285 59.730963,65.64504 58.355963,64.27005 C58.062993,63.97708 57.66455,63.81302 57.25046,63.81302 C56.98874,63.81302 56.73093,63.83255 56.47702,63.8638 C58.195823,61.9185 60.707523,60.688 63.500423,60.688 L63.500503,60.688 Z M69.750503,79.438 C68.430203,79.438 67.246603,78.60206 66.805203,77.356 C66.586453,76.731 65.996613,76.313 65.332503,76.313 L61.668403,76.313 C61.004343,76.313 60.414503,76.73097 60.195703,77.356 C59.754293,78.6021 58.570703,79.438 57.250399,79.438 C55.527699,79.438 54.125399,78.0357 54.125399,76.313 C54.125399,74.5903 55.527699,73.188 57.250399,73.188 L69.750403,73.188 C71.473103,73.188 72.875403,74.5903 72.875403,76.313 C72.875403,78.0357 71.473103,79.438 69.750403,79.438 L69.750503,79.438 Z M76.000503,41.938 C76.000503,42.80128 75.301283,43.5005 74.438003,43.5005 L74.398933,43.5005 C73.535653,43.5005 72.836433,42.80128 72.836433,41.938 C72.836433,41.07472 73.535653,40.3755 74.398933,40.3755 L74.438003,40.3755 C75.301283,40.3755 76.000503,41.07472 76.000503,41.938 Z M66.582503,41.938 C66.582503,41.07472 67.281723,40.3755 68.145003,40.3755 L68.234843,40.3755 C69.098123,40.3755 69.797343,41.07472 69.797343,41.938 C69.797343,42.80128 69.098123,43.5005 68.234843,43.5005 L68.145003,43.5005 C67.281723,43.5005 66.582503,42.80128 66.582503,41.938 Z M60.375503,41.97706 L60.375503,41.938 C60.375503,41.07472 61.074723,40.3755 61.938003,40.3755 L61.977063,40.3755 C62.840343,40.3755 63.539563,41.07472 63.539563,41.938 C63.539563,42.37941 63.355973,42.77784 63.063003,43.063 C62.777843,43.35597 62.379413,43.53956 61.938003,43.53956 C61.074723,43.53956 60.375503,42.84034 60.375503,41.97706 Z M60.375503,47.44586 L60.375503,47.36774 C60.375503,46.50446 61.074723,45.80524 61.938003,45.80524 C62.801283,45.80524 63.500503,46.50446 63.500503,47.36774 L63.500503,47.44586 C63.500503,48.30914 62.801283,49.00836 61.938003,49.00836 C61.074723,49.00836 60.375503,48.30914 60.375503,47.44586 Z M60.375503,52.87556 L60.375503,52.8365 C60.375503,51.97322 61.074723,51.274 61.938003,51.274 C62.801283,51.274 63.500503,51.97322 63.500503,52.8365 L63.500503,52.87556 C63.500503,53.73884 62.801283,54.43806 61.938003,54.43806 C61.074723,54.43806 60.375503,53.73884 60.375503,52.87556 Z M119.750503,41.93756 C119.750503,41.07428 120.449723,40.37506 121.313003,40.37506 L121.352063,40.37506 C122.215343,40.37506 122.914563,41.07428 122.914563,41.93756 C122.914563,42.80084 122.215343,43.50006 121.352063,43.50006 L121.313003,43.50006 C120.449723,43.50006 119.750503,42.80084 119.750503,41.93756 Z M125.957503,41.93756 C125.957503,41.07428 126.656723,40.37506 127.520003,40.37506 L127.609843,40.37506 C128.473123,40.37506 129.172343,41.07428 129.172343,41.93756 C129.172343,42.80084 128.473123,43.50006 127.609843,43.50006 L127.520003,43.50006 C126.656723,43.50006 125.957503,42.80084 125.957503,41.93756 Z M132.688003,43.06256 C132.395033,42.7774 132.211443,42.37897 132.211443,41.93756 C132.211443,41.07428 132.910663,40.37506 133.773943,40.37506 L133.813003,40.37506 C134.676283,40.37506 135.375503,41.07428 135.375503,41.93756 L135.375503,41.97662 C135.375503,42.8399 134.676283,43.53912 133.813003,43.53912 C133.371593,43.53912 132.973163,43.35553 132.688003,43.06256 Z M135.375503,47.44536 C135.375503,48.30864 134.676283,49.00786 133.813003,49.00786 C132.949723,49.00786 132.250503,48.30864 132.250503,47.44536 L132.250503,47.36724 C132.250503,46.50396 132.949723,45.80474 133.813003,45.80474 C134.676283,45.80474 135.375503,46.50396 135.375503,47.36724 L135.375503,47.44536 Z M135.375503,52.83596 L135.375503,52.87502 C135.375503,53.7383 134.676283,54.43752 133.813003,54.43752 C132.949723,54.43752 132.250503,53.7383 132.250503,52.87502 L132.250503,52.83596 C132.250503,51.97268 132.949723,51.27346 133.813003,51.27346 C134.676283,51.27346 135.375503,51.97268 135.375503,52.83596 Z M61.937493,91.23396 C61.937493,90.37068 62.636713,89.67146 63.499993,89.67146 C64.363273,89.67146 65.062493,90.37068 65.062493,91.23396 L65.062493,91.31208 C65.062493,92.17536 64.363273,92.87458 63.499993,92.87458 C62.636713,92.87458 61.937493,92.17536 61.937493,91.31208 L61.937493,91.23396 Z M61.937493,96.78086 C61.937493,95.91758 62.636713,95.21836 63.499993,95.21836 C64.363273,95.21836 65.062493,95.91758 65.062493,96.78086 L65.062493,96.85898 C65.062493,97.72226 64.363273,98.42148 63.499993,98.42148 C62.636713,98.42148 61.937493,97.72226 61.937493,96.85898 L61.937493,96.78086 Z M61.937493,85.76486 L61.937493,85.68673 C61.937493,84.82345 62.636713,84.12423 63.499993,84.12423 C64.363273,84.12423 65.062493,84.82345 65.062493,85.68673 L65.062493,85.76486 C65.062493,86.62814 64.363273,87.32736 63.499993,87.32736 C62.636713,87.32736 61.937493,86.62814 61.937493,85.76486 Z M130.687493,87.32736 L130.687493,87.24923 C130.687493,86.38595 131.386713,85.68673 132.249993,85.68673 C133.113273,85.68673 133.812493,86.38595 133.812493,87.24923 L133.812493,87.32736 C133.812493,88.19064 133.113273,88.88986 132.249993,88.88986 C131.386713,88.88986 130.687493,88.19064 130.687493,87.32736 Z M130.687493,98.34336 C130.687493,97.48008 131.386713,96.78086 132.249993,96.78086 C133.113273,96.78086 133.812493,97.48008 133.812493,98.34336 L133.812493,98.42148 C133.812493,99.28476 133.113273,99.98398 132.249993,99.98398 C131.386713,99.98398 130.687493,99.28476 130.687493,98.42148 L130.687493,98.34336 Z M130.687493,92.79646 C130.687493,91.93318 131.386713,91.23396 132.249993,91.23396 C133.113273,91.23396 133.812493,91.93318 133.812493,92.79646 L133.812493,92.87458 C133.812493,93.73786 133.113273,94.43708 132.249993,94.43708 C131.386713,94.43708 130.687493,93.73786 130.687493,92.87458 L130.687493,92.79646 Z M104.515493,113.81246 C104.515493,114.67574 103.816273,115.37496 102.952993,115.37496 L102.874873,115.37496 C102.011593,115.37496 101.312373,114.67574 101.312373,113.81246 C101.312373,112.94918 102.011593,112.24996 102.874873,112.24996 L102.952993,112.24996 C103.816273,112.24996 104.515493,112.94918 104.515493,113.81246 Z M82.327493,113.81246 C82.327493,114.67574 81.628273,115.37496 80.764993,115.37496 L80.686873,115.37496 C79.823593,115.37496 79.124373,114.67574 79.124373,113.81246 C79.124373,112.94918 79.823593,112.24996 80.686873,112.24996 L80.764993,112.24996 C81.628273,112.24996 82.327493,112.94918 82.327493,113.81246 Z M87.874393,113.81246 C87.874393,114.67574 87.175173,115.37496 86.311893,115.37496 L86.233773,115.37496 C85.370493,115.37496 84.671273,114.67574 84.671273,113.81246 C84.671273,112.94918 85.370493,112.24996 86.233773,112.24996 L86.311893,112.24996 C87.175173,112.24996 87.874393,112.94918 87.874393,113.81246 Z M98.968393,113.81246 C98.968393,114.67574 98.269173,115.37496 97.405893,115.37496 L97.327773,115.37496 C96.464493,115.37496 95.765273,114.67574 95.765273,113.81246 C95.765273,112.94918 96.464493,112.24996 97.327773,112.24996 L97.405893,112.24996 C98.269173,112.24996 98.968393,112.94918 98.968393,113.81246 Z M93.421493,113.81246 C93.421493,114.67574 92.722273,115.37496 91.858993,115.37496 L91.780873,115.37496 C90.917593,115.37496 90.218373,114.67574 90.218373,113.81246 C90.218373,112.94918 90.917593,112.24996 91.780873,112.24996 L91.858993,112.24996 C92.722273,112.24996 93.421493,112.94918 93.421493,113.81246 Z M141.948493,74.42546 C140.139893,72.62076 137.741493,71.62466 135.182893,71.62466 L133.811793,71.62466 L133.811793,70.06216 C133.811793,69.19888 134.511013,68.49966 135.374293,68.49966 C137.960193,68.49966 140.061793,66.39806 140.061793,63.81216 C140.061793,61.22626 137.960193,59.12466 135.374293,59.12466 C134.511013,59.12466 133.811793,58.42544 133.811793,57.56216 C133.811793,56.69888 133.112573,55.99966 132.249293,55.99966 C131.386013,55.99966 130.686793,56.69888 130.686793,57.56216 C130.686793,60.14806 132.788393,62.24966 135.374293,62.24966 C136.237573,62.24966 136.936793,62.94888 136.936793,63.81216 C136.936793,64.67544 136.237573,65.37466 135.374293,65.37466 C132.788393,65.37466 130.686793,67.47626 130.686793,70.06216 L130.686793,71.62466 L127.753193,71.62466 C125.198493,71.62466 122.796193,72.62075 120.991493,74.42546 C119.182893,76.23406 118.186793,78.63636 118.186793,81.19106 L118.186793,82.37466 C118.186793,85.06216 120.374293,87.24966 123.065693,87.24966 C124.366493,87.24966 125.592993,86.74185 126.514893,85.81996 C127.604693,84.72616 129.061793,84.12466 130.608693,84.12466 L132.327493,84.12466 C133.874393,84.12466 135.327493,84.72622 136.421293,85.81996 C137.343173,86.74184 138.569693,87.24966 139.870493,87.24966 C142.561893,87.24966 144.749393,85.06216 144.749393,82.37076 L144.749393,81.18716 C144.749393,78.63636 143.753303,76.23406 141.948593,74.42546 L141.948493,74.42546 Z M141.624273,82.37076 C141.624273,83.33951 140.839113,84.12466 139.870373,84.12466 C139.401623,84.12466 138.964123,83.94107 138.632073,83.61294 C136.948473,81.92544 134.710173,80.99964 132.327373,80.99964 L130.608573,80.99964 C128.225773,80.99964 125.987473,81.92542 124.303873,83.61294 C123.971843,83.94106 123.530433,84.12466 123.065573,84.12466 C122.096823,84.12466 121.311673,83.3395 121.311673,82.37076 L121.311673,81.18716 C121.311673,79.46836 121.979643,77.85126 123.198373,76.63246 C124.413173,75.41766 126.030373,74.74966 127.753073,74.74966 L135.186673,74.74966 C136.905473,74.74966 138.522573,75.41763 139.741373,76.63636 C140.956173,77.85116 141.624273,79.46836 141.624273,81.19106 L141.624273,82.37076 Z",
    id: "Fill-1",
    fill: "#2e5668"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Edge-Devices",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.074,
    y: 194
  }, "Edge Devices")), /*#__PURE__*/React.createElement("text", {
    id: "On-Premise",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 251.624,
    y: 194
  }, "On-Premise")), /*#__PURE__*/React.createElement("text", {
    id: "Cloud",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 535.094,
    y: 194
  }, "Cloud")), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(257.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#2e5668",
    strokeWidth: 4,
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(40.000000, 40.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4638936,40 L67.5362626,40 C73.8667622,40 79,34.7854771 79,28.3889592 C79,21.9928446 73.8516311,16.7779184 67.5362626,16.7779184 L61.1124285,16.7779184 C60.4591587,9.54688966 54.4552582,3.87550723 47.1449057,3.87550723 C44.920646,3.87550723 42.7431332,4.41113959 40.7677389,5.43515353 C37.4080157,1.9692639 32.835183,-5.36577899e-13 28.0290141,-5.36577899e-13 C18.6031859,-0.0157280135 10.8576972,7.43593066 10.2349363,16.8249433 C4.49550531,17.4551014 0,22.4018726 0,28.3883946 C0,34.7845092 5.14836893,39.9994354 11.4637343,39.9994354 L11.4638936,40 Z M11.4638936,19.3469469 L12.7393588,19.3469469 L12.7393588,18.0550926 C12.7393588,9.51640009 19.5987273,2.56913407 28.0288548,2.56913407 C32.4462362,2.56913407 36.6455716,4.50683489 39.554709,7.89400013 L40.254646,8.71318548 L41.1723025,8.14603917 C42.976557,7.02752369 45.0452858,6.42886343 47.145073,6.42886343 C53.4755725,6.42886343 58.6088104,11.6433863 58.6088104,18.0399042 L58.6088104,19.3317586 L67.5369076,19.3317586 C72.4520199,19.3317586 76.4650049,23.380499 76.4650049,28.3745775 C76.4650049,33.3685753 72.4676287,37.4173964 67.5369076,37.4173964 L11.4645386,37.4173964 C6.5494232,37.4173964 2.53643819,33.3686559 2.53643819,28.3745775 C2.53643819,23.3805797 6.5494232,19.3478906 11.4645386,19.3478906 L11.4638936,19.3469469 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0153887,74.9063591 L37.4339503,74.9063591 L37.4339503,77.4531796 L33.6227129,77.4531796 L33.6227129,80 L51.3926758,80 L51.3926758,77.4531796 L47.5814384,77.4531796 L47.5814384,74.9063591 L59,74.9063591 L59,52 L26,52 L26,74.9063591 L26.0153887,74.9063591 Z M45.0561079,77.4531796 L39.9745108,77.4531796 L39.9745108,74.9063591 L45.0561079,74.9063591 L45.0561079,77.4531796 Z M28.5561079,54.5468205 L56.4897409,54.5468205 L56.4897409,72.3589002 L28.5561079,72.3589002 L28.5561079,54.5468205 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,80 L20,80 L20,54 L2,54 L2,80 Z M4.57368985,56.6014619 L17.4264709,56.6014619 L17.4264709,77.3977258 L4.57368985,77.3977258 L4.57368985,56.6014619 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,79 L79,79 L79,59 L66,59 L66,79 Z M68.6031695,76.4980667 L68.6031695,73.9961336 L76.4127594,73.9961336 L76.4127594,76.4980667 L68.6031695,76.4980667 Z M76.3968305,61.5017769 L76.3968305,71.494356 L68.5872406,71.494356 L68.5872406,61.5017769 L76.3968305,61.5017769 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "9 76 12 76 12 73 9 73"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "9 45.5758976 9 52 11.5579531 52 11.5579531 48.1517951 27 48.1517951 27 43 24.4263791 43 24.4263791 45.5758976"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "73 52 73 45.5758976 57.5736784 45.5758976 57.5736784 43 55 43 55 48.1517951 70.4263216 48.1517951 70.4263216 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "41 50 44 50 44 42 41 42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(543.000000, 39.000000)",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9225805,15.0553385 C57.8113455,10.2243856 53.4599909,6.6585662 48.4640921,6.5809101 C43.3622396,-2.78078053 29.7280283,-1.9257373 25.6539672,7.69106187 C19.5633241,4.67057005 11.8107346,8.00086014 10.2259652,15.0487295 C4.53151446,15.3907963 0,20.1442914 0,25.943715 C0,31.1457649 3.68792572,35.6408139 8.76735069,36.6288638 C8.81888456,36.638546 8.87364238,36.6449981 8.92839196,36.6449981 C8.7383598,37.0354761 8.62241273,37.4678967 8.62241273,37.9293804 L8.62241273,43.4541162 C8.62241273,45.0902641 9.94943034,46.4197531 11.582353,46.4197531 L57.5571557,46.4197531 C59.1901608,46.4197531 60.517096,45.0901815 60.517096,43.4541162 L60.517096,37.9293804 C60.517096,37.4711351 60.4043646,37.038731 60.2175564,36.6514419 C65.2678751,35.6994938 69.1358025,31.2267503 69.1358025,25.9439876 C69.1390247,20.180418 64.658786,15.4496745 58.9222012,15.0556111 L58.9225805,15.0553385 Z M58.6455839,43.4502086 C58.6455839,44.0504407 58.1592362,44.5377245 57.5601571,44.5377245 L11.5853543,44.5409546 C10.9862752,44.5409546 10.4999274,44.0536709 10.4999274,43.4534305 L10.4999274,37.9286947 C10.4999274,37.3284627 10.9862752,36.8411789 11.5853543,36.8411789 L57.5601571,36.8411789 C58.1592362,36.8411789 58.6455839,37.3284627 58.6455839,37.9286947 L58.6455839,43.4502086 Z M58.4491121,34.9658667 L57.5633893,34.9626365 L57.5408463,34.9626365 L9.04459464,34.7657866 C4.88643024,33.9138827 1.87817186,30.2156348 1.87817186,25.9394274 C1.87817186,20.9568798 5.91710751,16.9032315 10.8871158,16.9032315 L11.0127265,16.9032315 C11.4765313,16.9032315 11.8695079,16.5643865 11.940336,16.1061494 C12.951719,9.42615523 20.4405377,6.52140405 25.651642,9.83599769 C26.157317,10.1587001 26.8497837,9.92635965 27.0430563,9.33580153 C30.0416675,0.151728582 42.7703669,-0.823103304 47.060458,7.94170932 C47.2343869,8.29345841 47.6080033,8.50322075 47.9912833,8.46449184 C48.0879113,8.45480961 48.1941948,8.45803977 48.3004865,8.45803977 C52.7131045,8.45803977 56.5459047,11.7464451 57.2187308,16.1093961 C57.2895919,16.5676415 57.7823793,16.9064781 58.2429766,16.9064781 C63.2159533,16.9064781 67.261817,20.9596309 67.261817,25.9426741 C67.2650308,30.8026241 63.3097861,34.8458632 58.4491121,34.9658667 L58.4491121,34.9658667 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.317583,21.7283951 L11.8182195,21.7283951 C10.2021018,21.7283951 8.88888889,23.1042946 8.88888889,24.7973674 L8.88888889,30.5112745 C8.88888889,32.2044329 10.2021834,33.5802469 11.8182195,33.5802469 L57.317583,33.5802469 C58.9337007,33.5802469 60.2469136,32.2043474 60.2469136,30.5112745 L60.2469136,24.7973674 C60.2469136,23.1042091 58.9336191,21.7283951 57.317583,21.7283951 Z M58.3917851,30.5109326 C58.3917851,31.1320793 57.9104668,31.6363421 57.317583,31.6363421 L11.8182195,31.6363421 C11.2253356,31.6363421 10.7440174,31.1320793 10.7440174,30.5109326 L10.7440174,24.7970255 C10.7440174,24.1758787 11.2253356,23.6716159 11.8182195,23.6716159 L57.317583,23.6716159 C57.9200305,23.6716159 58.3917851,24.1658591 58.3917851,24.7970255 L58.3917851,30.5109326 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.282893,12.8057834 C48.3202415,12.809128 48.4017267,12.8158087 48.4390752,12.8158087 C50.8700722,12.8158087 52.9785182,14.5934212 53.3451365,16.952451 C53.4198334,17.433615 53.840836,17.7777778 54.3195692,17.7777778 C54.3705029,17.7777778 54.4180294,17.7744332 54.4689631,17.7677525 C55.0087993,17.6875584 55.3789029,17.1896884 55.2973916,16.6583806 C54.7847171,13.3637113 51.844418,10.8777397 48.564671,10.8777397 L48.5510945,10.8777397 L48.5069578,10.871059 C47.9637231,10.807571 47.4748118,11.1918351 47.4137088,11.7264618 C47.3525884,12.2644332 47.7430481,12.7455887 48.2828843,12.8057235 L48.282893,12.8057834 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2812737,11.8073015 C30.378775,11.8391197 30.4795211,11.8518519 30.5737693,11.8518519 C30.9735171,11.8518519 31.3407672,11.603652 31.473986,11.212262 C33.297216,5.75192973 41.0585481,5.20460128 43.6385592,10.3754254 C43.8693042,10.8368219 44.4348017,11.0245623 44.9027729,10.7986336 C45.3707441,10.5727048 45.5657717,10.0190388 45.3350183,9.56085181 C42.0102901,2.90086093 32.0331104,3.59139571 29.6769055,10.6395426 C29.5144089,11.1263953 29.7841578,11.6482594 30.2813985,11.8073504 L30.2812737,11.8073015 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.655201,17.7677444 C14.705407,17.7744305 14.7556215,17.7777778 14.8024856,17.7777778 C15.2744511,17.7777778 15.6895524,17.433339 15.7631604,16.951789 C16.2953748,13.4939606 20.2786148,11.7049061 23.1974861,13.5508049 C23.6493657,13.8383994 24.2519061,13.7012882 24.5397401,13.2498383 C24.8276084,12.7950411 24.6937171,12.196421 24.238487,11.9088607 C20.1213215,9.30378238 14.5751833,11.8252551 13.8382461,16.6574999 C13.7579114,17.1892081 14.1227638,17.6874604 14.6549782,17.7677615 L14.655201,17.7677444 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.308642,24.691358 C13.4039782,24.691358 11.8518519,26.2408474 11.8518519,28.1465024 C11.8518519,30.0520729 13.4006038,31.6049383 15.308642,31.6049383 C17.2133057,31.6049383 18.7654321,30.0554489 18.7654321,28.1465024 C18.7654321,26.2409318 17.2133901,24.691358 15.308642,24.691358 Z M15.308642,29.686117 C14.4584692,29.686117 13.76976,28.9970715 13.76976,28.1465024 C13.76976,27.2959248 14.4584776,26.6068877 15.308642,26.6068877 C16.1588148,26.6068877 16.8475239,27.2959332 16.8475239,28.1465024 C16.8475239,28.9937884 16.1555163,29.686117 15.308642,29.686117 Z",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2082308,24.691358 C21.3026602,24.691358 19.7530864,26.2408474 19.7530864,28.1465024 C19.7530864,30.0520729 21.3025758,31.6049383 23.2082308,31.6049383 C25.1138013,31.6049383 26.6666667,30.0554489 26.6666667,28.1465024 C26.6666667,26.2409318 25.1138857,24.691358 23.2082308,24.691358 Z M23.2082308,29.686117 C22.3576532,29.686117 21.6686161,28.9970715 21.6686161,28.1465024 C21.6686161,27.2959248 22.3576616,26.6068877 23.2082308,26.6068877 C24.0555167,26.6068877 24.7478454,27.2959332 24.7478454,28.1465024 C24.7478454,28.9937884 24.0555083,29.686117 23.2082308,29.686117 Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094653,24.691358 C29.2038947,24.691358 27.654321,26.2408474 27.654321,28.1465024 C27.654321,30.0520729 29.2038103,31.6049383 31.1094653,31.6049383 C33.0150359,31.6049383 34.5679012,30.0554489 34.5679012,28.1465024 C34.5679012,26.2409318 33.0151203,24.691358 31.1094653,24.691358 Z M31.1094653,29.686117 C30.2588878,29.686117 29.5698507,28.9970715 29.5698507,28.1465024 C29.5698507,27.2959248 30.2588962,26.6068877 31.1094653,26.6068877 C31.9600429,26.6068877 32.6490799,27.2959332 32.6490799,28.1465024 C32.6490799,28.9937884 31.9600345,29.686117 31.1094653,29.686117 Z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3663449,26.6666667 L38.4608156,26.6666667 C37.9462948,26.6666667 37.5308642,27.1078919 37.5308642,27.654321 C37.5308642,28.2007674 37.9463112,28.6419753 38.4608156,28.6419753 L55.3663449,28.6419753 C55.8808657,28.6419753 56.2962963,28.2007501 56.2962963,27.654321 C56.2962963,27.1078745 55.8776505,26.6666667 55.3663449,26.6666667 Z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.308642,37.5308642 C13.4039782,37.5308642 11.8518519,39.0803535 11.8518519,40.9893001 C11.8518519,42.8948707 13.4006038,44.4444444 15.308642,44.4444444 C17.2133057,44.4444444 18.7654321,42.8949551 18.7654321,40.9893001 C18.7654321,39.0804379 17.2133901,37.5308642 15.308642,37.5308642 Z M15.308642,42.5256231 C14.4584692,42.5256231 13.76976,41.8365777 13.76976,40.9860085 C13.76976,40.135431 14.4584776,39.4463939 15.308642,39.4463939 C16.1588148,39.4463939 16.8475239,40.1354394 16.8475239,40.9860085 C16.8475239,41.8365861 16.1555163,42.5256231 15.308642,42.5256231 Z",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2082308,37.5308642 C21.3026602,37.5308642 19.7530864,39.0803535 19.7530864,40.9893001 C19.7530864,42.8948707 21.3025758,44.4444444 23.2082308,44.4444444 C25.1138013,44.4444444 26.6666667,42.8949551 26.6666667,40.9893001 C26.6666667,39.0804379 25.1138857,37.5308642 23.2082308,37.5308642 Z M23.2082308,42.5256231 C22.3576532,42.5256231 21.6686161,41.8365777 21.6686161,40.9860085 C21.6686161,40.135431 22.3576616,39.4463939 23.2082308,39.4463939 C24.0555167,39.4463939 24.7478454,40.1354394 24.7478454,40.9860085 C24.7478454,41.8365861 24.0555083,42.5256231 23.2082308,42.5256231 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094653,37.5308642 C29.2038947,37.5308642 27.654321,39.0803535 27.654321,40.9893001 C27.654321,42.8948707 29.2038103,44.4444444 31.1094653,44.4444444 C33.0150359,44.4444444 34.5679012,42.8949551 34.5679012,40.9893001 C34.5679012,39.0837295 33.0151203,37.5308642 31.1094653,37.5308642 Z M31.1094653,42.5256231 C30.2588878,42.5256231 29.5698507,41.8365777 29.5698507,40.9860085 C29.5698507,40.135431 30.2588962,39.4463939 31.1094653,39.4463939 C31.9600429,39.4463939 32.6490799,40.1354394 32.6490799,40.9860085 C32.6490799,41.8365861 31.9600345,42.5256231 31.1094653,42.5256231 Z",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3663449,40.4938272 L38.4608156,40.4938272 C37.9462948,40.4938272 37.5308642,40.9350524 37.5308642,41.4814815 C37.5308642,42.0279279 37.9463112,42.4691358 38.4608156,42.4691358 L55.3663449,42.4691358 C55.8808657,42.4691358 56.2962963,42.0279106 56.2962963,41.4814815 C56.2962963,40.935035 55.8776505,40.4938272 55.3663449,40.4938272 Z",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.308642,50.3703704 C13.4039782,50.3703704 11.8518519,51.9191224 11.8518519,53.8271605 C11.8518519,55.7318243 13.4006038,57.2839506 15.308642,57.2839506 C17.2133057,57.2839506 18.7654321,55.7351986 18.7654321,53.8271605 C18.7654321,51.9192067 17.2133901,50.3703704 15.308642,50.3703704 Z M15.308642,55.3627524 C14.4584692,55.3627524 13.76976,54.6740348 13.76976,53.8238705 C13.76976,52.9736977 14.4584776,52.2849885 15.308642,52.2849885 C16.1588148,52.2849885 16.8475239,52.9737061 16.8475239,53.8238705 C16.8475239,54.6740433 16.1555163,55.3627524 15.308642,55.3627524 Z",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2082308,50.3703704 C21.3026602,50.3703704 19.7530864,51.9191224 19.7530864,53.8271605 C19.7530864,55.7318243 21.3025758,57.2839506 23.2082308,57.2839506 C25.1138013,57.2839506 26.6666667,55.7351986 26.6666667,53.8271605 C26.6666667,51.9192067 25.1138857,50.3703704 23.2082308,50.3703704 Z M23.2082308,55.3627524 C22.3576532,55.3627524 21.6686161,54.6740348 21.6686161,53.8238705 C21.6686161,52.9736977 22.3576616,52.2849885 23.2082308,52.2849885 C24.0555167,52.2849885 24.7478454,52.9737061 24.7478454,53.8238705 C24.7478454,54.6740433 24.0555083,55.3627524 23.2082308,55.3627524 Z",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094653,50.3703704 C29.2038947,50.3703704 27.654321,51.9191224 27.654321,53.8271605 C27.654321,55.7318243 29.2038103,57.2839506 31.1094653,57.2839506 C33.0150359,57.2839506 34.5679012,55.7351986 34.5679012,53.8271605 C34.5679012,51.9192067 33.0151203,50.3703704 31.1094653,50.3703704 Z M31.1094653,55.3627524 C30.2588878,55.3627524 29.5698507,54.6740348 29.5698507,53.8238705 C29.5698507,52.9736977 30.2588962,52.2849885 31.1094653,52.2849885 C31.9600429,52.2849885 32.6490799,52.9737061 32.6490799,53.8238705 C32.6490799,54.6740433 31.9600345,55.3627524 31.1094653,55.3627524 Z",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3663449,53.3333333 L38.4608156,53.3333333 C37.9462948,53.3333333 37.5308642,53.7745586 37.5308642,54.3209877 C37.5308642,54.8674341 37.9463112,55.308642 38.4608156,55.308642 L55.3663449,55.308642 C55.8808657,55.308642 56.2962963,54.8674167 56.2962963,54.3209877 C56.2962963,53.7779385 55.8776505,53.3333333 55.3663449,53.3333333 Z",
    id: "Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2757927,73.4907082 L49.0100453,73.4907082 L49.0100453,72.6603587 C49.0100453,72.1481331 48.5884201,71.7345555 48.0662644,71.7345555 L39.2735841,71.7345555 L39.2735841,67.5190436 C39.2735841,67.0068179 38.8519589,66.5932404 38.3298033,66.5932404 L37.4865694,66.5932404 L37.4865694,59.6893399 L58.2079029,59.6893399 C59.8522752,59.6893399 61.1884471,58.3785387 61.1884471,56.7655707 L61.1884471,51.3188309 C61.1884471,49.7057815 59.8521922,48.3950617 58.2079029,48.3950617 L11.9163925,48.3950617 C10.2720201,48.3950617 8.93584825,49.7058629 8.93584825,51.3188309 L8.93584825,56.7655707 C8.93584825,58.3786201 10.2721032,59.6893399 11.9163925,59.6893399 L32.6310837,59.6893399 L32.6310837,66.5932404 L31.7943261,66.5932404 C31.2721538,66.5932404 30.8505452,67.0068342 30.8505452,67.5190436 L30.8505452,71.7345555 L22.0578649,71.7345555 C21.5356926,71.7345555 21.114084,72.1481493 21.114084,72.6603587 L21.114084,73.4907082 L8.84501546,73.4907082 C8.32284317,73.4907082 7.90123457,73.904302 7.90123457,74.4165114 L7.90123457,77.3180457 C7.90123457,77.8302714 8.32285978,78.2438489 8.84501546,78.2438489 L21.114084,78.2438489 L21.114084,79.0741968 C21.114084,79.5864224 21.5357092,80 22.0578649,80 L48.0689213,79.9968187 C48.5910936,79.9968187 49.0127022,79.5832248 49.0127022,79.0710155 L49.0127022,78.2406676 L61.2784413,78.2406676 C61.8006136,78.2406676 62.2222222,77.8270738 62.2222222,77.3148644 L62.2222222,74.4133301 C62.2189841,73.904289 61.7973506,73.4907033 61.2752032,73.4907033 L61.2757927,73.4907082 Z M10.8195907,56.7656521 L10.8195907,51.3189124 C10.8195907,50.7271541 11.3093239,50.2467496 11.9125732,50.2467496 L58.2074047,50.2467496 C58.810654,50.2467496 59.3003872,50.7271541 59.3003872,51.3189124 L59.3003872,56.7656521 C59.3003872,57.3574104 58.810654,57.8378149 58.2074047,57.8378149 L11.915886,57.8378149 C11.3126368,57.8378149 10.8195907,57.3574104 10.8195907,56.7656521 L10.8195907,56.7656521 Z M34.5183134,59.6926792 L35.6015815,59.6926792 L35.6015815,66.5934033 L34.5183134,66.5934033 L34.5183134,59.6926792 Z M9.78838121,76.3892289 L9.78838121,75.3393011 L21.1142501,75.3393011 L21.1142501,76.3892289 L9.78838121,76.3892289 Z M47.1253065,78.14538 L23.0014798,78.14538 L23.0014798,73.5830686 L31.79416,73.5830686 C32.3163323,73.5830686 32.7379409,73.1694747 32.7379409,72.6572637 L32.7379409,68.4417519 L37.3888453,68.4417519 L37.3888453,72.6572637 C37.3888453,73.169491 37.8104705,73.5830686 38.3326262,73.5830686 L47.1253065,73.5830686 L47.1253065,78.14538 Z M60.3317628,76.3892289 L49.009215,76.3892289 L49.009215,75.3393011 L60.3317628,75.3393011 L60.3317628,76.3892289 Z",
    id: "Fill-18"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#2e5668",
    strokeWidth: 4,
    cx: 577,
    cy: 80,
    r: 80
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#2e5668",
    x: 0,
    y: 318,
    width: 800,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#2e5668",
    x: 0,
    y: 0,
    width: 800,
    height: 4
  }), /*#__PURE__*/React.createElement("text", {
    id: "APPLICATION-BUILDER",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "APPLICATION BUILDER")), /*#__PURE__*/React.createElement("text", {
    id: "DEEP-LEARNING-ENGINE",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 361
  }, "DEEP LEARNING ENGINE")), /*#__PURE__*/React.createElement("g", {
    id: "dori_workflow",
    transform: "translate(13.000000, 402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_workflow_step1-1-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_mock_sample"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-45-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133,-2 L5,-2 C3.06700338,-2 1.31700338,-1.21649831 0.0502525317,0.0502525317 C-1.21649831,1.31700338 -2,3.06700338 -2,5 L-2,94.5024876 C-2,96.4354842 -1.21649831,98.1854842 0.0502525317,99.452235 C1.31700338,100.718986 3.06700338,101.502488 5,101.502488 L133,101.502488 C134.932997,101.502488 136.682997,100.718986 137.949747,99.452235 C139.216498,98.1854842 140,96.4354842 140,94.5024876 L140,5 C140,3.06700338 139.216498,1.31700338 137.949747,0.0502525317 C136.682997,-1.21649831 134.932997,-2 133,-2 Z",
    id: "Rectangle-10",
    stroke: "#2E5668",
    strokeWidth: 4,
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91727409,89.6679394 L133.082726,89.6679394 C135.798461,89.6679394 138,91.869478 138,94.5852135 C138,97.300949 135.798461,99.5024876 133.082726,99.5024876 L4.91727409,99.5024876 C2.2015386,99.5024876 3.32581678e-16,97.300949 0,94.5852135 C-3.32581678e-16,91.869478 2.2015386,89.6679394 4.91727409,89.6679394 Z",
    id: "Rectangle-10",
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enter-Text",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 12,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.032,
    y: 102.049751
  }, "Annotate"))), /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_benchmark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "benchmark_deploy_monitor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 138,
    height: 90.0497512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#151524",
    fillRule: "nonzero",
    x: 0,
    y: 17.4009181,
    width: 17.7407798,
    height: 72.6488331
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/eval_targets",
    transform: "translate(4.217071, 62.498298)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/file/cloud_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-2)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.23498419,
    height: 5.22027543
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/hardware/devices_other_24px",
    transform: "translate(1.744995, 1.740092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-4)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 6.97997893,
    height: 6.96036725
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/maps/category_24px",
    transform: "translate(4.217071, 49.447609)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-6)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/home_24px",
    transform: "translate(4.217071, 24.651301)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-8)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24",
    transform: "translate(4.217071, 37.701989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 1.97651733,
    x2: 3.45363541,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 7.00765235,
    x2: 3.45363541,
    y2: 6.28891878,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 6.648286) scale(1, -1) translate(-2.544784, -6.648286) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 5.5701852,
    x2: 3.45363541,
    y2: 4.49208484,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 3.77335127,
    x2: 3.45363541,
    y2: 2.6952509,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 3.234301) scale(1, -1) translate(-2.544784, -3.234301) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 3.41398448,
    x2: 7.0890411,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(5.998419, 2.335884) scale(1, -1) translate(-5.998419, -2.335884) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 7.00765235,
    x2: 7.0890411,
    y2: 4.85145163,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 4.13271805,
    x2: 6.72550053,
    y2: 4.13271805,
    id: "Line-2",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 5.21081841,
    x2: 3.45363541,
    y2: 1.61715054,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 6.64828556,
    x2: 3.45363541,
    y2: 3.05461769,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.181243, 4.851452) scale(1, -1) translate(-2.181243, -4.851452) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 7.36701914,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 5.92955199,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 0.898416968,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 7.81612223,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 2.33588412,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#25829A",
    x: 0,
    y: 0,
    width: 17.7407798,
    height: 17.4009181
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    transform: "translate(4.944152, 75.548986)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Path",
    stroke: "#979797",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-140",
    fill: "#25829A",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px",
    transform: "translate(0.727081, 0.725038)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-10)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.96206533,
    height: 5.94531369
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DoriIcon300_gray",
    transform: "translate(2.908325, 3.190168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ropesegment_gray"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 6.168236) rotate(8.999732) translate(-9.917986, -6.168236) translate(8.848605, 4.975710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 6.826181) rotate(18.000102) translate(-9.750240, -6.826181) translate(8.680859, 5.633655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 7.443005) rotate(26.999884) translate(-9.498621, -7.443005) translate(8.429240, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 8.018707) rotate(36.000119) translate(-9.121192, -8.018707) translate(8.051811, 6.826181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.701827, 8.553287) rotate(45.000000) translate(-8.701827, -8.553287) translate(7.632446, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 8.964503) rotate(53.999881) translate(-8.156652, -8.964503) translate(7.087271, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 9.334597) rotate(63.000116) translate(-7.569541, -9.334597) translate(6.500160, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 9.581326) rotate(71.999898) translate(-6.940493, -9.581326) translate(5.871112, 8.388801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 9.745813) rotate(81.000268) translate(-6.269509, -9.745813) translate(5.200128, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.598525, 9.786934) rotate(90.000000) translate(-5.598525, -9.786934) translate(4.529144, 8.594409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 9.745813) rotate(98.999732) translate(-4.885604, -9.745813) translate(3.816223, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.256556, 9.622448) rotate(108.000102) translate(-4.256556, -9.622448) translate(3.187175, 8.429922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.627509, 9.334597) rotate(116.999884) translate(-3.627509, -9.334597) translate(2.558127, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 8.964503) rotate(126.000119) translate(-2.998461, -8.964503) translate(1.929080, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.495223, 8.553287) rotate(135.000000) translate(-2.495223, -8.553287) translate(1.425842, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 8.059828) rotate(143.999881) translate(-2.075857, -8.059828) translate(1.006476, 6.867303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.698429, 7.443005) rotate(153.000116) translate(-1.698429, -7.443005) translate(0.629048, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 6.867303) rotate(161.999898) translate(-1.404873, -6.867303) translate(0.335492, 5.674777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 6.209357) rotate(171.000268) translate(-1.279064, -6.209357) translate(0.209683, 5.016832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.195191, 5.510291) rotate(-180.000000) translate(-1.195191, -5.510291) translate(0.125810, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 4.852346) rotate(-171.000268) translate(-1.279064, -4.852346) translate(0.209683, 3.659820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 4.194400) rotate(-161.999898) translate(-1.404873, -4.194400) translate(0.335492, 3.001875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.656492, 3.577577) rotate(-153.000116) translate(-1.656492, -3.577577) translate(0.587111, 2.385051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 3.001875) rotate(-143.999881) translate(-2.075857, -3.001875) translate(1.006476, 1.809349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.453286, 2.467294) rotate(-135.000000) translate(-2.453286, -2.467294) translate(1.383905, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 2.056079) rotate(-126.000119) translate(-2.998461, -2.056079) translate(1.929080, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.585572, 1.685984) rotate(-116.999884) translate(-3.585572, -1.685984) translate(2.516191, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.214620, 1.439255) rotate(-108.000102) translate(-4.214620, -1.439255) translate(3.145239, 0.246729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 1.274769) rotate(-98.999732) translate(-4.885604, -1.274769) translate(3.816223, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.556588, 1.233647) rotate(-90.000000) translate(-5.556588, -1.233647) translate(4.487207, 0.041122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 1.274769) rotate(-81.000268) translate(-6.269509, -1.274769) translate(5.200128, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 1.398133) rotate(-71.999898) translate(-6.940493, -1.398133) translate(5.871112, 0.205608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 1.685984) rotate(-63.000116) translate(-7.569541, -1.685984) translate(6.500160, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 2.056079) rotate(-53.999881) translate(-8.156652, -2.056079) translate(7.087271, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.659890, 2.467294) rotate(-45.000000) translate(-8.659890, -2.467294) translate(7.590509, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 2.960753) rotate(-36.000119) translate(-9.121192, -2.960753) translate(8.051811, 1.768228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 3.536455) rotate(-26.999884) translate(-9.498621, -3.536455) translate(8.429240, 2.343930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 4.153279) rotate(-18.000102) translate(-9.750240, -4.153279) translate(8.680859, 2.960753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 4.811224) rotate(-8.999732) translate(-9.917986, -4.811224) translate(8.848605, 3.618698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(21.165644, 4.237288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-15)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-17)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-8",
    transform: "translate(21.165644, 33.898305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-19)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-21)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-5",
    transform: "translate(49.950920, 4.237288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-23)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-25)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-9",
    transform: "translate(49.950920, 33.898305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-27)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-29)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-6",
    transform: "translate(79.582822, 4.237288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-31)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-33)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-10",
    transform: "translate(79.582822, 33.898305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-35)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-37)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-7",
    transform: "translate(108.368098, 4.237288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-39)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/check_green",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-40"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-41)",
    fill: "#25829A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-4",
    transform: "translate(108.368098, 62.711864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-43)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/x_red",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#B00020",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/highlight_off_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-44"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-45)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-12",
    transform: "translate(79.582822, 62.711864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-47",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-47)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.8110429,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/x_red",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#B00020",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/highlight_off_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-49",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-49)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-13",
    transform: "translate(49.950920, 62.711864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-51",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-51)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/x_red",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#B00020",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/highlight_off_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-53",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-53)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-14",
    transform: "translate(21.165644, 62.711864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-55",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-55)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/x_red",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#B00020",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/highlight_off_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-57",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-56"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-57)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-11",
    transform: "translate(108.368098, 33.898305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(3.047853, 2.457627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-59",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-58"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-59)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.745957,
    height: 19.1694915
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/x_red",
    transform: "translate(19.811043, 19.169492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    fill: "#B00020",
    fillRule: "nonzero",
    cx: 2.5398773,
    cy: 2.45762712,
    rx: 2.11656442,
    ry: 2.0480226
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/highlight_off_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-61",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-61)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.0797546,
    height: 4.91525424
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 24.398773,
    height: 23.5762712
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dori_workflow_step2-copy",
    transform: "translate(212.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_mock_sample"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-45-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133,-2 L5,-2 C3.06700338,-2 1.31700338,-1.21649831 0.0502525317,0.0502525317 C-1.21649831,1.31700338 -2,3.06700338 -2,5 L-2,95.4975124 C-2,97.4305091 -1.21649831,99.1805091 0.0502525317,100.44726 C1.31700338,101.714011 3.06700338,102.497512 5,102.497512 L133,102.497512 C134.932997,102.497512 136.682997,101.714011 137.949747,100.44726 C139.216498,99.1805091 140,97.4305091 140,95.4975124 L140,5 C140,3.06700338 139.216498,1.31700338 137.949747,0.0502525317 C136.682997,-1.21649831 134.932997,-2 133,-2 Z",
    id: "Rectangle-10",
    stroke: "#2E5668",
    strokeWidth: 4,
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96644684,90.5646188 L133.033553,90.5646188 C135.776446,90.5646188 138,92.7881728 138,95.5310656 C138,98.2739585 135.776446,100.497512 133.033553,100.497512 L4.96644684,100.497512 C2.22355399,100.497512 3.35907495e-16,98.2739585 0,95.5310656 C-3.35907495e-16,92.7881728 2.22355399,90.5646188 4.96644684,90.5646188 Z",
    id: "Rectangle-10",
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enter-Text",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 12,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.69,
    y: 102.950249
  }, "Train &amp; Benchmark"))), /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_benchmark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "benchmark_deploy_monitor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 138,
    height: 90.9502488
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#151524",
    fillRule: "nonzero",
    x: 0,
    y: 17.5749273,
    width: 17.7407798,
    height: 73.3753215
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/eval_targets",
    transform: "translate(4.217071, 63.123281)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/file/cloud_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-63",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-62"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-63)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.23498419,
    height: 5.27247819
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/hardware/devices_other_24px",
    transform: "translate(1.744995, 1.757493)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-65",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-64"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-65)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 6.97997893,
    height: 7.02997092
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/maps/category_24px",
    transform: "translate(4.217071, 49.942085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-67",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-66"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-67)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.78746365
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/home_24px",
    transform: "translate(4.217071, 24.897814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-69",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-68"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-69)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.78746365
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24",
    transform: "translate(4.217071, 38.079009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 1.9962825,
    x2: 3.45363541,
    y2: 1.27036159,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 7.07772887,
    x2: 3.45363541,
    y2: 6.35180796,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 6.714768) scale(1, -1) translate(-2.544784, -6.714768) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 5.62588705,
    x2: 3.45363541,
    y2: 4.53700569,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 3.81108478,
    x2: 3.45363541,
    y2: 2.72220341,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 3.266644) scale(1, -1) translate(-2.544784, -3.266644) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 3.44812432,
    x2: 7.0890411,
    y2: 1.27036159,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(5.998419, 2.359243) scale(1, -1) translate(-5.998419, -2.359243) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 7.07772887,
    x2: 7.0890411,
    y2: 4.89996614,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 4.17404523,
    x2: 6.72550053,
    y2: 4.17404523,
    id: "Line-2",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 5.2629266,
    x2: 3.45363541,
    y2: 1.63332205,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 6.71476842,
    x2: 3.45363541,
    y2: 3.08516387,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.181243, 4.899966) scale(1, -1) translate(-2.181243, -4.899966) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 7.44068933,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 5.98884751,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 0.907401138,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 7.81612223,
    cy: 4.17404523,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 2.35924296,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 4.17404523,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#25829A",
    x: 0,
    y: 0,
    width: 17.7407798,
    height: 17.5749273
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    transform: "translate(4.944152, 76.304476)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Path",
    stroke: "#979797",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    cx: 3.7081138,
    cy: 3.73467205,
    rx: 3.7081138,
    ry: 3.73467205
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-140",
    fill: "#25829A",
    cx: 3.7081138,
    cy: 3.73467205,
    rx: 3.7081138,
    ry: 3.73467205
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px",
    transform: "translate(0.727081, 0.732289)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-71",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-70"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-71)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.96206533,
    height: 6.00476683
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DoriIcon300_gray",
    transform: "translate(2.908325, 3.222070)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ropesegment_gray"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.360943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.360943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 6.229918) rotate(8.999732) translate(-9.917986, -6.229918) translate(8.848605, 5.025467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 6.894443) rotate(18.000102) translate(-9.750240, -6.894443) translate(8.680859, 5.689992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 7.517435) rotate(26.999884) translate(-9.498621, -7.517435) translate(8.429240, 6.312984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 8.098894) rotate(36.000119) translate(-9.121192, -8.098894) translate(8.051811, 6.894443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.701827, 8.638820) rotate(45.000000) translate(-8.701827, -8.638820) translate(7.632446, 7.434369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 9.054148) rotate(53.999881) translate(-8.156652, -9.054148) translate(7.087271, 7.849697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 9.427943) rotate(63.000116) translate(-7.569541, -9.427943) translate(6.500160, 8.223492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 9.677140) rotate(71.999898) translate(-6.940493, -9.677140) translate(5.871112, 8.472689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 9.843271) rotate(81.000268) translate(-6.269509, -9.843271) translate(5.200128, 8.638820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.598525, 9.884804) rotate(90.000000) translate(-5.598525, -9.884804) translate(4.529144, 8.680353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 9.843271) rotate(98.999732) translate(-4.885604, -9.843271) translate(3.816223, 8.638820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.256556, 9.718672) rotate(108.000102) translate(-4.256556, -9.718672) translate(3.187175, 8.514222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.627509, 9.427943) rotate(116.999884) translate(-3.627509, -9.427943) translate(2.558127, 8.223492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 9.054148) rotate(126.000119) translate(-2.998461, -9.054148) translate(1.929080, 7.849697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.495223, 8.638820) rotate(135.000000) translate(-2.495223, -8.638820) translate(1.425842, 7.434369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 8.140427) rotate(143.999881) translate(-2.075857, -8.140427) translate(1.006476, 6.935976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.698429, 7.517435) rotate(153.000116) translate(-1.698429, -7.517435) translate(0.629048, 6.312984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 6.935976) rotate(161.999898) translate(-1.404873, -6.935976) translate(0.335492, 5.731525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 6.271451) rotate(171.000268) translate(-1.279064, -6.271451) translate(0.209683, 5.067000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.195191, 5.565394) rotate(-180.000000) translate(-1.195191, -5.565394) translate(0.125810, 4.360943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 4.900869) rotate(-171.000268) translate(-1.279064, -4.900869) translate(0.209683, 3.696418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 4.236344) rotate(-161.999898) translate(-1.404873, -4.236344) translate(0.335492, 3.031894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.656492, 3.613353) rotate(-153.000116) translate(-1.656492, -3.613353) translate(0.587111, 2.408902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 3.031894) rotate(-143.999881) translate(-2.075857, -3.031894) translate(1.006476, 1.827443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.453286, 2.491967) rotate(-135.000000) translate(-2.453286, -2.491967) translate(1.383905, 1.287516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 2.076639) rotate(-126.000119) translate(-2.998461, -2.076639) translate(1.929080, 0.872189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.585572, 1.702844) rotate(-116.999884) translate(-3.585572, -1.702844) translate(2.516191, 0.498393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.214620, 1.453648) rotate(-108.000102) translate(-4.214620, -1.453648) translate(3.145239, 0.249197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 1.287516) rotate(-98.999732) translate(-4.885604, -1.287516) translate(3.816223, 0.083066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.556588, 1.245984) rotate(-90.000000) translate(-5.556588, -1.245984) translate(4.487207, 0.041533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 1.287516) rotate(-81.000268) translate(-6.269509, -1.287516) translate(5.200128, 0.083066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 1.412115) rotate(-71.999898) translate(-6.940493, -1.412115) translate(5.871112, 0.207664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 1.702844) rotate(-63.000116) translate(-7.569541, -1.702844) translate(6.500160, 0.498393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 2.076639) rotate(-53.999881) translate(-8.156652, -2.076639) translate(7.087271, 0.872189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.659890, 2.491967) rotate(-45.000000) translate(-8.659890, -2.491967) translate(7.590509, 1.287516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 2.990361) rotate(-36.000119) translate(-9.121192, -2.990361) translate(8.051811, 1.785910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 3.571820) rotate(-26.999884) translate(-9.498621, -3.571820) translate(8.429240, 2.367369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 4.194812) rotate(-18.000102) translate(-9.750240, -4.194812) translate(8.680859, 2.990361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 4.859336) rotate(-8.999732) translate(-9.917986, -4.859336) translate(8.848605, 3.654885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.3825614 C0.00910111604,2.3825614 -0.103950672,1.85237789 0.947926741,0.984227717 C1.84800436,0.241362948 1.92079054,-0.00702408728 1.93141609,0.0230309016 C2.24301555,0.903630818 2.26349306,0.820760096 0.898166389,1.67069717 C0.100362557,2.16733616 0.00910111604,2.3825614 0.00910111604,2.3825614 L0.00910111604,2.3825614 Z",
    id: "Shape",
    fill: "url(#radialGradient-74)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/settings_24px",
    transform: "translate(108.368098, 28.008403)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-76)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24.5521472,
    height: 25.4621849
  }))))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#2E5668",
    points: "80.4294479 39.8907563 100.748466 39.8907563 100.748466 41.5882353 80.4294479 41.5882353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3",
    fill: "#2E5668",
    transform: "translate(102.441718, 40.739496) scale(1, -1) rotate(90.000000) translate(-102.441718, -40.739496) ",
    points: "102.441718 39.0462443 104.987936 42.4327473 99.8954993 42.4327473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3-Copy",
    fill: "#2E5668",
    transform: "translate(79.582822, 40.739496) scale(-1, -1) rotate(90.000000) translate(-79.582822, -40.739496) ",
    points: "79.5828221 39.0462443 82.1290406 42.4327473 77.0366036 42.4327473"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(23.705521, 19.521008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 23.9754601,
    height: 24.0378151
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(2.997055, 3.004538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-78",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-77"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-78)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.4168578,
    height: 19.5294958
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(12.487730, 12.518908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 23.9754601,
    height: 24.0378151
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(2.997055, 3.004538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-80",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-79"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-80)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.4168578,
    height: 19.5294958
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(24.975460, 25.037815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 23.9754601,
    height: 24.0378151
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(2.997055, 3.004538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-81"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-82)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 19.4168578,
    height: 19.5294958
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "dori_workflow_step3-copy",
    transform: "translate(425.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_mock_sample"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-45-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133,-2 L5,-2 C3.06700338,-2 1.31700338,-1.21649831 0.0502525317,0.0502525317 C-1.21649831,1.31700338 -2,3.06700338 -2,5 L-2,94.5024876 C-2,96.4354842 -1.21649831,98.1854842 0.0502525317,99.452235 C1.31700338,100.718986 3.06700338,101.502488 5,101.502488 L133,101.502488 C134.932997,101.502488 136.682997,100.718986 137.949747,99.452235 C139.216498,98.1854842 140,96.4354842 140,94.5024876 L140,5 C140,3.06700338 139.216498,1.31700338 137.949747,0.0502525317 C136.682997,-1.21649831 134.932997,-2 133,-2 Z",
    id: "Rectangle-10",
    stroke: "#2E5668",
    strokeWidth: 4,
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91727409,89.6679394 L133.082726,89.6679394 C135.798461,89.6679394 138,91.869478 138,94.5852135 C138,97.300949 135.798461,99.5024876 133.082726,99.5024876 L4.91727409,99.5024876 C2.2015386,99.5024876 3.32581678e-16,97.300949 0,94.5852135 C-3.32581678e-16,91.869478 2.2015386,89.6679394 4.91727409,89.6679394 Z",
    id: "Rectangle-10",
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enter-Text",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 12,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47.214,
    y: 102.049751
  }, "Deploy"))), /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_benchmark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "benchmark_deploy_monitor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 138,
    height: 90.0497512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#151524",
    fillRule: "nonzero",
    x: 0,
    y: 17.4009181,
    width: 17.7407798,
    height: 72.6488331
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/eval_targets",
    transform: "translate(4.217071, 62.498298)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/file/cloud_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-84",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-83"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-84)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.23498419,
    height: 5.22027543
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/hardware/devices_other_24px",
    transform: "translate(1.744995, 1.740092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-86",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-85"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-86)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 6.97997893,
    height: 6.96036725
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/maps/category_24px",
    transform: "translate(4.217071, 49.447609)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-87"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-88)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/home_24px",
    transform: "translate(4.217071, 24.651301)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-90",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-89"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-90)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24",
    transform: "translate(4.217071, 37.701989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 1.97651733,
    x2: 3.45363541,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 7.00765235,
    x2: 3.45363541,
    y2: 6.28891878,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 6.648286) scale(1, -1) translate(-2.544784, -6.648286) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 5.5701852,
    x2: 3.45363541,
    y2: 4.49208484,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 3.77335127,
    x2: 3.45363541,
    y2: 2.6952509,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 3.234301) scale(1, -1) translate(-2.544784, -3.234301) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 3.41398448,
    x2: 7.0890411,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(5.998419, 2.335884) scale(1, -1) translate(-5.998419, -2.335884) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 7.00765235,
    x2: 7.0890411,
    y2: 4.85145163,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 4.13271805,
    x2: 6.72550053,
    y2: 4.13271805,
    id: "Line-2",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 5.21081841,
    x2: 3.45363541,
    y2: 1.61715054,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 6.64828556,
    x2: 3.45363541,
    y2: 3.05461769,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.181243, 4.851452) scale(1, -1) translate(-2.181243, -4.851452) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 7.36701914,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 5.92955199,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 0.898416968,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 7.81612223,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 2.33588412,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#25829A",
    x: 0,
    y: 0,
    width: 17.7407798,
    height: 17.4009181
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    transform: "translate(4.944152, 75.548986)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Path",
    stroke: "#979797",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-140",
    fill: "#25829A",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px",
    transform: "translate(0.727081, 0.725038)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-92",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-91"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-92)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.96206533,
    height: 5.94531369
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DoriIcon300_gray",
    transform: "translate(2.908325, 3.190168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ropesegment_gray"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 6.168236) rotate(8.999732) translate(-9.917986, -6.168236) translate(8.848605, 4.975710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 6.826181) rotate(18.000102) translate(-9.750240, -6.826181) translate(8.680859, 5.633655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 7.443005) rotate(26.999884) translate(-9.498621, -7.443005) translate(8.429240, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 8.018707) rotate(36.000119) translate(-9.121192, -8.018707) translate(8.051811, 6.826181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.701827, 8.553287) rotate(45.000000) translate(-8.701827, -8.553287) translate(7.632446, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 8.964503) rotate(53.999881) translate(-8.156652, -8.964503) translate(7.087271, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 9.334597) rotate(63.000116) translate(-7.569541, -9.334597) translate(6.500160, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 9.581326) rotate(71.999898) translate(-6.940493, -9.581326) translate(5.871112, 8.388801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 9.745813) rotate(81.000268) translate(-6.269509, -9.745813) translate(5.200128, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.598525, 9.786934) rotate(90.000000) translate(-5.598525, -9.786934) translate(4.529144, 8.594409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 9.745813) rotate(98.999732) translate(-4.885604, -9.745813) translate(3.816223, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.256556, 9.622448) rotate(108.000102) translate(-4.256556, -9.622448) translate(3.187175, 8.429922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.627509, 9.334597) rotate(116.999884) translate(-3.627509, -9.334597) translate(2.558127, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 8.964503) rotate(126.000119) translate(-2.998461, -8.964503) translate(1.929080, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.495223, 8.553287) rotate(135.000000) translate(-2.495223, -8.553287) translate(1.425842, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 8.059828) rotate(143.999881) translate(-2.075857, -8.059828) translate(1.006476, 6.867303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.698429, 7.443005) rotate(153.000116) translate(-1.698429, -7.443005) translate(0.629048, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 6.867303) rotate(161.999898) translate(-1.404873, -6.867303) translate(0.335492, 5.674777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 6.209357) rotate(171.000268) translate(-1.279064, -6.209357) translate(0.209683, 5.016832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.195191, 5.510291) rotate(-180.000000) translate(-1.195191, -5.510291) translate(0.125810, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 4.852346) rotate(-171.000268) translate(-1.279064, -4.852346) translate(0.209683, 3.659820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 4.194400) rotate(-161.999898) translate(-1.404873, -4.194400) translate(0.335492, 3.001875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.656492, 3.577577) rotate(-153.000116) translate(-1.656492, -3.577577) translate(0.587111, 2.385051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 3.001875) rotate(-143.999881) translate(-2.075857, -3.001875) translate(1.006476, 1.809349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.453286, 2.467294) rotate(-135.000000) translate(-2.453286, -2.467294) translate(1.383905, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 2.056079) rotate(-126.000119) translate(-2.998461, -2.056079) translate(1.929080, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.585572, 1.685984) rotate(-116.999884) translate(-3.585572, -1.685984) translate(2.516191, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.214620, 1.439255) rotate(-108.000102) translate(-4.214620, -1.439255) translate(3.145239, 0.246729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 1.274769) rotate(-98.999732) translate(-4.885604, -1.274769) translate(3.816223, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.556588, 1.233647) rotate(-90.000000) translate(-5.556588, -1.233647) translate(4.487207, 0.041122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 1.274769) rotate(-81.000268) translate(-6.269509, -1.274769) translate(5.200128, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 1.398133) rotate(-71.999898) translate(-6.940493, -1.398133) translate(5.871112, 0.205608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 1.685984) rotate(-63.000116) translate(-7.569541, -1.685984) translate(6.500160, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 2.056079) rotate(-53.999881) translate(-8.156652, -2.056079) translate(7.087271, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.659890, 2.467294) rotate(-45.000000) translate(-8.659890, -2.467294) translate(7.590509, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 2.960753) rotate(-36.000119) translate(-9.121192, -2.960753) translate(8.051811, 1.768228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 3.536455) rotate(-26.999884) translate(-9.498621, -3.536455) translate(8.429240, 2.343930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 4.153279) rotate(-18.000102) translate(-9.750240, -4.153279) translate(8.680859, 2.960753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 4.811224) rotate(-8.999732) translate(-9.917986, -4.811224) translate(8.848605, 3.618698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24_blue",
    transform: "translate(34.711656, 7.627119)",
    fill: "#2E5668",
    stroke: "#2E5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24_green"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 4.64083939,
    x2: 8.04294479,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 16.4538851,
    x2: 8.04294479,
    y2: 14.7663071,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 15.610096) scale(1, -1) translate(-5.926380, -15.610096) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 13.0787292,
    x2: 8.04294479,
    y2: 10.5473622,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 8.85978428,
    x2: 8.04294479,
    y2: 6.32841735,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 7.594101) scale(1, -1) translate(-5.926380, -7.594101) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 8.0159953,
    x2: 16.5092025,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(13.969325, 5.484628) scale(1, -1) translate(-13.969325, -5.484628) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 16.4538851,
    x2: 16.5092025,
    y2: 11.3911512,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 9.70357326,
    x2: 15.6625767,
    y2: 9.70357326,
    id: "Line-2",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 12.2349402,
    x2: 8.04294479,
    y2: 3.79705041,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 15.6100961,
    x2: 8.04294479,
    y2: 7.17220632,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.079755, 11.391151) scale(1, -1) translate(-5.079755, -11.391151) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 17.2976741,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 13.9225182,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 2.10947245,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 18.202454,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 5.48462837,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(62.650307, 15.254237)",
    fill: "#2E5668"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 1.52542373 19.8773006 1.52542373 19.8773006 3.55932203 0 3.55932203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3",
    transform: "translate(21.368098, 2.542373) scale(1, -1) rotate(90.000000) translate(-21.368098, -2.542373) ",
    points: "21.3680982 1.05157534 23.910471 4.03317043 18.8257253 4.03317043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Rocket_1941065",
    transform: "translate(98.208589, 7.627119)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1485685,14.7082998 C10.3501353,15.0541545 9.54063838,15.3485867 8.75280793,15.5870398 L10.3690359,19.3853663 C10.4162873,19.4966733 10.5347615,19.5255307 10.6320302,19.4476375 C14.2480291,16.5577763 14.0654774,13.1942634 14.0654774,13.1942634 C13.0049718,13.8456158 11.9926397,14.3431345 11.1485685,14.7082998 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52600888,15.6255811 C6.0459354,16.0863384 5.49519794,16.018337 3.30792665,16.0187607 C3.307485,13.9200376 3.23637936,13.3912788 3.71689448,12.931157 C3.94213595,12.7148659 4.21375066,12.643475 4.47189504,12.6771579 C3.92358665,12.2138585 3.1058718,12.1161991 2.50324047,12.694529 C1.78688428,13.3813222 1.87742252,14.1687406 1.88117654,17.2194837 C1.88139736,17.3122707 1.9595694,17.3874747 2.05629074,17.3874747 C5.23639108,17.3902287 6.05675583,17.4775078 6.77267037,16.7902909 C7.37596417,16.2121728 7.27416386,15.4268729 6.79055719,14.9015036 C6.82633083,15.1489356 6.75147117,15.4099255 6.52600888,15.6255811 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98610687,9.09684793 C5.36676512,8.28715003 5.8853922,7.31626431 6.56460595,6.29872478 C6.56460595,6.29872478 3.05816217,6.12404938 0.0454658406,9.5923512 C-0.0352798492,9.68565883 -0.00542430007,9.7993084 0.110831399,9.84485667 L4.07008434,11.3950456 C4.31842823,10.6392981 4.6255785,9.86254532 4.98610687,9.09684793 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.237897,0.374216236 C20.2211971,0.228259562 20.0811039,0.0938726253 19.9289497,0.0774080006 C18.1436894,-0.115495103 16.5026973,0.0613883657 15.0048136,0.505043254 C15.5125354,1.46510887 16.1814571,2.36621333 17.0176093,3.16786256 C17.8530657,3.96928929 18.7922003,4.61074217 19.7927996,5.09778357 C20.2552926,3.66113382 20.4396868,2.0867597 20.237897,0.374216236 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1588883,0.899608866 L13.8389414,1.01811955 C9.03340293,3.00219677 5.94684343,7.85831313 4.68900425,11.6615076 L6.08577368,13.0013729 L9.17912131,10.0342648 C9.3556125,9.86474676 9.64229756,9.86474676 9.81878876,10.0342648 C9.99550623,10.2037828 9.99550623,10.4783543 9.81878876,10.6478723 L6.7256674,13.6151975 L8.16226049,14.9934811 C12.1269768,13.786669 17.1895589,10.8262895 19.2579,6.2163107 L19.3812176,5.90961547 C18.2831255,5.38868939 17.2526885,4.69303601 16.3401385,3.81744609 C15.4264571,2.94142206 14.7019381,1.95274776 14.1588883,0.899608866 Z M14.7938041,8.06255956 C13.9984623,8.82549922 12.7096241,8.82549922 11.9142823,8.06234251 C11.1189406,7.2996199 11.1189406,6.06307161 11.9142823,5.30013195 C12.7096241,4.53740935 13.9984623,4.53740935 14.7938041,5.30013195 C15.5886933,6.06285456 15.5886933,7.29983695 14.7938041,8.06255956 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Rocket_1941065-Copy",
    transform: "translate(98.208589, 36.440678)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1485685,14.7082998 C10.3501353,15.0541545 9.54063838,15.3485867 8.75280793,15.5870398 L10.3690359,19.3853663 C10.4162873,19.4966733 10.5347615,19.5255307 10.6320302,19.4476375 C14.2480291,16.5577763 14.0654774,13.1942634 14.0654774,13.1942634 C13.0049718,13.8456158 11.9926397,14.3431345 11.1485685,14.7082998 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52600888,15.6255811 C6.0459354,16.0863384 5.49519794,16.018337 3.30792665,16.0187607 C3.307485,13.9200376 3.23637936,13.3912788 3.71689448,12.931157 C3.94213595,12.7148659 4.21375066,12.643475 4.47189504,12.6771579 C3.92358665,12.2138585 3.1058718,12.1161991 2.50324047,12.694529 C1.78688428,13.3813222 1.87742252,14.1687406 1.88117654,17.2194837 C1.88139736,17.3122707 1.9595694,17.3874747 2.05629074,17.3874747 C5.23639108,17.3902287 6.05675583,17.4775078 6.77267037,16.7902909 C7.37596417,16.2121728 7.27416386,15.4268729 6.79055719,14.9015036 C6.82633083,15.1489356 6.75147117,15.4099255 6.52600888,15.6255811 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98610687,9.09684793 C5.36676512,8.28715003 5.8853922,7.31626431 6.56460595,6.29872478 C6.56460595,6.29872478 3.05816217,6.12404938 0.0454658406,9.5923512 C-0.0352798492,9.68565883 -0.00542430007,9.7993084 0.110831399,9.84485667 L4.07008434,11.3950456 C4.31842823,10.6392981 4.6255785,9.86254532 4.98610687,9.09684793 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.237897,0.374216236 C20.2211971,0.228259562 20.0811039,0.0938726253 19.9289497,0.0774080006 C18.1436894,-0.115495103 16.5026973,0.0613883657 15.0048136,0.505043254 C15.5125354,1.46510887 16.1814571,2.36621333 17.0176093,3.16786256 C17.8530657,3.96928929 18.7922003,4.61074217 19.7927996,5.09778357 C20.2552926,3.66113382 20.4396868,2.0867597 20.237897,0.374216236 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1588883,0.899608866 L13.8389414,1.01811955 C9.03340293,3.00219677 5.94684343,7.85831313 4.68900425,11.6615076 L6.08577368,13.0013729 L9.17912131,10.0342648 C9.3556125,9.86474676 9.64229756,9.86474676 9.81878876,10.0342648 C9.99550623,10.2037828 9.99550623,10.4783543 9.81878876,10.6478723 L6.7256674,13.6151975 L8.16226049,14.9934811 C12.1269768,13.786669 17.1895589,10.8262895 19.2579,6.2163107 L19.3812176,5.90961547 C18.2831255,5.38868939 17.2526885,4.69303601 16.3401385,3.81744609 C15.4264571,2.94142206 14.7019381,1.95274776 14.1588883,0.899608866 Z M14.7938041,8.06255956 C13.9984623,8.82549922 12.7096241,8.82549922 11.9142823,8.06234251 C11.1189406,7.2996199 11.1189406,6.06307161 11.9142823,5.30013195 C12.7096241,4.53740935 13.9984623,4.53740935 14.7938041,5.30013195 C15.5886933,6.06285456 15.5886933,7.29983695 14.7938041,8.06255956 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy",
    transform: "translate(62.650307, 44.067797)",
    fill: "#2E5668"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 1.52542373 19.8773006 1.52542373 19.8773006 3.55932203 0 3.55932203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3",
    transform: "translate(21.368098, 2.542373) scale(1, -1) rotate(90.000000) translate(-21.368098, -2.542373) ",
    points: "21.3680982 1.05157534 23.910471 4.03317043 18.8257253 4.03317043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24_blue",
    transform: "translate(34.711656, 36.440678)",
    fill: "#2E5668",
    stroke: "#2E5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24_green"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 4.64083939,
    x2: 8.04294479,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 16.4538851,
    x2: 8.04294479,
    y2: 14.7663071,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 15.610096) scale(1, -1) translate(-5.926380, -15.610096) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 13.0787292,
    x2: 8.04294479,
    y2: 10.5473622,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 8.85978428,
    x2: 8.04294479,
    y2: 6.32841735,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 7.594101) scale(1, -1) translate(-5.926380, -7.594101) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 8.0159953,
    x2: 16.5092025,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(13.969325, 5.484628) scale(1, -1) translate(-13.969325, -5.484628) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 16.4538851,
    x2: 16.5092025,
    y2: 11.3911512,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 9.70357326,
    x2: 15.6625767,
    y2: 9.70357326,
    id: "Line-2",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 12.2349402,
    x2: 8.04294479,
    y2: 3.79705041,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 15.6100961,
    x2: 8.04294479,
    y2: 7.17220632,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.079755, 11.391151) scale(1, -1) translate(-5.079755, -11.391151) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 17.2976741,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 13.9225182,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 2.10947245,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 18.202454,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 5.48462837,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24_blue",
    transform: "translate(34.711656, 65.254237)",
    fill: "#2E5668",
    stroke: "#2E5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24_green"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 4.64083939,
    x2: 8.04294479,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 16.4538851,
    x2: 8.04294479,
    y2: 14.7663071,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 15.610096) scale(1, -1) translate(-5.926380, -15.610096) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 13.0787292,
    x2: 8.04294479,
    y2: 10.5473622,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80981595,
    y1: 8.85978428,
    x2: 8.04294479,
    y2: 6.32841735,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.926380, 7.594101) scale(1, -1) translate(-5.926380, -7.594101) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 8.0159953,
    x2: 16.5092025,
    y2: 2.95326143,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(13.969325, 5.484628) scale(1, -1) translate(-13.969325, -5.484628) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 16.4538851,
    x2: 16.5092025,
    y2: 11.3911512,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4294479,
    y1: 9.70357326,
    x2: 15.6625767,
    y2: 9.70357326,
    id: "Line-2",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 12.2349402,
    x2: 8.04294479,
    y2: 3.79705041,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11656442,
    y1: 15.6100961,
    x2: 8.04294479,
    y2: 7.17220632,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.079755, 11.391151) scale(1, -1) translate(-5.079755, -11.391151) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 17.2976741,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 13.9225182,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 2.10947245,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 18.202454,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fillRule: "nonzero",
    cx: 2.11656442,
    cy: 5.48462837,
    rx: 2.11656442,
    ry: 2.10947245
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.73619632,
    cy: 9.70357326,
    rx: 2.11656442,
    ry: 2.10947245
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dori_workflow_step4-copy",
    transform: "translate(637.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_mock_sample"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-45-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133,-2 L5,-2 C3.06700338,-2 1.31700338,-1.21649831 0.0502525317,0.0502525317 C-1.21649831,1.31700338 -2,3.06700338 -2,5 L-2,94.5024876 C-2,96.4354842 -1.21649831,98.1854842 0.0502525317,99.452235 C1.31700338,100.718986 3.06700338,101.502488 5,101.502488 L133,101.502488 C134.932997,101.502488 136.682997,100.718986 137.949747,99.452235 C139.216498,98.1854842 140,96.4354842 140,94.5024876 L140,5 C140,3.06700338 139.216498,1.31700338 137.949747,0.0502525317 C136.682997,-1.21649831 134.932997,-2 133,-2 Z",
    id: "Rectangle-10",
    stroke: "#2E5668",
    strokeWidth: 4,
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91727409,89.6679394 L133.082726,89.6679394 C135.798461,89.6679394 138,91.869478 138,94.5852135 C138,97.300949 135.798461,99.5024876 133.082726,99.5024876 L4.91727409,99.5024876 C2.2015386,99.5024876 3.32581678e-16,97.300949 0,94.5852135 C-3.32581678e-16,91.869478 2.2015386,89.6679394 4.91727409,89.6679394 Z",
    id: "Rectangle-10",
    fill: "#25829A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enter-Text",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 12,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 44.73,
    y: 102.049751
  }, "Monitor"))), /*#__PURE__*/React.createElement("g", {
    id: "dori_dashboard_benchmark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "benchmark_deploy_monitor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 138,
    height: 90.0497512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#151524",
    fillRule: "nonzero",
    x: 0,
    y: 17.4009181,
    width: 17.7407798,
    height: 72.6488331
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/dori/eval_targets",
    transform: "translate(4.217071, 62.498298)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/file/cloud_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-93"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-94)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.23498419,
    height: 5.22027543
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/hardware/devices_other_24px",
    transform: "translate(1.744995, 1.740092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-96",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-95"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-96)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 6.97997893,
    height: 6.96036725
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon/maps/category_24px",
    transform: "translate(4.217071, 49.447609)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-98",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-97"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-98)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/home_24px",
    transform: "translate(4.217071, 24.651301)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-99"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-100)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.72497366,
    height: 8.70045906
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24",
    transform: "translate(4.217071, 37.701989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 1.97651733,
    x2: 3.45363541,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 7.00765235,
    x2: 3.45363541,
    y2: 6.28891878,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 6.648286) scale(1, -1) translate(-2.544784, -6.648286) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 5.5701852,
    x2: 3.45363541,
    y2: 4.49208484,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.63593256,
    y1: 3.77335127,
    x2: 3.45363541,
    y2: 2.6952509,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.544784, 3.234301) scale(1, -1) translate(-2.544784, -3.234301) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 3.41398448,
    x2: 7.0890411,
    y2: 1.25778376,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(5.998419, 2.335884) scale(1, -1) translate(-5.998419, -2.335884) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 7.00765235,
    x2: 7.0890411,
    y2: 4.85145163,
    id: "Line",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90779768,
    y1: 4.13271805,
    x2: 6.72550053,
    y2: 4.13271805,
    id: "Line-2",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 5.21081841,
    x2: 3.45363541,
    y2: 1.61715054,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.908851423,
    y1: 6.64828556,
    x2: 3.45363541,
    y2: 3.05461769,
    id: "Line-3",
    stroke: "#2e5668",
    strokeLinecap: "square",
    fillRule: "nonzero",
    transform: "translate(2.181243, 4.851452) scale(1, -1) translate(-2.181243, -4.851452) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 7.36701914,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 5.92955199,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 0.898416968,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 7.81612223,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 0.908851423,
    cy: 2.33588412,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2e5668",
    fillRule: "nonzero",
    cx: 4.18071654,
    cy: 4.13271805,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#25829A",
    x: 0,
    y: 0,
    width: 17.7407798,
    height: 17.4009181
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    transform: "translate(4.944152, 75.548986)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Path",
    stroke: "#979797",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-140",
    fill: "#25829A",
    cx: 3.7081138,
    cy: 3.6976951,
    rx: 3.7081138,
    ry: 3.6976951
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px",
    transform: "translate(0.727081, 0.725038)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-102",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-101"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-102)",
    fill: "#2e5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 5.96206533,
    height: 5.94531369
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DoriIcon300_gray",
    transform: "translate(2.908325, 3.190168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ropesegment_gray"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.890541, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 6.168236) rotate(8.999732) translate(-9.917986, -6.168236) translate(8.848605, 4.975710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 6.826181) rotate(18.000102) translate(-9.750240, -6.826181) translate(8.680859, 5.633655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 7.443005) rotate(26.999884) translate(-9.498621, -7.443005) translate(8.429240, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 8.018707) rotate(36.000119) translate(-9.121192, -8.018707) translate(8.051811, 6.826181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.701827, 8.553287) rotate(45.000000) translate(-8.701827, -8.553287) translate(7.632446, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 8.964503) rotate(53.999881) translate(-8.156652, -8.964503) translate(7.087271, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 9.334597) rotate(63.000116) translate(-7.569541, -9.334597) translate(6.500160, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 9.581326) rotate(71.999898) translate(-6.940493, -9.581326) translate(5.871112, 8.388801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 9.745813) rotate(81.000268) translate(-6.269509, -9.745813) translate(5.200128, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.598525, 9.786934) rotate(90.000000) translate(-5.598525, -9.786934) translate(4.529144, 8.594409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 9.745813) rotate(98.999732) translate(-4.885604, -9.745813) translate(3.816223, 8.553287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.256556, 9.622448) rotate(108.000102) translate(-4.256556, -9.622448) translate(3.187175, 8.429922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.627509, 9.334597) rotate(116.999884) translate(-3.627509, -9.334597) translate(2.558127, 8.142071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 8.964503) rotate(126.000119) translate(-2.998461, -8.964503) translate(1.929080, 7.771977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.495223, 8.553287) rotate(135.000000) translate(-2.495223, -8.553287) translate(1.425842, 7.360762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 8.059828) rotate(143.999881) translate(-2.075857, -8.059828) translate(1.006476, 6.867303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.698429, 7.443005) rotate(153.000116) translate(-1.698429, -7.443005) translate(0.629048, 6.250479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 6.867303) rotate(161.999898) translate(-1.404873, -6.867303) translate(0.335492, 5.674777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 6.209357) rotate(171.000268) translate(-1.279064, -6.209357) translate(0.209683, 5.016832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.195191, 5.510291) rotate(-180.000000) translate(-1.195191, -5.510291) translate(0.125810, 4.317765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.279064, 4.852346) rotate(-171.000268) translate(-1.279064, -4.852346) translate(0.209683, 3.659820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.404873, 4.194400) rotate(-161.999898) translate(-1.404873, -4.194400) translate(0.335492, 3.001875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.656492, 3.577577) rotate(-153.000116) translate(-1.656492, -3.577577) translate(0.587111, 2.385051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075857, 3.001875) rotate(-143.999881) translate(-2.075857, -3.001875) translate(1.006476, 1.809349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.453286, 2.467294) rotate(-135.000000) translate(-2.453286, -2.467294) translate(1.383905, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.998461, 2.056079) rotate(-126.000119) translate(-2.998461, -2.056079) translate(1.929080, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.585572, 1.685984) rotate(-116.999884) translate(-3.585572, -1.685984) translate(2.516191, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.214620, 1.439255) rotate(-108.000102) translate(-4.214620, -1.439255) translate(3.145239, 0.246729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.885604, 1.274769) rotate(-98.999732) translate(-4.885604, -1.274769) translate(3.816223, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.556588, 1.233647) rotate(-90.000000) translate(-5.556588, -1.233647) translate(4.487207, 0.041122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.269509, 1.274769) rotate(-81.000268) translate(-6.269509, -1.274769) translate(5.200128, 0.082243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.940493, 1.398133) rotate(-71.999898) translate(-6.940493, -1.398133) translate(5.871112, 0.205608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.569541, 1.685984) rotate(-63.000116) translate(-7.569541, -1.685984) translate(6.500160, 0.493459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.156652, 2.056079) rotate(-53.999881) translate(-8.156652, -2.056079) translate(7.087271, 0.863553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.659890, 2.467294) rotate(-45.000000) translate(-8.659890, -2.467294) translate(7.590509, 1.274769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.121192, 2.960753) rotate(-36.000119) translate(-9.121192, -2.960753) translate(8.051811, 1.768228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.498621, 3.536455) rotate(-26.999884) translate(-9.498621, -3.536455) translate(8.429240, 2.343930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750240, 4.153279) rotate(-18.000102) translate(-9.750240, -4.153279) translate(8.680859, 2.960753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.917986, 4.811224) rotate(-8.999732) translate(-9.917986, -4.811224) translate(8.848605, 3.618698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.016382, 0.013820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00910111604,2.35897168 C0.00910111604,2.35897168 -0.103950672,1.83403751 0.947926741,0.974482888 C1.84800436,0.238973216 1.92079054,-0.00695454186 1.93141609,0.0228028728 C2.24301555,0.894683978 2.26349306,0.812633758 0.898166389,1.65415561 C0.100362557,2.14587739 0.00910111604,2.35897168 0.00910111604,2.35897168 L0.00910111604,2.35897168 Z",
    id: "Shape",
    fill: "url(#radialGradient-13)"
  }))))))))))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2-Copy-3",
    fill: "#2E5668",
    points: "27.0920245 45.7627119 126.993865 45.7627119 126.993865 46.6101695 27.0920245 46.6101695"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(27.092025, 16.949153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_report_2223105",
    transform: "translate(38.493252, 0.000000)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99824715,16.3861335 C6.56336547,16.3861335 3.75740578,13.5547658 3.75740578,10.0887813 C3.75740578,9.24262543 3.91866784,8.44528626 4.22506573,7.69676378 L0.967572305,5.93936317 C0.403155127,7.20859694 0.0806310254,8.60800854 0.0806310254,10.0887813 C0.0806310254,15.6050665 4.53146363,20.0962014 9.99824715,20.0962014 C11.8850131,20.0962014 13.6427695,19.5592179 15.1263804,18.6479731 L12.9170903,15.6538832 C12.0462752,16.1257778 11.0464505,16.3861335 9.99824715,16.3861335 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99824715,3.79142909 C11.2077125,3.79142909 12.3365469,4.14941811 13.3041192,4.75149054 L16.0455741,2.16420631 C14.3684487,0.862428077 12.2720421,0.0813611393 9.99824715,0.0813611393 C6.61174408,0.0813611393 3.61226994,1.80621729 1.82226117,4.42604598 L5.09588081,6.19971882 C6.24084137,4.73521831 8.01472393,3.79142909 9.99824715,3.79142909 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3195443,3.35207894 L14.626468,5.87427426 C15.6262927,6.99705798 16.2390885,8.47783072 16.2390885,10.0887813 C16.2390885,11.8787263 15.4972831,13.4896769 14.3039439,14.6450051 L16.513234,17.6228228 C18.5935145,15.784061 19.8997371,13.0991434 19.8997371,10.0887813 C19.9158633,7.48522482 18.9321648,5.12575178 17.3195443,3.35207894 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "8.15985977 13.4896769 8.15985977 10.1213257 6.30534619 11.1302039 6.30534619 13.4896769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9.07905346 13.4896769 10.9174408 13.4896769 10.9174408 6.68788565 9.07905346 7.69676378"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.8366345 9.99114791 11.8366345 10.3328647 11.8366345 10.9837538 11.8366345 11.3254706 11.8366345 11.9763597 11.8366345 12.3180765 11.8366345 12.9689656 11.8366345 13.3106824 11.8366345 13.4896769 13.6911481 13.4896769 13.6911481 12.2204431 13.6911481 11.8787263 13.6911481 11.2278372 13.6911481 10.8861204 13.6911481 10.2352313 13.6911481 9.87724231 13.6911481 9.24262543 13.6911481 8.88463641 13.6911481 7.89203051 11.8366345 8.88463641"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(63.488869, 2.017756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 9.99807187,
    height: 10.0976594
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(1.319769, 1.331719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-104",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-103"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-104)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.55031283,
    height: 8.65617433
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(5.499036, 5.548830)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 9.99807187,
    height: 10.0976594
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(1.319769, 1.331719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-106",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-105"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-106)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.55031283,
    height: 8.65617433
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Pie-Chart_1721475",
    transform: "translate(84.985101, 0.000000)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6146797,4.16808361 L13.1266931,4.16808361 C13.4155626,4.16808361 13.6497821,4.40442345 13.6497821,4.69590868 L13.6497821,9.21787541 C13.6497821,9.51198677 13.4155626,9.74832712 13.1266931,9.74832712 L11.6146797,9.74832712 C11.3232076,9.74832712 11.0889891,9.51198677 11.0889891,9.21787541 L11.0889891,4.69590868 C11.0889891,4.40442345 11.3232076,4.16808361 11.6146797,4.16808361 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5944648,2.15919616 L16.1064782,2.15919616 C16.3953467,2.15919616 16.6295662,2.3955355 16.6295662,2.68702123 L16.6295662,9.21787541 C16.6295662,9.51198677 16.3953467,9.74832712 16.1064782,9.74832712 L14.5944648,9.74832712 C14.3055943,9.74832712 14.0687732,9.51198677 14.0687732,9.21787541 L14.0687732,2.68702123 C14.0687732,2.3955355 14.3055943,2.15919616 14.5944648,2.15919616 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6315015,0.0321385561 L19.1435149,0.0321385561 C19.434987,0.0321385561 19.6692065,0.268478399 19.6692065,0.559963866 L19.6692065,9.21787514 C19.6692065,9.51198651 19.434987,9.74832686 19.1435149,9.74832686 L17.6315015,9.74832686 C17.342633,9.74832686 17.1084135,9.51198651 17.1084135,9.21787514 L17.1084135,0.559963866 C17.1084135,0.268478399 17.342633,0.0321385561 17.6315015,0.0321385561 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0303403,17.7418607 C18.7141135,16.0428409 19.794124,13.7398416 19.9268481,11.182121 L10.006377,11.182121 C9.71750753,11.182121 9.48328804,10.9457817 9.48328804,10.6542955 L9.48328804,0.646621904 C0.942107465,1.09304121 -3.09426426,11.6075322 2.98501636,17.7418607 C6.8626399,21.6545971 13.1527178,21.6545971 17.0303403,17.7418607 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24_blue",
    transform: "translate(0.000000, 0.504439)",
    fill: "#2E5668",
    stroke: "#2E5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24_green"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 4.62402475,
    x2: 7.915279,
    y2: 2.94256121,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 16.3942696,
    x2: 7.915279,
    y2: 14.712806,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.832311, 15.553538) scale(1, -1) translate(-5.832311, -15.553538) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 13.0313425,
    x2: 7.915279,
    y2: 10.5091472,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 8.82768362,
    x2: 7.915279,
    y2: 6.3054883,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.832311, 7.566586) scale(1, -1) translate(-5.832311, -7.566586) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 7.98695184,
    x2: 16.2471516,
    y2: 2.94256121,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(13.747590, 5.464757) scale(1, -1) translate(-13.747590, -5.464757) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 16.3942696,
    x2: 16.2471516,
    y2: 11.3498789,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 9.66841539,
    x2: 15.4139644,
    y2: 9.66841539,
    id: "Line-2",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.08296816,
    y1: 12.1906107,
    x2: 7.915279,
    y2: 3.78329298,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.08296816,
    y1: 15.5535378,
    x2: 7.915279,
    y2: 7.14622007,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(4.999124, 11.349879) scale(1, -1) translate(-4.999124, -11.349879) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 17.2350013,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fillRule: "nonzero",
    cx: 2.08296816,
    cy: 13.8720743,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 2.10182943,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 17.9135261,
    cy: 9.66841539,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fillRule: "nonzero",
    cx: 2.08296816,
    cy: 5.46475652,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 9.66841539,
    rx: 2.08296816,
    ry: 2.10182943
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy",
    transform: "translate(24.995618, 7.566586)",
    fill: "#2E5668"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 1.51331719 5.49903593 1.51331719 5.49903593 3.53107345 0 3.53107345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3",
    transform: "translate(6.998773, 2.522195) scale(1, -1) rotate(90.000000) translate(-6.998773, -2.522195) ",
    points: "6.99877301 1.02245825 9.52096832 4.02193239 4.47657769 4.02193239"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy",
    transform: "translate(27.092025, 54.237288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_report_2223105",
    transform: "translate(38.493252, 0.000000)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99824715,16.3861335 C6.56336547,16.3861335 3.75740578,13.5547658 3.75740578,10.0887813 C3.75740578,9.24262543 3.91866784,8.44528626 4.22506573,7.69676378 L0.967572305,5.93936317 C0.403155127,7.20859694 0.0806310254,8.60800854 0.0806310254,10.0887813 C0.0806310254,15.6050665 4.53146363,20.0962014 9.99824715,20.0962014 C11.8850131,20.0962014 13.6427695,19.5592179 15.1263804,18.6479731 L12.9170903,15.6538832 C12.0462752,16.1257778 11.0464505,16.3861335 9.99824715,16.3861335 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99824715,3.79142909 C11.2077125,3.79142909 12.3365469,4.14941811 13.3041192,4.75149054 L16.0455741,2.16420631 C14.3684487,0.862428077 12.2720421,0.0813611393 9.99824715,0.0813611393 C6.61174408,0.0813611393 3.61226994,1.80621729 1.82226117,4.42604598 L5.09588081,6.19971882 C6.24084137,4.73521831 8.01472393,3.79142909 9.99824715,3.79142909 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3195443,3.35207894 L14.626468,5.87427426 C15.6262927,6.99705798 16.2390885,8.47783072 16.2390885,10.0887813 C16.2390885,11.8787263 15.4972831,13.4896769 14.3039439,14.6450051 L16.513234,17.6228228 C18.5935145,15.784061 19.8997371,13.0991434 19.8997371,10.0887813 C19.9158633,7.48522482 18.9321648,5.12575178 17.3195443,3.35207894 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "8.15985977 13.4896769 8.15985977 10.1213257 6.30534619 11.1302039 6.30534619 13.4896769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9.07905346 13.4896769 10.9174408 13.4896769 10.9174408 6.68788565 9.07905346 7.69676378"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.8366345 9.99114791 11.8366345 10.3328647 11.8366345 10.9837538 11.8366345 11.3254706 11.8366345 11.9763597 11.8366345 12.3180765 11.8366345 12.9689656 11.8366345 13.3106824 11.8366345 13.4896769 13.6911481 13.4896769 13.6911481 12.2204431 13.6911481 11.8787263 13.6911481 11.2278372 13.6911481 10.8861204 13.6911481 10.2352313 13.6911481 9.87724231 13.6911481 9.24262543 13.6911481 8.88463641 13.6911481 7.89203051 11.8366345 8.88463641"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(63.488869, 2.017756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 9.99807187,
    height: 10.0976594
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(1.319769, 1.331719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-108",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-107"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-108)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.55031283,
    height: 8.65617433
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(5.499036, 5.548830)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#2E5668",
    fill: "#2e5668",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 9.99807187,
    height: 10.0976594
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/image/broken_image_24px",
    transform: "translate(1.319769, 1.331719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-110",
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-109"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Primary-or-Secondary",
    mask: "url(#mask-110)",
    fill: "#2E5668",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 8.55031283,
    height: 8.65617433
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Pie-Chart_1721475",
    transform: "translate(84.985101, 0.000000)",
    fill: "#2E5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6146797,4.16808361 L13.1266931,4.16808361 C13.4155626,4.16808361 13.6497821,4.40442345 13.6497821,4.69590868 L13.6497821,9.21787541 C13.6497821,9.51198677 13.4155626,9.74832712 13.1266931,9.74832712 L11.6146797,9.74832712 C11.3232076,9.74832712 11.0889891,9.51198677 11.0889891,9.21787541 L11.0889891,4.69590868 C11.0889891,4.40442345 11.3232076,4.16808361 11.6146797,4.16808361 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5944648,2.15919616 L16.1064782,2.15919616 C16.3953467,2.15919616 16.6295662,2.3955355 16.6295662,2.68702123 L16.6295662,9.21787541 C16.6295662,9.51198677 16.3953467,9.74832712 16.1064782,9.74832712 L14.5944648,9.74832712 C14.3055943,9.74832712 14.0687732,9.51198677 14.0687732,9.21787541 L14.0687732,2.68702123 C14.0687732,2.3955355 14.3055943,2.15919616 14.5944648,2.15919616 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6315015,0.0321385561 L19.1435149,0.0321385561 C19.434987,0.0321385561 19.6692065,0.268478399 19.6692065,0.559963866 L19.6692065,9.21787514 C19.6692065,9.51198651 19.434987,9.74832686 19.1435149,9.74832686 L17.6315015,9.74832686 C17.342633,9.74832686 17.1084135,9.51198651 17.1084135,9.21787514 L17.1084135,0.559963866 C17.1084135,0.268478399 17.342633,0.0321385561 17.6315015,0.0321385561 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0303403,17.7418607 C18.7141135,16.0428409 19.794124,13.7398416 19.9268481,11.182121 L10.006377,11.182121 C9.71750753,11.182121 9.48328804,10.9457817 9.48328804,10.6542955 L9.48328804,0.646621904 C0.942107465,1.09304121 -3.09426426,11.6075322 2.98501636,17.7418607 C6.8626399,21.6545971 13.1527178,21.6545971 17.0303403,17.7418607 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/neural_network_24_blue",
    transform: "translate(0.000000, 0.504439)",
    fill: "#2E5668",
    stroke: "#2E5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neural_network_24_green"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 4.62402475,
    x2: 7.915279,
    y2: 2.94256121,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 16.3942696,
    x2: 7.915279,
    y2: 14.712806,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.832311, 15.553538) scale(1, -1) translate(-5.832311, -15.553538) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 13.0313425,
    x2: 7.915279,
    y2: 10.5091472,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.74934268,
    y1: 8.82768362,
    x2: 7.915279,
    y2: 6.3054883,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(5.832311, 7.566586) scale(1, -1) translate(-5.832311, -7.566586) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 7.98695184,
    x2: 16.2471516,
    y2: 2.94256121,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(13.747590, 5.464757) scale(1, -1) translate(-13.747590, -5.464757) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 16.3942696,
    x2: 16.2471516,
    y2: 11.3498789,
    id: "Line",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.248028,
    y1: 9.66841539,
    x2: 15.4139644,
    y2: 9.66841539,
    id: "Line-2",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.08296816,
    y1: 12.1906107,
    x2: 7.915279,
    y2: 3.78329298,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.08296816,
    y1: 15.5535378,
    x2: 7.915279,
    y2: 7.14622007,
    id: "Line-3",
    strokeWidth: 4,
    fillRule: "nonzero",
    strokeLinecap: "square",
    transform: "translate(4.999124, 11.349879) scale(1, -1) translate(-4.999124, -11.349879) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 17.2350013,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fillRule: "nonzero",
    cx: 2.08296816,
    cy: 13.8720743,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 2.10182943,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 17.9135261,
    cy: 9.66841539,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy-2",
    fillRule: "nonzero",
    cx: 2.08296816,
    cy: 5.46475652,
    rx: 2.08296816,
    ry: 2.10182943
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fillRule: "nonzero",
    cx: 9.58165352,
    cy: 9.66841539,
    rx: 2.08296816,
    ry: 2.10182943
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy",
    transform: "translate(24.995618, 7.566586)",
    fill: "#2E5668"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 1.51331719 5.49903593 1.51331719 5.49903593 3.53107345 0 3.53107345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-3",
    transform: "translate(6.998773, 2.522195) scale(1, -1) rotate(90.000000) translate(-6.998773, -2.522195) ",
    points: "6.99877301 1.02245825 9.52096832 4.02193239 4.47657769 4.02193239"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon/infinity_blue",
    transform: "translate(155.000000, 41.000000)",
    fill: "#2e5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819516,2.78370341 C35.5254952,0.989740285 33.1901594,0 30.7082602,0 C28.2254392,0 25.8905643,0.989740285 24.1341078,2.78370341 L13.4294484,13.7198156 C12.3260748,14.8465751 10.8604407,15.4652805 9.29894125,15.4652805 C7.74205071,15.4652805 6.27595574,14.8465751 5.17304305,13.7151071 C4.06598234,12.5930561 3.46037128,11.091024 3.46037128,9.5 C3.46037128,7.90944687 4.06598234,6.4111816 5.17304305,5.28018438 C6.27595574,4.15342486 7.74205071,3.53471947 9.29894125,3.53471947 C10.8604407,3.53471947 12.3265357,4.152954 13.4294484,5.28018438 L15.9472971,7.85294409 L18.2337784,7.63635012 L18.3914032,5.35646312 L15.8730936,2.78370341 C14.1170981,0.989740285 11.7817622,0 9.29894125,0 C6.81658114,0 4.48078444,0.989740285 2.72478889,2.78370341 C0.968793344,4.57766653 0,6.96349623 0,9.5 C0,12.0365038 0.968793344,14.4213918 2.72478889,16.2167674 C4.48078444,18.0107306 6.81612025,19 9.29894125,19 C11.7817622,19 14.1170981,18.0102597 15.8730936,16.2167674 L26.5777531,5.28018438 C27.6811266,4.15342486 29.1467607,3.53471947 30.7087211,3.53471947 C32.2656116,3.53471947 33.7321675,4.152954 34.8346193,5.28018438 C37.1132655,7.60856959 37.1132655,11.3914304 34.8346193,13.7198156 C33.7317066,14.8465751 32.2656116,15.4652805 30.7087211,15.4652805 C29.1467607,15.4652805 27.6811266,14.8465751 26.5777531,13.7198156 L23.6921131,10.7713125 L23.5344883,13.0511994 L21.248007,13.2677934 L21.2272669,13.2466049 L21.2272669,13.2470757 L24.1345687,16.2167674 C25.8905643,18.0107306 28.2259001,19 30.7087211,19 C33.1906203,19 35.5259561,18.0102597 37.2824125,16.2167674 C40.9059393,12.5130105 40.9059393,6.48651864 37.2819516,2.78370341 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Infinity_201526-Copy",
    transform: "translate(368.000000, 41.000000)",
    fill: "#2e5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819516,2.78370341 C35.5254952,0.989740285 33.1901594,0 30.7082602,0 C28.2254392,0 25.8905643,0.989740285 24.1341078,2.78370341 L13.4294484,13.7198156 C12.3260748,14.8465751 10.8604407,15.4652805 9.29894125,15.4652805 C7.74205071,15.4652805 6.27595574,14.8465751 5.17304305,13.7151071 C4.06598234,12.5930561 3.46037128,11.091024 3.46037128,9.5 C3.46037128,7.90944687 4.06598234,6.4111816 5.17304305,5.28018438 C6.27595574,4.15342486 7.74205071,3.53471947 9.29894125,3.53471947 C10.8604407,3.53471947 12.3265357,4.152954 13.4294484,5.28018438 L15.9472971,7.85294409 L18.2337784,7.63635012 L18.3914032,5.35646312 L15.8730936,2.78370341 C14.1170981,0.989740285 11.7817622,0 9.29894125,0 C6.81658114,0 4.48078444,0.989740285 2.72478889,2.78370341 C0.968793344,4.57766653 0,6.96349623 0,9.5 C0,12.0365038 0.968793344,14.4213918 2.72478889,16.2167674 C4.48078444,18.0107306 6.81612025,19 9.29894125,19 C11.7817622,19 14.1170981,18.0102597 15.8730936,16.2167674 L26.5777531,5.28018438 C27.6811266,4.15342486 29.1467607,3.53471947 30.7087211,3.53471947 C32.2656116,3.53471947 33.7321675,4.152954 34.8346193,5.28018438 C37.1132655,7.60856959 37.1132655,11.3914304 34.8346193,13.7198156 C33.7317066,14.8465751 32.2656116,15.4652805 30.7087211,15.4652805 C29.1467607,15.4652805 27.6811266,14.8465751 26.5777531,13.7198156 L23.6921131,10.7713125 L23.5344883,13.0511994 L21.248007,13.2677934 L21.2272669,13.2466049 L21.2272669,13.2470757 L24.1345687,16.2167674 C25.8905643,18.0107306 28.2259001,19 30.7087211,19 C33.1906203,19 35.5259561,18.0102597 37.2824125,16.2167674 C40.9059393,12.5130105 40.9059393,6.48651864 37.2819516,2.78370341 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Infinity_201526-Copy-2",
    transform: "translate(580.000000, 41.000000)",
    fill: "#2e5668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819516,2.78370341 C35.5254952,0.989740285 33.1901594,0 30.7082602,0 C28.2254392,0 25.8905643,0.989740285 24.1341078,2.78370341 L13.4294484,13.7198156 C12.3260748,14.8465751 10.8604407,15.4652805 9.29894125,15.4652805 C7.74205071,15.4652805 6.27595574,14.8465751 5.17304305,13.7151071 C4.06598234,12.5930561 3.46037128,11.091024 3.46037128,9.5 C3.46037128,7.90944687 4.06598234,6.4111816 5.17304305,5.28018438 C6.27595574,4.15342486 7.74205071,3.53471947 9.29894125,3.53471947 C10.8604407,3.53471947 12.3265357,4.152954 13.4294484,5.28018438 L15.9472971,7.85294409 L18.2337784,7.63635012 L18.3914032,5.35646312 L15.8730936,2.78370341 C14.1170981,0.989740285 11.7817622,0 9.29894125,0 C6.81658114,0 4.48078444,0.989740285 2.72478889,2.78370341 C0.968793344,4.57766653 0,6.96349623 0,9.5 C0,12.0365038 0.968793344,14.4213918 2.72478889,16.2167674 C4.48078444,18.0107306 6.81612025,19 9.29894125,19 C11.7817622,19 14.1170981,18.0102597 15.8730936,16.2167674 L26.5777531,5.28018438 C27.6811266,4.15342486 29.1467607,3.53471947 30.7087211,3.53471947 C32.2656116,3.53471947 33.7321675,4.152954 34.8346193,5.28018438 C37.1132655,7.60856959 37.1132655,11.3914304 34.8346193,13.7198156 C33.7317066,14.8465751 32.2656116,15.4652805 30.7087211,15.4652805 C29.1467607,15.4652805 27.6811266,14.8465751 26.5777531,13.7198156 L23.6921131,10.7713125 L23.5344883,13.0511994 L21.248007,13.2677934 L21.2272669,13.2466049 L21.2272669,13.2470757 L24.1345687,16.2167674 C25.8905643,18.0107306 28.2259001,19 30.7087211,19 C33.1906203,19 35.5259561,18.0102597 37.2824125,16.2167674 C40.9059393,12.5130105 40.9059393,6.48651864 37.2819516,2.78370341 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "DEPLOYMENT-MONITOR",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 28,
    fontWeight: 500,
    fill: "#2e5668"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 816
  }, "DEPLOYMENT MONITOR")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoriArchStack);
export default __webpack_public_path__ + "static/media/dori_arch_stack.06036424811c17862b9990a446dc14e7.svg";
export { ForwardRef as ReactComponent };